export const municipiosLocalidades = [
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 1,
    "localidad": "Acatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 2,
    "localidad": "Colonia Agustín Olvera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 3,
    "localidad": "Alcholoya (El Salto de Alcholoya)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 4,
    "localidad": "Almoloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 5,
    "localidad": "Los Arcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 6,
    "localidad": "Colonia Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 7,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 8,
    "localidad": "Colonia Chautenco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 10,
    "localidad": "Encinillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 11,
    "localidad": "Hueyotlipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 12,
    "localidad": "El Huizache y la Paloma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 13,
    "localidad": "Loma Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 15,
    "localidad": "Metepec Primero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 16,
    "localidad": "El Milagro San Simón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 17,
    "localidad": "Mixquiapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 18,
    "localidad": "La Peñuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 19,
    "localidad": "San Antonio la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 20,
    "localidad": "San Bartolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 21,
    "localidad": "San Dionisio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 22,
    "localidad": "San Pablo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 23,
    "localidad": "Totoapa el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 24,
    "localidad": "Totoapita Canutillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 25,
    "localidad": "Totoapita la Herradura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 26,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 27,
    "localidad": "Colonia 28 de Mayo (Santa Rosa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 28,
    "localidad": "El Veladero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 29,
    "localidad": "Vicente Guerrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 30,
    "localidad": "Las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 31,
    "localidad": "Metepec Segundo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 32,
    "localidad": "Barrio el Yolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 33,
    "localidad": "El Chilar (La Barranca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 34,
    "localidad": "El Fortin"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 36,
    "localidad": "Lagunicatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 38,
    "localidad": "Loma Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 39,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 40,
    "localidad": "Hacienda el Lucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 41,
    "localidad": "Los Migueles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 42,
    "localidad": "Piedra Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 43,
    "localidad": "El Sabino (La Barranca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 47,
    "localidad": "La Calera (Los Baños)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 48,
    "localidad": "La Chamusquina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 49,
    "localidad": "La Luz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 50,
    "localidad": "Majadillas (La Venta)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 51,
    "localidad": "El Transformador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 52,
    "localidad": "Zupitlán (Los Pocitos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 53,
    "localidad": "Cerro de Aguatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 55,
    "localidad": "Colonia Echeverría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 56,
    "localidad": "Rancho Alicia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 57,
    "localidad": "El Rosario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 58,
    "localidad": "Rancho Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 59,
    "localidad": "Ampliación Hueyotlipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 61,
    "localidad": "Ejido Alcholoya (Colonia del Cerro de Aguatepec)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 62,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 1,
    "municipio": "Acatlán",
    "claveLocalidad": 64,
    "localidad": "Colonia Ernesto Zedillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 1,
    "localidad": "Acaxochitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 2,
    "localidad": "Apapaxtla (Altamira)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 3,
    "localidad": "La Bóveda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 4,
    "localidad": "Cuaunepantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 5,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 6,
    "localidad": "Ojo de Agua las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 7,
    "localidad": "Los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 8,
    "localidad": "San Francisco Atotonilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 9,
    "localidad": "San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 10,
    "localidad": "San Mateo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 11,
    "localidad": "San Miguel del Resgate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 12,
    "localidad": "San Pedro Tlachichilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 13,
    "localidad": "Santa Ana Tzacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 14,
    "localidad": "Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 15,
    "localidad": "Techachalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 16,
    "localidad": "Tepepa (Santiago Tepepa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 17,
    "localidad": "Tlacpac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 18,
    "localidad": "Venta Quemada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 20,
    "localidad": "Ejido de Tlatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 21,
    "localidad": "Tlamimilolpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 24,
    "localidad": "Toxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 25,
    "localidad": "Yemila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 26,
    "localidad": "Zacacuautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 27,
    "localidad": "Canales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 28,
    "localidad": "Chimalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 29,
    "localidad": "Montemar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 30,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 31,
    "localidad": "El Tejocotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 32,
    "localidad": "Zotictla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 34,
    "localidad": "San Martín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 36,
    "localidad": "Ejido Techachalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 37,
    "localidad": "El Bado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 39,
    "localidad": "Coyametepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 40,
    "localidad": "Loma Linda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 41,
    "localidad": "San Fernando"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 42,
    "localidad": "Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 43,
    "localidad": "Tlacuilolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 44,
    "localidad": "Barrio Tlatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 45,
    "localidad": "Barrio Tlatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 46,
    "localidad": "Alpinagua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 47,
    "localidad": "Atezcapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 48,
    "localidad": "Barrio Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 49,
    "localidad": "Ejido de Tepepa (Barrio Santa Félix)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 50,
    "localidad": "Ocotenco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 51,
    "localidad": "Parada 170"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 52,
    "localidad": "El Valle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 53,
    "localidad": "Barrio Cuautenco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 54,
    "localidad": "Ejido de Tlamimilolpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 55,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 56,
    "localidad": "Paredones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 57,
    "localidad": "Apopoalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 58,
    "localidad": "Barrio el Puente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 59,
    "localidad": "El Crucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 60,
    "localidad": "Necaxanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 61,
    "localidad": "Loma Bonita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 62,
    "localidad": "Nuevo San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 63,
    "localidad": "Agua Chiquila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 64,
    "localidad": "Capoltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 65,
    "localidad": "La Cumbre de Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 66,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 67,
    "localidad": "Meztolotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 2,
    "municipio": "Acaxochitlán",
    "claveLocalidad": 68,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 1,
    "localidad": "Actopan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 2,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 3,
    "localidad": "Bothi Bají"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 4,
    "localidad": "Boxaxni"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 5,
    "localidad": "El Boxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 6,
    "localidad": "San Diego Canguihuindo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 7,
    "localidad": "Cañada Chica Antigua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 9,
    "localidad": "Colonia Cuauhtémoc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 10,
    "localidad": "Chicavasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 11,
    "localidad": "Dajiedhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 12,
    "localidad": "El Daxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 13,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 14,
    "localidad": "El Huaxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 15,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 16,
    "localidad": "Santa María Magdalena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 17,
    "localidad": "Las Mecas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 18,
    "localidad": "Mesa Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 19,
    "localidad": "El Palomo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 20,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 21,
    "localidad": "Plomosas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 23,
    "localidad": "San Andrés Tianguistengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 24,
    "localidad": "Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 25,
    "localidad": "La Quinta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 26,
    "localidad": "Xideje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 27,
    "localidad": "La Escoba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 28,
    "localidad": "Rancho Osorios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 35,
    "localidad": "El Senthé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 37,
    "localidad": "La Segunda Manzana de Magdalena (El Arco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 38,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 39,
    "localidad": "La Ardilla (Tierras Coloradas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 40,
    "localidad": "Casa Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 41,
    "localidad": "San Pedrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 43,
    "localidad": "Segunda Manzana Chicavasco (El Pozo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 44,
    "localidad": "Cuarta Manzana Chicavasco (La Ladera Chicavasco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 45,
    "localidad": "Dos Cerritos (Unidad Deportiva)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 46,
    "localidad": "Francisco Constancio Azpeitia García"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 47,
    "localidad": "El Apartadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 48,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 3,
    "municipio": "Actopan",
    "claveLocalidad": 49,
    "localidad": "Manzana de Golondrinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 1,
    "localidad": "Agua Blanca Iturbide"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 2,
    "localidad": "Ejido de Agua Blanca (Cerro Alto)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 3,
    "localidad": "Ejido de Calabazas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 4,
    "localidad": "Calabazas Primera Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 5,
    "localidad": "Calabazas Segunda Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 6,
    "localidad": "Ejido de los Cubes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 7,
    "localidad": "Los Cubes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 8,
    "localidad": "Chichicaxtle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 9,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 10,
    "localidad": "Ejido de Palizar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 11,
    "localidad": "Ejido Milpa Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 12,
    "localidad": "Milpa Vieja (Apulco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 13,
    "localidad": "El Palizar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 14,
    "localidad": "Ejido de Loma Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 15,
    "localidad": "Plan Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 16,
    "localidad": "Potrero de Monroy"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 17,
    "localidad": "El Remudadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 18,
    "localidad": "Ejido Rosa de Castilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 19,
    "localidad": "Rosa de Castilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 20,
    "localidad": "San Cornelio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 21,
    "localidad": "San Martín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 22,
    "localidad": "San Pedrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 23,
    "localidad": "Tetetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 24,
    "localidad": "El Xúchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 25,
    "localidad": "Sabanillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 28,
    "localidad": "Colonia el Vivero (El Pujido)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 29,
    "localidad": "Puerto Lobo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 31,
    "localidad": "Ejido San Pedrito (Potrerillos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 4,
    "municipio": "Agua Blanca de Iturbide",
    "claveLocalidad": 32,
    "localidad": "Rancho la Torre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 1,
    "localidad": "Ajacuba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 2,
    "localidad": "Emiliano Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 3,
    "localidad": "Vicente Guerrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 4,
    "localidad": "Ignacio Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 5,
    "localidad": "Santiago Tezontlale"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 6,
    "localidad": "San Nicolás Tecomatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 7,
    "localidad": "Tulancalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 8,
    "localidad": "Colonia el Santo Niño"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 9,
    "localidad": "El Gorrión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 14,
    "localidad": "La Concepción (El Mezquite)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 15,
    "localidad": "Santa Bárbara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 34,
    "localidad": "Las Huertas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 35,
    "localidad": "Barrio el Rincón Sur"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 36,
    "localidad": "Los Cruces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 37,
    "localidad": "El Cerrito de las Colmenas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 38,
    "localidad": "El Pozo de Agua Potable de Ajacuba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 39,
    "localidad": "Nuevo Venero (Cuernavaca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 40,
    "localidad": "Presa Nueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 41,
    "localidad": "El Pico del Angel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 42,
    "localidad": "El Tumba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 5,
    "municipio": "Ajacuba",
    "claveLocalidad": 43,
    "localidad": "Los Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 1,
    "localidad": "Alfajayucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 2,
    "localidad": "Arias"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 3,
    "localidad": "Baxthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 4,
    "localidad": "Boxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 5,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 6,
    "localidad": "Cebolletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 7,
    "localidad": "Cerro Azul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 8,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 9,
    "localidad": "Deca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 10,
    "localidad": "Donguiño"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 11,
    "localidad": "Tercera Manzana la Ladera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 12,
    "localidad": "El Espíritu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 13,
    "localidad": "Golondrinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 14,
    "localidad": "La Huapilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 15,
    "localidad": "Huixthey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 16,
    "localidad": "Madho Cerro Prieto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 17,
    "localidad": "Madho Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 18,
    "localidad": "Madho San Pablo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 19,
    "localidad": "El Mayorazgo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 20,
    "localidad": "Milpa Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 21,
    "localidad": "Naxthey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 22,
    "localidad": "Nexni"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 23,
    "localidad": "El Perú"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 24,
    "localidad": "La Piedad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 25,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 27,
    "localidad": "La Salitrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 28,
    "localidad": "San Agustín Tlalixticapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 29,
    "localidad": "San Antonio Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 30,
    "localidad": "San Antonio Tezoquipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 31,
    "localidad": "San Francisco Sacachichilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 32,
    "localidad": "San Lucas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 33,
    "localidad": "San Pablo Oxtotipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 34,
    "localidad": "San Pedro la Paz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 35,
    "localidad": "Santa María la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 36,
    "localidad": "Taxhie"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 37,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 38,
    "localidad": "Xamage"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 39,
    "localidad": "Santa María Xigui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 40,
    "localidad": "Xothe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 41,
    "localidad": "Yonthe Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 42,
    "localidad": "Yonthe Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 43,
    "localidad": "El Zapote (Fontezuelas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 44,
    "localidad": "Zozea"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 47,
    "localidad": "La Venta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 49,
    "localidad": "El Bermejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 50,
    "localidad": "Cuarta Manzana Bathahuai"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 51,
    "localidad": "Cuarta Manzana Dotzihai (Cuarta Manzana la Loma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 52,
    "localidad": "Cuarta Manzana Toxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 53,
    "localidad": "Dolores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 54,
    "localidad": "El Doydhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 56,
    "localidad": "La Noria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 57,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 58,
    "localidad": "Primera Manzana Dosdha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 59,
    "localidad": "Los Puertecitos (Ejido de Baxthe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 60,
    "localidad": "El Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 63,
    "localidad": "Segunda Manzana Zundho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 64,
    "localidad": "Tercera Manzana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 66,
    "localidad": "Tres Hermanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 67,
    "localidad": "El Deca Tezoquipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 68,
    "localidad": "La Nopalera Naxthey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 69,
    "localidad": "El Peñón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 70,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 71,
    "localidad": "Puithe San Antonio Tezoquipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 72,
    "localidad": "Los Trejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 73,
    "localidad": "Tercera Manzana Tezoquipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 74,
    "localidad": "El Dadhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 75,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 76,
    "localidad": "San Pedro Xamage"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 6,
    "municipio": "Alfajayucan",
    "claveLocalidad": 77,
    "localidad": "Ejido de Santa María la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 1,
    "localidad": "Almoloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 4,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 5,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 6,
    "localidad": "El Carmen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 7,
    "localidad": "Hacienda Cuatlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 8,
    "localidad": "Hacienda Coliuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 10,
    "localidad": "La Coronilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 11,
    "localidad": "El Cuatezón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 12,
    "localidad": "Cuautlatilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 13,
    "localidad": "El Cuervo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 14,
    "localidad": "La Defensa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 16,
    "localidad": "Golondrinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 18,
    "localidad": "Huacalillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 19,
    "localidad": "Huimiyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 20,
    "localidad": "Las Maravillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 21,
    "localidad": "La Mesa del Gallo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 22,
    "localidad": "El Mexicano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 23,
    "localidad": "Los Morales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 24,
    "localidad": "Ocotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 25,
    "localidad": "Ocotepec de Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 26,
    "localidad": "La Ordeña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 29,
    "localidad": "La Presa (La Haciendita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 30,
    "localidad": "La Puerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 31,
    "localidad": "El Pozo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 32,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 33,
    "localidad": "El Refugio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 34,
    "localidad": "Cuatlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 35,
    "localidad": "San Isidro Tetlapayac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 37,
    "localidad": "San José Coliuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 38,
    "localidad": "San Juan Violeta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 39,
    "localidad": "San Lorenzo Xicoténcatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 41,
    "localidad": "Los Ërganos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 43,
    "localidad": "Santiago Tetlapayac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 45,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 46,
    "localidad": "Techachales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 47,
    "localidad": "Tepepatlaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 48,
    "localidad": "Hacienda Tepepatlaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 49,
    "localidad": "Tepetlayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 51,
    "localidad": "El Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 52,
    "localidad": "Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 53,
    "localidad": "Estación Tetlapayac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 55,
    "localidad": "Las Vigas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 56,
    "localidad": "La Violeta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 57,
    "localidad": "Zopiloapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 58,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 64,
    "localidad": "El Chapulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 67,
    "localidad": "La Misa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 68,
    "localidad": "El Portezuelo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 69,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 71,
    "localidad": "La Venta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 72,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 73,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 74,
    "localidad": "Hacienda Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 75,
    "localidad": "El Manantial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 79,
    "localidad": "La Fragua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 82,
    "localidad": "Alejandro Saldívar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 83,
    "localidad": "Cuatro Vientos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 84,
    "localidad": "San Francisco Javier (La Fe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 85,
    "localidad": "Laguna del Puerco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 86,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 89,
    "localidad": "San Ignacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 90,
    "localidad": "Santa Brígida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 91,
    "localidad": "Santa Elena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 93,
    "localidad": "Los Angeles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 94,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 97,
    "localidad": "Las Cotorras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 98,
    "localidad": "San Antonio Alconedo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 99,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 101,
    "localidad": "El  Llorón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 102,
    "localidad": "El Ocote (San Isidro Tlacotoca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 103,
    "localidad": "El Nido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 104,
    "localidad": "El Nopal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 106,
    "localidad": "Los Ojitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 107,
    "localidad": "El Príncipe Bebe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 108,
    "localidad": "El Pájaro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 109,
    "localidad": "Los Sosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 111,
    "localidad": "El Pozo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 113,
    "localidad": "Los Capulines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 114,
    "localidad": "El Cazadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 116,
    "localidad": "Rancho del Cristo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 118,
    "localidad": "El Recuerdo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 121,
    "localidad": "San Carlos Tlalpiza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 125,
    "localidad": "Alvaro López Avilés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 128,
    "localidad": "El Sabinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 130,
    "localidad": "Rancho Daniel Muñoz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 136,
    "localidad": "El Llorón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 137,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 138,
    "localidad": "Santa Inés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 139,
    "localidad": "Rancho San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 140,
    "localidad": "Agua Limpia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 141,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 142,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 145,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 146,
    "localidad": "Hacienda Tepetlayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 147,
    "localidad": "Jorge González Vázquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 148,
    "localidad": "El Lindero Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 149,
    "localidad": "Lucio Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 150,
    "localidad": "La Mesa de los Alpes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 151,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 152,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 153,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 154,
    "localidad": "Los Carrasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 155,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 156,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 157,
    "localidad": "Rancho de No Me Olvides"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 158,
    "localidad": "Rancho del Tunel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 159,
    "localidad": "Rancho el Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 160,
    "localidad": "Horacio Ramírez Curiel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 161,
    "localidad": "Rancho Tecontitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 162,
    "localidad": "El Rincón del Aserradero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 163,
    "localidad": "El Rocio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 165,
    "localidad": "Tomás Castillo Cortés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 166,
    "localidad": "Rancho Gustavo Madrid Ajis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 167,
    "localidad": "El Calvario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 168,
    "localidad": "La Loma Bonita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 169,
    "localidad": "La Frontera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 170,
    "localidad": "Los Rosales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 171,
    "localidad": "Colonia P. Ramírez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 7,
    "municipio": "Almoloya",
    "claveLocalidad": 172,
    "localidad": "Ildefonso Aburto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 1,
    "localidad": "Apan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 2,
    "localidad": "Acopinalco y Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 3,
    "localidad": "Alcantarillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 4,
    "localidad": "Cocinillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 5,
    "localidad": "Chimalpa Tlalayote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 6,
    "localidad": "Ex Hacienda Espejel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 7,
    "localidad": "San José Jiquilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 8,
    "localidad": "La Josefina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 9,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 11,
    "localidad": "Lázaro Cárdenas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 13,
    "localidad": "Malayerba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 14,
    "localidad": "San Juan Ixtilmaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 15,
    "localidad": "San Miguel de las Tunas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 16,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 17,
    "localidad": "El Tezoyo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 18,
    "localidad": "San Diego Tlalayote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 19,
    "localidad": "Colonia los Voladores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 20,
    "localidad": "Zotoluca (Veloz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 21,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 22,
    "localidad": "El Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 23,
    "localidad": "El Tigre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 24,
    "localidad": "Las Ventas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 25,
    "localidad": "Ex Hacienda el Marañón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 26,
    "localidad": "San Lucas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 28,
    "localidad": "La Leona"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 32,
    "localidad": "San Sebastián"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 33,
    "localidad": "El Alcanfor"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 35,
    "localidad": "Los Ranchos (Salsipuedes)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 36,
    "localidad": "El Balconcillo (La Palma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 37,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 38,
    "localidad": "Los Chiteros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 39,
    "localidad": "El Coyote (El Chupadero)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 40,
    "localidad": "Los Encinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 41,
    "localidad": "La Ermita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 42,
    "localidad": "Hacienda San Miguel de las Tunas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 43,
    "localidad": "Jagüeyes Cuates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 44,
    "localidad": "La Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 45,
    "localidad": "Loma Larga (San Antonio)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 46,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 47,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 48,
    "localidad": "Los Ojitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 49,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 50,
    "localidad": "Las Palomas (El Edén)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 51,
    "localidad": "Lomas del Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 52,
    "localidad": "San Diego Tlazala Avilés (Los Quintos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 53,
    "localidad": "Los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 55,
    "localidad": "San Antonio Tochac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 59,
    "localidad": "Ex Hacienda San Juan Ixtilmaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 60,
    "localidad": "Ex Hacienda Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 61,
    "localidad": "Los Sosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 62,
    "localidad": "El Tecorral"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 63,
    "localidad": "El Tejón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 64,
    "localidad": "Zacatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 65,
    "localidad": "Ex Hacienda Zotoluca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 67,
    "localidad": "Ex Hacienda Ocotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 69,
    "localidad": "Los Barrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 70,
    "localidad": "Los Laureles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 71,
    "localidad": "El Rocio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 77,
    "localidad": "La Curva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 88,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 92,
    "localidad": "Cerro del Coyote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 94,
    "localidad": "Santa Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 100,
    "localidad": "Colonia la Virgencita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 102,
    "localidad": "Lindero de Ocotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 106,
    "localidad": "Marcelino Guzmán González"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 111,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 114,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 116,
    "localidad": "Los Capulines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 123,
    "localidad": "Loma Linda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 124,
    "localidad": "Antonio Pale"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 126,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 127,
    "localidad": "Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 141,
    "localidad": "San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 143,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 151,
    "localidad": "San Francisco Marañón (La Virgencita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 171,
    "localidad": "San Joaquín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 194,
    "localidad": "La Era de Ocotepec (Campo Deportivo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 200,
    "localidad": "Colonia San José el Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 201,
    "localidad": "Los Montalvo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 202,
    "localidad": "Celedonio Márquez Sánchez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 203,
    "localidad": "Cándido García Beristáin"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 205,
    "localidad": "Colonia Bosques de Chulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 206,
    "localidad": "Colonia Magisterial Hidalguense"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 207,
    "localidad": "Guadalupe Herrera de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 208,
    "localidad": "Joaquin Macias Romano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 209,
    "localidad": "La Montaña de las Tres Cruces (El Tecorrál)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 210,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 211,
    "localidad": "Las Peñitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 212,
    "localidad": "Rancho Los Mauricios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 213,
    "localidad": "Rancho Teteyo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 214,
    "localidad": "La Sombrilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 215,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 216,
    "localidad": "Las Cabañitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 218,
    "localidad": "Unidad Deportiva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 219,
    "localidad": "El Capulín (La Mesa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 220,
    "localidad": "Cerro del Conejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 221,
    "localidad": "Los Charritos (Los Cotorros)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 222,
    "localidad": "Los Gutiérrez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 223,
    "localidad": "Canuto Monroy"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 224,
    "localidad": "El Jazmín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 225,
    "localidad": "Leonel Ramírez González"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 226,
    "localidad": "Los Morales (El Jagüey)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 227,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 229,
    "localidad": "San Isidro (Rosendo Luna Orozco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 230,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 231,
    "localidad": "Los Téllez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 233,
    "localidad": "Ampliación Loma Bonita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 8,
    "municipio": "Apan",
    "claveLocalidad": 234,
    "localidad": "Las Lagunetas (La Presa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 1,
    "localidad": "El Arenal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 3,
    "localidad": "Chimilpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 4,
    "localidad": "Fray Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 5,
    "localidad": "El Jiadi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 6,
    "localidad": "El Meje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 7,
    "localidad": "Ojo de Agua San José Tepenene"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 8,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 9,
    "localidad": "San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 10,
    "localidad": "Santa Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 11,
    "localidad": "San José Tepenene (Tepenene)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 12,
    "localidad": "Colonia Veinte de Noviembre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 13,
    "localidad": "Ojo de Agua Santa Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 16,
    "localidad": "Cosahuayán Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 17,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 18,
    "localidad": "La Sala (La Caliente)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 20,
    "localidad": "La Manzana Uno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 21,
    "localidad": "La Garita (La Mina)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 24,
    "localidad": "El Pozo (Santa Ana)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 26,
    "localidad": "El Bocja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 27,
    "localidad": "Puerto del Oro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 28,
    "localidad": "Las Peñitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 29,
    "localidad": "El Paje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 9,
    "municipio": "El Arenal",
    "claveLocalidad": 30,
    "localidad": "El Puerto de San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 1,
    "localidad": "Atitalaquia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 2,
    "localidad": "Cardonal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 6,
    "localidad": "Tezoquipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 7,
    "localidad": "Tlalminulpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 8,
    "localidad": "Tlamaco (San Gerónimo Tlamaco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 9,
    "localidad": "San José Bojay el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 10,
    "localidad": "San Isidro Bojayito (Ex Hacienda Bojayito)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 11,
    "localidad": "Rancho Chihuahua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 12,
    "localidad": "Unidad Habitacional Antonio Osorio de León (Bojay)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 13,
    "localidad": "La Cantera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 14,
    "localidad": "Colonia Empleados Pemex"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 16,
    "localidad": "El Gavillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 17,
    "localidad": "La Loma de Ixtazacuala (La Loma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 18,
    "localidad": "Rancho Chelita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 19,
    "localidad": "Rancho el Olimpo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 20,
    "localidad": "Ventas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 22,
    "localidad": "El Tecolote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 23,
    "localidad": "La Era"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 24,
    "localidad": "Ejido San Luis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 25,
    "localidad": "Ejido de San Luis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 10,
    "municipio": "Atitalaquia",
    "claveLocalidad": 26,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 1,
    "localidad": "Atlapexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 2,
    "localidad": "Achiquihuixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 3,
    "localidad": "Atencuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 4,
    "localidad": "Atlajco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 5,
    "localidad": "Atlaltipa Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 6,
    "localidad": "Atlaltipa Huitzotlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 7,
    "localidad": "Atlaltipa Tecolotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 8,
    "localidad": "Atotomoc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 9,
    "localidad": "Cochiscuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 10,
    "localidad": "Cochotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 11,
    "localidad": "Coyolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 12,
    "localidad": "Cuatapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 16,
    "localidad": "Huitzotlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 17,
    "localidad": "Ixtacuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 18,
    "localidad": "Ixtacuayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 19,
    "localidad": "Itzocal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 20,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 21,
    "localidad": "Oxpantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 22,
    "localidad": "Pahactla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 23,
    "localidad": "Palo Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 25,
    "localidad": "Pochoica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 26,
    "localidad": "El Porvenir"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 27,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 28,
    "localidad": "La Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 29,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 30,
    "localidad": "Los Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 31,
    "localidad": "Santo Tomás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 32,
    "localidad": "Tecacahuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 33,
    "localidad": "Tecolotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 34,
    "localidad": "Tempexquite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 35,
    "localidad": "Tenexco I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 36,
    "localidad": "Tenexco II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 37,
    "localidad": "Tlachapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 38,
    "localidad": "Plan Huasteca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 39,
    "localidad": "Xancaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 40,
    "localidad": "Tierra Playa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 41,
    "localidad": "Teocoatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 45,
    "localidad": "Tlahíca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 50,
    "localidad": "Coahuixpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 51,
    "localidad": "General Emiliano Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 52,
    "localidad": "Potrero de Méndez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 53,
    "localidad": "Samaria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 54,
    "localidad": "El Suspiro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 57,
    "localidad": "Poxtla Atlajco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 58,
    "localidad": "Cuatenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 60,
    "localidad": "Rancho las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 61,
    "localidad": "Tzintepetzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 62,
    "localidad": "6 de Enero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 63,
    "localidad": "Tzapopilol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 64,
    "localidad": "Ejido Atlapexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 65,
    "localidad": "Salida a Pahactla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 66,
    "localidad": "Granja Coyolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 11,
    "municipio": "Atlapexco",
    "claveLocalidad": 67,
    "localidad": "10 de Mayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 1,
    "localidad": "Atotonilco el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 2,
    "localidad": "Apipilhuasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 3,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 4,
    "localidad": "Cieneguillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 5,
    "localidad": "El Contadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 6,
    "localidad": "La Cruz (Barrio de la Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 7,
    "localidad": "La Cumbre de San Lucas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 8,
    "localidad": "Doñana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 9,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 11,
    "localidad": "Montecillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 12,
    "localidad": "La Nogalera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 13,
    "localidad": "El Novillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 14,
    "localidad": "Paraje de los Sauces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 15,
    "localidad": "Paso de Amajac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 16,
    "localidad": "El Pedregal de San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 17,
    "localidad": "Potrero de los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 18,
    "localidad": "La Puebla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 19,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 20,
    "localidad": "Los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 21,
    "localidad": "El Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 22,
    "localidad": "Los Sabinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 23,
    "localidad": "Sanctórum"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 24,
    "localidad": "San Felipe y Anexas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 25,
    "localidad": "San José Zoquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 26,
    "localidad": "San Lucas Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 27,
    "localidad": "San Martín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 28,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 29,
    "localidad": "San Nicolás Xathé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 30,
    "localidad": "San Pedro Vaquerías"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 31,
    "localidad": "Santa Ana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 32,
    "localidad": "Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 33,
    "localidad": "Santa María Amajac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 34,
    "localidad": "Santiaguito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 35,
    "localidad": "Sauz Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 36,
    "localidad": "Sauz Xathé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 37,
    "localidad": "Tezahuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 38,
    "localidad": "Agua Limpia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 39,
    "localidad": "Tiltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 40,
    "localidad": "Uña de Gato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 41,
    "localidad": "El Xithe (Santa Rita el Xithe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 42,
    "localidad": "El Zoquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 43,
    "localidad": "Cerro Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 44,
    "localidad": "El Ocote (Ocote Potrero de Reyes)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 45,
    "localidad": "Rincón de Xathé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 46,
    "localidad": "Santa Cruz de Montecillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 49,
    "localidad": "Barrio el Atorón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 50,
    "localidad": "Barrio Coyula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 51,
    "localidad": "Barrio de Metlapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 53,
    "localidad": "Barrio de Cabrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 54,
    "localidad": "Mesa de San Lucas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 56,
    "localidad": "Santa Ana Norte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 59,
    "localidad": "El Troje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 61,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 65,
    "localidad": "Pedregal de San Nicolás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 66,
    "localidad": "Ramal de San Nicolás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 67,
    "localidad": "El Tecolote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 68,
    "localidad": "Los Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 69,
    "localidad": "Paredones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 71,
    "localidad": "Cumbre de Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 72,
    "localidad": "Colonia el Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 73,
    "localidad": "Los Baños de Santa María Amajac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 74,
    "localidad": "El Naranjo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 75,
    "localidad": "Rancho del Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 76,
    "localidad": "Padre Nuestro San Bartolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 77,
    "localidad": "La Estancia (Aguacatitlan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 12,
    "municipio": "Atotonilco el Grande",
    "claveLocalidad": 78,
    "localidad": "La Loma del Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 1,
    "localidad": "Atotonilco de Tula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 2,
    "localidad": "San José Acoculco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 5,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 6,
    "localidad": "Conejos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 7,
    "localidad": "Cuayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 8,
    "localidad": "Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 9,
    "localidad": "El Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 10,
    "localidad": "Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 11,
    "localidad": "El Refugio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 12,
    "localidad": "Texas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 13,
    "localidad": "Vito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 14,
    "localidad": "Zacamulpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 15,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 18,
    "localidad": "Praderas del Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 19,
    "localidad": "Batha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 20,
    "localidad": "Hacienda Montero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 21,
    "localidad": "Potrero Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 22,
    "localidad": "El Puertecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 23,
    "localidad": "Vito (Fabricio Alvarez Estrada)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 24,
    "localidad": "1a Sección Conejos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 25,
    "localidad": "La Sierrita (La Presa del Tejocote)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 26,
    "localidad": "El Portal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 13,
    "municipio": "Atotonilco de Tula",
    "claveLocalidad": 27,
    "localidad": "Santa Cruz Tezontle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 1,
    "localidad": "Calnali"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 2,
    "localidad": "Acatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 3,
    "localidad": "Ahuacatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 4,
    "localidad": "Atempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 5,
    "localidad": "Camotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 6,
    "localidad": "Coamitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 7,
    "localidad": "Coyula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 8,
    "localidad": "Chiatipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 9,
    "localidad": "San Andrés (San Andrés Chichayotla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 10,
    "localidad": "Papatlatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 11,
    "localidad": "Pezmatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 13,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 14,
    "localidad": "Santa Lucía (Mesa de Santa Lucía)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 15,
    "localidad": "Tecpaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 16,
    "localidad": "Tecueyaca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 17,
    "localidad": "Techichico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 18,
    "localidad": "Tochintlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 19,
    "localidad": "Tostlamantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 20,
    "localidad": "Tula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 21,
    "localidad": "Pezmapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 22,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 23,
    "localidad": "Xontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 25,
    "localidad": "Acatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 26,
    "localidad": "Cuaxacal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 27,
    "localidad": "Piedras Blancas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 28,
    "localidad": "Arroyo del Muerto (Piedras Blancas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 29,
    "localidad": "Texcaco (Sagrado Corazón de Jesús)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 31,
    "localidad": "Tetzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 32,
    "localidad": "Izocal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 33,
    "localidad": "San Antonio (Huehuenco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 37,
    "localidad": "Zihuatecpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 39,
    "localidad": "Olozacaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 41,
    "localidad": "Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 42,
    "localidad": "Atezco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 43,
    "localidad": "Chicuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 44,
    "localidad": "Tonalish"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 45,
    "localidad": "Tlalica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 46,
    "localidad": "Tecomatla (Chintipan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 47,
    "localidad": "Cuanectla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 48,
    "localidad": "Tiocintepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 49,
    "localidad": "Tlanepango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 51,
    "localidad": "Cohuamila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 52,
    "localidad": "Xaltipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 55,
    "localidad": "Ahuamolos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 57,
    "localidad": "Amatépetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 58,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 60,
    "localidad": "Michinteopan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 61,
    "localidad": "Pochula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 62,
    "localidad": "Temextla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 63,
    "localidad": "Cruz Verde (Tempalahuaco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 64,
    "localidad": "Tecuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 65,
    "localidad": "Tlalica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 67,
    "localidad": "Tonalaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 68,
    "localidad": "La Cumbre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 69,
    "localidad": "Xacalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 70,
    "localidad": "Ayacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 71,
    "localidad": "Acalamaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 72,
    "localidad": "Ayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 73,
    "localidad": "Chalahuico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 74,
    "localidad": "Cholingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 75,
    "localidad": "Hualul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 76,
    "localidad": "Huichapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 77,
    "localidad": "Linda Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 78,
    "localidad": "Metlatépetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 80,
    "localidad": "Nuevo Cuaptonapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 81,
    "localidad": "Pezmatépetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 82,
    "localidad": "Tepetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 83,
    "localidad": "Tepeyacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 84,
    "localidad": "Tlatexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 85,
    "localidad": "Ayateca (Tlanepango)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 86,
    "localidad": "Agiladero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 87,
    "localidad": "Coamila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 88,
    "localidad": "Cerro de la Aguja (Huitzmalotépetl)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 89,
    "localidad": "Coahuizas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 91,
    "localidad": "La Ciénega (Agua Zarca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 92,
    "localidad": "Cuazala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 93,
    "localidad": "Cuitlachamaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 94,
    "localidad": "Eloxochititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 95,
    "localidad": "Limonzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 96,
    "localidad": "Molhuasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 97,
    "localidad": "Octatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 98,
    "localidad": "Palzoquitempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 99,
    "localidad": "Teotlalzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 100,
    "localidad": "Tepetlaixpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 101,
    "localidad": "Tonalix"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 102,
    "localidad": "Xochimilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 104,
    "localidad": "Zacatépetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 105,
    "localidad": "San Lucas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 106,
    "localidad": "Gerardo Reyes Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 107,
    "localidad": "Cuatlapalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 108,
    "localidad": "Hueytepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 109,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 110,
    "localidad": "Temanaxteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 111,
    "localidad": "Tepeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 112,
    "localidad": "Tetioco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 14,
    "municipio": "Calnali",
    "claveLocalidad": 113,
    "localidad": "Xontla (Barrio de la Esperanza)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 1,
    "localidad": "Cardonal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 2,
    "localidad": "Aguacatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 3,
    "localidad": "El Arenalito (El Arroyo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 4,
    "localidad": "El Bingu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 5,
    "localidad": "El Botho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 6,
    "localidad": "El Boxo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 7,
    "localidad": "El Buena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 8,
    "localidad": "Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 9,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 10,
    "localidad": "Cieneguilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 11,
    "localidad": "El Cubo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 12,
    "localidad": "El Deca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 13,
    "localidad": "Emilio Hernández la Florida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 14,
    "localidad": "Jonacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 15,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 16,
    "localidad": "Moxthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 17,
    "localidad": "Piedra Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 18,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 19,
    "localidad": "Pozuelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 20,
    "localidad": "San Andrés Daboxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 21,
    "localidad": "San Antonio Sabanillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 22,
    "localidad": "San Clemente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 23,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 24,
    "localidad": "San Miguel Tlazintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 25,
    "localidad": "San Miguel Jigui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 26,
    "localidad": "Santa Teresa Daboxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 27,
    "localidad": "Santuario (Santuario Mapethe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 28,
    "localidad": "El Sauz (Juxmaye)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 29,
    "localidad": "El Tedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 30,
    "localidad": "Barrio de Tixqui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 31,
    "localidad": "El Vithe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 32,
    "localidad": "Pilas Yonthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 33,
    "localidad": "El Molino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 35,
    "localidad": "Durango Daboxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 37,
    "localidad": "Los Ambrocios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 38,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 39,
    "localidad": "Barrio Quixpedhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 40,
    "localidad": "Los Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 41,
    "localidad": "Cardonalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 43,
    "localidad": "Bixhuaji"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 45,
    "localidad": "La Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 46,
    "localidad": "Cieneguillita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 47,
    "localidad": "Molanguito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 48,
    "localidad": "Dojume"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 49,
    "localidad": "Toxthi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 50,
    "localidad": "El Vixtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 51,
    "localidad": "El Manchado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 52,
    "localidad": "El Pájaro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 54,
    "localidad": "Grutas de Tolantongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 57,
    "localidad": "El Gumbo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 58,
    "localidad": "La Hacienda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 59,
    "localidad": "Pozo Seco (Los Barrera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 60,
    "localidad": "El Bondho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 61,
    "localidad": "Pinalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 62,
    "localidad": "El Moro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 64,
    "localidad": "Cuesta Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 65,
    "localidad": "Agua Nueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 67,
    "localidad": "Baxcajay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 68,
    "localidad": "Los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 69,
    "localidad": "Cerro Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 70,
    "localidad": "Los Fresnos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 71,
    "localidad": "Loma Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 72,
    "localidad": "Manzanitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 74,
    "localidad": "Nogal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 76,
    "localidad": "Puerto Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 77,
    "localidad": "Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 78,
    "localidad": "El Tixqui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 79,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 80,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 82,
    "localidad": "Baxoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 83,
    "localidad": "Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 84,
    "localidad": "El Clavelito (El Cave)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 85,
    "localidad": "La Colonia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 86,
    "localidad": "Chalmita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 87,
    "localidad": "Cerro Blanco (El Fraile)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 88,
    "localidad": "Los Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 89,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 90,
    "localidad": "Los Lirios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 92,
    "localidad": "Manzana del Cubo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 93,
    "localidad": "Manzana del Piñón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 95,
    "localidad": "La Parada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 96,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 97,
    "localidad": "El Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 101,
    "localidad": "Los Pérez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 103,
    "localidad": "Texmaye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 104,
    "localidad": "Los Vargas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 106,
    "localidad": "El Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 107,
    "localidad": "El Cuartel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 108,
    "localidad": "Cuesta Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 109,
    "localidad": "El Estribero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 110,
    "localidad": "Huizache"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 112,
    "localidad": "Los Rebolledo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 113,
    "localidad": "Cerro del Coyote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 114,
    "localidad": "El Huizachito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 15,
    "municipio": "Cardonal",
    "claveLocalidad": 115,
    "localidad": "Palacios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 1,
    "localidad": "Cuautepec de Hinojosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 2,
    "localidad": "Alhuajoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 3,
    "localidad": "Las Animas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 4,
    "localidad": "El Aserradero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 5,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 6,
    "localidad": "Cerro Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 7,
    "localidad": "Cima de Togo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 8,
    "localidad": "Coatzetzengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 9,
    "localidad": "El Coyuco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 10,
    "localidad": "Chacalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 11,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 12,
    "localidad": "Guadalupe Victoria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 13,
    "localidad": "San Juan Hueyapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 14,
    "localidad": "Hueyapita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 15,
    "localidad": "Huistongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 16,
    "localidad": "Lomas de Ojuila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 17,
    "localidad": "San Rafael Mazatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 18,
    "localidad": "El Nectario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 19,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 20,
    "localidad": "Las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 21,
    "localidad": "Santa Elena Paliseca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 24,
    "localidad": "Las Puentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 25,
    "localidad": "La Puerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 27,
    "localidad": "San Juan Tecocomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 28,
    "localidad": "San Lorenzo Sayula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 29,
    "localidad": "Santa María Nativitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 30,
    "localidad": "Tecocomulco de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 33,
    "localidad": "El Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 34,
    "localidad": "Tezoncualpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 35,
    "localidad": "Tezoquipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 36,
    "localidad": "Texcaltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 37,
    "localidad": "El Ventorrillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 38,
    "localidad": "Xayahualulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 39,
    "localidad": "Almoloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 40,
    "localidad": "Cebaditas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 41,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 44,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 47,
    "localidad": "Las Aguilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 48,
    "localidad": "El Atorón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 50,
    "localidad": "Casas Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 51,
    "localidad": "Las Conchas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 53,
    "localidad": "La Esperanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 54,
    "localidad": "La Isleta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 55,
    "localidad": "El Jazmín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 56,
    "localidad": "Los Laureles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 58,
    "localidad": "Maravillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 60,
    "localidad": "El Piñón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 63,
    "localidad": "La Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 65,
    "localidad": "San Aparicio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 68,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 69,
    "localidad": "San José Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 70,
    "localidad": "Peña del Tigre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 72,
    "localidad": "Tulimán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 73,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 74,
    "localidad": "Buenos Aires"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 76,
    "localidad": "La Puerta del Yolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 80,
    "localidad": "Loma Bonita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 81,
    "localidad": "El Jarillal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 83,
    "localidad": "El Abertal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 84,
    "localidad": "La Barranca del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 85,
    "localidad": "Caballo Rucio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 86,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 87,
    "localidad": "La Coronilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 88,
    "localidad": "La Cueva del Tezontle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 89,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 90,
    "localidad": "El Emporio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 91,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 92,
    "localidad": "Las Eras de Huistongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 93,
    "localidad": "La Fábrica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 94,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 95,
    "localidad": "La Isla de Montecristo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 96,
    "localidad": "La Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 97,
    "localidad": "Nopal Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 98,
    "localidad": "Presa Reventada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 99,
    "localidad": "El Ranchero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 100,
    "localidad": "Rancho Trejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 101,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 102,
    "localidad": "Las Tires"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 103,
    "localidad": "Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 104,
    "localidad": "Xocopa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 105,
    "localidad": "Explanada San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 106,
    "localidad": "Manuel Rodríguez Martínez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 107,
    "localidad": "Marcelino Acosta Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 108,
    "localidad": "La Rayuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 109,
    "localidad": "Valentín Hernández Yáñez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 110,
    "localidad": "Tlacomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 111,
    "localidad": "Ejido el Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 112,
    "localidad": "Granja Avícola Cuautepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 113,
    "localidad": "El Ojito de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 114,
    "localidad": "Arboledas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 115,
    "localidad": "Las Canoas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 116,
    "localidad": "Cerro de Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 117,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 118,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 119,
    "localidad": "El Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 120,
    "localidad": "La Serena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 121,
    "localidad": "Santa Teresa de los Pinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 16,
    "municipio": "Cuautepec de Hinojosa",
    "claveLocalidad": 122,
    "localidad": "Los Aguilares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 1,
    "localidad": "Chapantongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 2,
    "localidad": "El Agua Fría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 3,
    "localidad": "Santa María Amealco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 5,
    "localidad": "Bathi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 6,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 7,
    "localidad": "Chapulaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 8,
    "localidad": "Dexha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 9,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 10,
    "localidad": "Las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 11,
    "localidad": "Juchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 12,
    "localidad": "San José el Marquez (Escandón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 13,
    "localidad": "Nueva Santa Lucía"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 14,
    "localidad": "San Bartolo Ozocalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 15,
    "localidad": "San Juan el Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 16,
    "localidad": "San Ramón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 17,
    "localidad": "Taxhue"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 18,
    "localidad": "Tenería"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 20,
    "localidad": "Tlaunilolpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 21,
    "localidad": "Toxthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 22,
    "localidad": "Zimapantongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 23,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 24,
    "localidad": "El Sauz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 25,
    "localidad": "El Huizachal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 27,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 29,
    "localidad": "Atargea (El Arco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 30,
    "localidad": "El Camarón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 32,
    "localidad": "El Colorado (Cerro Colorado)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 33,
    "localidad": "El Dañe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 36,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 37,
    "localidad": "Rincón de las Víboras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 38,
    "localidad": "Santa Lucía (El Cielito)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 40,
    "localidad": "Colonia Félix Olvera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 41,
    "localidad": "Ex Hacienda el Marquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 42,
    "localidad": "Colonia el Saucito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 43,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 44,
    "localidad": "La Magdalena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 46,
    "localidad": "Quinta la Esperanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 47,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 48,
    "localidad": "La Noria (El Plan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 49,
    "localidad": "Puerto Vallarta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 50,
    "localidad": "Barrio Guadalupe Altos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 17,
    "municipio": "Chapantongo",
    "claveLocalidad": 51,
    "localidad": "Barrio Remedios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 1,
    "localidad": "Chapulhuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 2,
    "localidad": "Amixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 3,
    "localidad": "El Amolar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 4,
    "localidad": "Arroyo Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 5,
    "localidad": "El Banco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 6,
    "localidad": "El Barrio (Barrio del Carmen)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 8,
    "localidad": "Cahuazas (Hacienda de Cahuazas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 9,
    "localidad": "El Campanario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 10,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 11,
    "localidad": "Carrizal del Sótano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 12,
    "localidad": "Carrizal de Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 13,
    "localidad": "Las Ciruelas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 14,
    "localidad": "El Coyol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 15,
    "localidad": "La Guayaba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 16,
    "localidad": "La Hondura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 17,
    "localidad": "Huatepango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 18,
    "localidad": "Iglesia Vieja (Iglesia Nueva)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 19,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 20,
    "localidad": "Miahuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 21,
    "localidad": "Neblinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 22,
    "localidad": "El Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 23,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 24,
    "localidad": "Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 25,
    "localidad": "Palo Semita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 26,
    "localidad": "Palo Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 27,
    "localidad": "Pared Gruesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 28,
    "localidad": "El Pescado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 29,
    "localidad": "La Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 30,
    "localidad": "Plan de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 31,
    "localidad": "Puerto Obscuro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 32,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 33,
    "localidad": "El Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 34,
    "localidad": "San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 35,
    "localidad": "Santa Ana de Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 36,
    "localidad": "Santa María de Alamos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 37,
    "localidad": "Saucillo (Saucillo Agua Nueva)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 38,
    "localidad": "La Sierrita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 40,
    "localidad": "Soledad del Coyol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 42,
    "localidad": "El Sótano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 43,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 44,
    "localidad": "Tetlalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 45,
    "localidad": "Tocapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 47,
    "localidad": "El Zacatal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 48,
    "localidad": "Zacate Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 49,
    "localidad": "La Ceiba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 50,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 51,
    "localidad": "Yobicó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 52,
    "localidad": "Cuicuiteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 53,
    "localidad": "Sayula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 54,
    "localidad": "Arroyo de Acaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 55,
    "localidad": "Piedra Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 57,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 58,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 59,
    "localidad": "El Algodonal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 60,
    "localidad": "Zimapanito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 61,
    "localidad": "La Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 62,
    "localidad": "Chalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 63,
    "localidad": "El Voladero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 64,
    "localidad": "El Balcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 65,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 67,
    "localidad": "El Cajete"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 68,
    "localidad": "Acuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 69,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 70,
    "localidad": "El Alamo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 71,
    "localidad": "Las Campanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 72,
    "localidad": "La Casa Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 73,
    "localidad": "El Chinillar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 74,
    "localidad": "Cerro Boludo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 75,
    "localidad": "Rancho el Estero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 76,
    "localidad": "El Hualul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 77,
    "localidad": "La Joya del Zopilote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 79,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 80,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 81,
    "localidad": "La Lomita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 82,
    "localidad": "El Entronque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 84,
    "localidad": "El Porvenir (Colonia Solidaridad)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 85,
    "localidad": "Las Pozas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 86,
    "localidad": "Puerto del Amolar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 87,
    "localidad": "Puerto del Caballo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 88,
    "localidad": "La Chuparrosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 89,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 90,
    "localidad": "La Ceibita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 92,
    "localidad": "Arroyo del Mamey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 93,
    "localidad": "Las Carpas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 95,
    "localidad": "La Ceiba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 96,
    "localidad": "La Golondrina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 97,
    "localidad": "El Huizache"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 99,
    "localidad": "Rancho Nuevo (Puerto del Gallo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 100,
    "localidad": "La Reforma de Palo Semita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 101,
    "localidad": "El Zacatito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 103,
    "localidad": "El Limoncito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 104,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 105,
    "localidad": "Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 106,
    "localidad": "Barrio Arriba Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 108,
    "localidad": "Escuayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 109,
    "localidad": "El Limoncito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 110,
    "localidad": "Soledad del Ocote (La Loma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 111,
    "localidad": "Las Minas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 112,
    "localidad": "Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 113,
    "localidad": "Nuevo Coyolar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 114,
    "localidad": "El Sabinito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 115,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 116,
    "localidad": "Puerto de la Cruz Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 117,
    "localidad": "Puerto del Tambor"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 118,
    "localidad": "El Clarín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 119,
    "localidad": "Los Jobos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 120,
    "localidad": "Puerto el Zopilote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 18,
    "municipio": "Chapulhuacán",
    "claveLocalidad": 121,
    "localidad": "Pared Gruesa (Nuevo Pared Gruesa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 1,
    "localidad": "Chilcuautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 2,
    "localidad": "El Bethi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 3,
    "localidad": "Boxaxni"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 4,
    "localidad": "El Dadhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 5,
    "localidad": "El Deca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 6,
    "localidad": "El Dontzhi (Colonia Alamos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 7,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 8,
    "localidad": "Huitexcalco de Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 9,
    "localidad": "Llano Primero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 10,
    "localidad": "El Mejay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 11,
    "localidad": "Santa Ana Batha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 12,
    "localidad": "El Tandhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 13,
    "localidad": "Texcatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 14,
    "localidad": "Tlacotlapilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 15,
    "localidad": "Tunititlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 16,
    "localidad": "El Xothi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 17,
    "localidad": "Zacualoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 19,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 20,
    "localidad": "Cerro del Corazón (El Mui)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 21,
    "localidad": "El Gallinero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 22,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 23,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 24,
    "localidad": "El Xithey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 25,
    "localidad": "El Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 26,
    "localidad": "El Padhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 27,
    "localidad": "Piletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 28,
    "localidad": "La Barranca de San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 29,
    "localidad": "La Isla (El Puente)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 19,
    "municipio": "Chilcuautla",
    "claveLocalidad": 30,
    "localidad": "El Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 1,
    "localidad": "Eloxochitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 2,
    "localidad": "San Miguel Almolón (Almolón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 3,
    "localidad": "Almoloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 4,
    "localidad": "Chalmita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 5,
    "localidad": "San Pedro Gilo (Gilo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 6,
    "localidad": "Hualula (San Juan Hualula)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 7,
    "localidad": "Itztacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 8,
    "localidad": "Otatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 9,
    "localidad": "San Juan Amajaque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 10,
    "localidad": "Tecomate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 11,
    "localidad": "Tepeyica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 12,
    "localidad": "Chacaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 13,
    "localidad": "Metzquititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 14,
    "localidad": "El Puerto de Jiliapa (El Puerto de Hualula)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 17,
    "localidad": "Otompa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 18,
    "localidad": "Mecapala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 19,
    "localidad": "Yateco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 20,
    "localidad": "La Punta de Hualula (La Punta de Cerro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 21,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 23,
    "localidad": "Patoloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 24,
    "localidad": "El Mezquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 20,
    "municipio": "Eloxochitlán",
    "claveLocalidad": 25,
    "localidad": "El Rancho de Tecuanimito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 1,
    "localidad": "Emiliano Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 2,
    "localidad": "Malpaís"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 5,
    "localidad": "Santa Bárbara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 6,
    "localidad": "Santa Clara (Progreso)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 10,
    "localidad": "Tortolitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 11,
    "localidad": "José María Morelos (San José)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 13,
    "localidad": "Hacienda Santa Clara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 15,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 19,
    "localidad": "El Puente Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 22,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 24,
    "localidad": "Rancho San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 26,
    "localidad": "Los Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 27,
    "localidad": "El Alcanfor"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 28,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 29,
    "localidad": "La Providencia (Santa Maria)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 30,
    "localidad": "San Luis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 31,
    "localidad": "Las Vegas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 32,
    "localidad": "Ex Hacienda San Lorenzo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 21,
    "municipio": "Emiliano Zapata",
    "claveLocalidad": 35,
    "localidad": "El Panteón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 1,
    "localidad": "Epazoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 2,
    "localidad": "Escobillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 4,
    "localidad": "El Guajolote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 5,
    "localidad": "Jometitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 6,
    "localidad": "Los Lirios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 7,
    "localidad": "El Manzano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 8,
    "localidad": "El Mercillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 9,
    "localidad": "Nexpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 10,
    "localidad": "El Nopalillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 11,
    "localidad": "El Ocote Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 12,
    "localidad": "El Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 14,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 15,
    "localidad": "San Ignacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 16,
    "localidad": "San José Palacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 17,
    "localidad": "San Juan Tizahuapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 19,
    "localidad": "San Miguel Nopalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 20,
    "localidad": "San Pablo Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 21,
    "localidad": "Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 22,
    "localidad": "Santa Teresa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 23,
    "localidad": "Tepozotlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 24,
    "localidad": "Xochihuacán (Las Palomas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 25,
    "localidad": "Xolostitla de Morelos (Xolostitla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 26,
    "localidad": "San José el Tecolote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 27,
    "localidad": "El Crucero de Nexpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 29,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 37,
    "localidad": "San José Chavarría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 40,
    "localidad": "Piedra Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 41,
    "localidad": "Barrio Chapultepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 42,
    "localidad": "Barrio de San Juan Tizahuapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 43,
    "localidad": "Casacoalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 44,
    "localidad": "Cerro Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 45,
    "localidad": "Los Charcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 47,
    "localidad": "El Escobal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 49,
    "localidad": "La Huerta Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 50,
    "localidad": "La Huerta Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 51,
    "localidad": "Mirasoles (San Miguel)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 52,
    "localidad": "El Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 53,
    "localidad": "La Presa (Casas Blancas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 54,
    "localidad": "El Puente (Piedras Negras)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 56,
    "localidad": "Techalote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 57,
    "localidad": "La Trinidad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 58,
    "localidad": "El Cascabel (La Coyotera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 59,
    "localidad": "El Grillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 60,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 61,
    "localidad": "San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 62,
    "localidad": "Los Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 63,
    "localidad": "Maguey Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 64,
    "localidad": "San Agustín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 65,
    "localidad": "Caja del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 66,
    "localidad": "Las Palmitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 67,
    "localidad": "Las Cuevas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 68,
    "localidad": "Ejido de San Juan Tizahuapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 69,
    "localidad": "Felipe González Ortiz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 70,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 71,
    "localidad": "La Mesita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 72,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 73,
    "localidad": "El Pinillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 74,
    "localidad": "Santa María el Arco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 75,
    "localidad": "La Trinidad Segunda Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 76,
    "localidad": "El Galán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 77,
    "localidad": "Cerro Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 78,
    "localidad": "El Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 79,
    "localidad": "La Gotera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 80,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 81,
    "localidad": "San Cayetano (Los Lazcano)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 82,
    "localidad": "Santa María las Mesas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 22,
    "municipio": "Epazoyucan",
    "claveLocalidad": 83,
    "localidad": "Ciénega Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 1,
    "localidad": "Tepatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 2,
    "localidad": "Arambo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 3,
    "localidad": "Bocamiño"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 4,
    "localidad": "La Comunidad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 5,
    "localidad": "Dengantzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 6,
    "localidad": "Doctor José G. Parres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 7,
    "localidad": "El Mendoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 8,
    "localidad": "Lázaro Cárdenas (Colonia el  Mexe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 9,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 10,
    "localidad": "La Puerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 12,
    "localidad": "El Rosario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 13,
    "localidad": "San José Boxay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 14,
    "localidad": "San Juan Tepa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 15,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 18,
    "localidad": "Colonia el Veinte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 19,
    "localidad": "Colonia Emiliano Zapata (Colonia los Morales)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 24,
    "localidad": "El Villano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 26,
    "localidad": "Jagüey del Gonzudi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 28,
    "localidad": "Las Coronas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 30,
    "localidad": "Los Filtros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 32,
    "localidad": "Compuerta el Trece"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 35,
    "localidad": "El Porvenir"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 36,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 37,
    "localidad": "Colonia el Horno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 38,
    "localidad": "Barrio Nuevo México"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 39,
    "localidad": "Barrio San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 40,
    "localidad": "El Barrozo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 41,
    "localidad": "Colonia Cuarta Demarcación (Barrio los Violines)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 42,
    "localidad": "Colonia Francisco Villa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 43,
    "localidad": "Las Fuentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 44,
    "localidad": "Barrio el Quince"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 45,
    "localidad": "Granja Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 46,
    "localidad": "El Tapia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 48,
    "localidad": "El Rancho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 49,
    "localidad": "Barrio los Amigos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 23,
    "municipio": "Francisco I. Madero",
    "claveLocalidad": 50,
    "localidad": "Barrio el Bravo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 1,
    "localidad": "Huasca de Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 2,
    "localidad": "Aguacatitla (El Campamento)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 3,
    "localidad": "Bermúdez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 4,
    "localidad": "San José Cacaloapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 5,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 6,
    "localidad": "Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 10,
    "localidad": "Magueyes Verdes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 12,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 13,
    "localidad": "Palma Antigua el Vite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 14,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 15,
    "localidad": "La Palmilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 16,
    "localidad": "Palmillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 17,
    "localidad": "El Peral"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 18,
    "localidad": "Piedra del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 20,
    "localidad": "Los Reyes Tepezala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 21,
    "localidad": "Río Seco Puente de Doria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 22,
    "localidad": "San Bartolomé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 23,
    "localidad": "San Diego"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 24,
    "localidad": "San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 25,
    "localidad": "San José Ocotillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 26,
    "localidad": "San Juan Hueyapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 27,
    "localidad": "San Miguel Regla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 29,
    "localidad": "San Sebastián (San Sebastián la Barranca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 31,
    "localidad": "Santa María Regla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 34,
    "localidad": "Santo Domingo Agua Zarca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 35,
    "localidad": "Santo Tomás Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 36,
    "localidad": "San Lorenzo el Zembo (El Zembo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 37,
    "localidad": "Xúchil el Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 38,
    "localidad": "Tlaxocoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 40,
    "localidad": "Las Vigas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 41,
    "localidad": "El Vite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 42,
    "localidad": "Cacaloapan (San Miguel Cacaloapan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 43,
    "localidad": "Llano Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 44,
    "localidad": "Agua Zarca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 45,
    "localidad": "La Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 46,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 47,
    "localidad": "San José Regla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 48,
    "localidad": "Santa Elena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 50,
    "localidad": "Tepezala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 51,
    "localidad": "El Tizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 52,
    "localidad": "Yerbabuena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 54,
    "localidad": "Cruz Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 55,
    "localidad": "El Jilotillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 56,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 58,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 59,
    "localidad": "Tlaxcalera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 60,
    "localidad": "Tonteopa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 61,
    "localidad": "El Tunal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 65,
    "localidad": "Barranca del Xúchil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 66,
    "localidad": "Barranca de Tlaxocoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 67,
    "localidad": "Bosque Real"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 68,
    "localidad": "San Pablo Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 70,
    "localidad": "El Huariche"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 71,
    "localidad": "Las Mesas de Tlaxocoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 72,
    "localidad": "La Bolsa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 73,
    "localidad": "El Dongo Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 74,
    "localidad": "La Hacienda Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 75,
    "localidad": "Jarillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 76,
    "localidad": "La Nogalera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 77,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 78,
    "localidad": "La Laguna San Bartolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 79,
    "localidad": "San Ignacio Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 80,
    "localidad": "El Dongo Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 81,
    "localidad": "Mario Díaz Guzmán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 82,
    "localidad": "Cerro del Tezontle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 24,
    "municipio": "Huasca de Ocampo",
    "claveLocalidad": 83,
    "localidad": "El Contento"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 1,
    "localidad": "Huautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 2,
    "localidad": "Acatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 3,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 4,
    "localidad": "Ahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 5,
    "localidad": "Ahuehuetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 6,
    "localidad": "Aquetzpalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 7,
    "localidad": "Banderas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 8,
    "localidad": "El Barbecho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 9,
    "localidad": "Los Cerezos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 10,
    "localidad": "Coamitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 11,
    "localidad": "Coapantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 12,
    "localidad": "Coatzacoatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 13,
    "localidad": "Coatzonco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 14,
    "localidad": "El Cojolite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 15,
    "localidad": "Coatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 16,
    "localidad": "Coatenahuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 17,
    "localidad": "Chalacuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 18,
    "localidad": "Chalingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 19,
    "localidad": "Chiatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 20,
    "localidad": "Chiliteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 21,
    "localidad": "Chipila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 22,
    "localidad": "Hernandeztla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 23,
    "localidad": "Huemaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 24,
    "localidad": "Huitzotlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 25,
    "localidad": "Ixtlahuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 26,
    "localidad": "El Ixtle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 27,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 28,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 29,
    "localidad": "Metlatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 30,
    "localidad": "Pahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 31,
    "localidad": "El Pajonal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 32,
    "localidad": "Pepeyoca de Cabrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 33,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 34,
    "localidad": "Piltepeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 35,
    "localidad": "Los Puentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 36,
    "localidad": "Huazalinguillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 37,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 38,
    "localidad": "Tamoyón I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 39,
    "localidad": "Tamoyón II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 40,
    "localidad": "Tecoluco Calpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 41,
    "localidad": "Tempexquisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 42,
    "localidad": "Tepeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 43,
    "localidad": "Tepetzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 44,
    "localidad": "Tepexquimitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 46,
    "localidad": "Tlacuapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 47,
    "localidad": "Tohuaco Amatzintla (Tohuaco III)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 48,
    "localidad": "Tohuaco I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 49,
    "localidad": "Tohuaco II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 50,
    "localidad": "Tzacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 51,
    "localidad": "Tzocohuijapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 52,
    "localidad": "Vinasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 53,
    "localidad": "Xóchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 54,
    "localidad": "Zacatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 55,
    "localidad": "14 de Mayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 58,
    "localidad": "Axtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 59,
    "localidad": "Terrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 60,
    "localidad": "La Puerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 61,
    "localidad": "El Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 63,
    "localidad": "21 de Enero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 67,
    "localidad": "Tlalpane"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 68,
    "localidad": "Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 69,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 70,
    "localidad": "Puantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 71,
    "localidad": "Barrio Hondo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 72,
    "localidad": "Barrio Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 73,
    "localidad": "Los Coyoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 74,
    "localidad": "Machín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 75,
    "localidad": "Machín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 76,
    "localidad": "Sin Nombre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 77,
    "localidad": "Texojol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 25,
    "municipio": "Huautla",
    "claveLocalidad": 78,
    "localidad": "Fraccionamiento Nuñez Soto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 1,
    "localidad": "Huazalingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 3,
    "localidad": "Amaxac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 4,
    "localidad": "Ameyalol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 7,
    "localidad": "Cuamontax"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 9,
    "localidad": "Comala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 10,
    "localidad": "Copaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 11,
    "localidad": "Coaxocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 13,
    "localidad": "Chiatipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 14,
    "localidad": "Huilotitla I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 16,
    "localidad": "Ixtlahuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 17,
    "localidad": "Mazahapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 18,
    "localidad": "Otecoch"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 21,
    "localidad": "Pilchiatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 23,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 24,
    "localidad": "San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 25,
    "localidad": "San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 26,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 27,
    "localidad": "Santo Tomás (Cuaxahual)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 32,
    "localidad": "Tepancahuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 33,
    "localidad": "Tepemaxac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 36,
    "localidad": "Tetlicuil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 39,
    "localidad": "Tlamamala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 40,
    "localidad": "Tlatzonco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 41,
    "localidad": "La Ceiba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 43,
    "localidad": "Tzapotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 46,
    "localidad": "Zoquicualoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 49,
    "localidad": "Ahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 50,
    "localidad": "Congreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 51,
    "localidad": "Copalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 52,
    "localidad": "Nuevo Hidalgo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 54,
    "localidad": "Rancho los Parajes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 55,
    "localidad": "Tahuize"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 56,
    "localidad": "Huilotitla II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 57,
    "localidad": "Chichizoquit"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 59,
    "localidad": "Ahuateno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 60,
    "localidad": "Barrio las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 61,
    "localidad": "Coahuazas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 62,
    "localidad": "Cuahuapilol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 63,
    "localidad": "Mantetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 64,
    "localidad": "Pahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 26,
    "municipio": "Huazalingo",
    "claveLocalidad": 65,
    "localidad": "Rancho la Cumbre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 1,
    "localidad": "Huehuetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 2,
    "localidad": "Acuautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 3,
    "localidad": "San Lorenzo Achiotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 4,
    "localidad": "Agua de los Monos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 5,
    "localidad": "Barrio Aztlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 6,
    "localidad": "El Xindho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 7,
    "localidad": "El Borbollón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 8,
    "localidad": "El Bosque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 9,
    "localidad": "La Cebolla (Arroyo de las Cebollas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 10,
    "localidad": "Cerro del Tomate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 11,
    "localidad": "Chapingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 12,
    "localidad": "Chintipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 13,
    "localidad": "El Chote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 14,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 15,
    "localidad": "La Esperanza Número Uno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 16,
    "localidad": "La Esperanza Número 2"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 18,
    "localidad": "Hermanos Galeana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 20,
    "localidad": "Juntas Chicas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 21,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 22,
    "localidad": "Loma de Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 23,
    "localidad": "El Ðanjuay (Agua Fría)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 24,
    "localidad": "El Ojital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 25,
    "localidad": "El Ocotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 26,
    "localidad": "El Padhí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 27,
    "localidad": "Palo Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 28,
    "localidad": "El Paraíso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 29,
    "localidad": "La Pimienta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 30,
    "localidad": "El Plan del Recreo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 31,
    "localidad": "Poza Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 32,
    "localidad": "Río Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 33,
    "localidad": "San Ambrosio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 34,
    "localidad": "San Antonio el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 35,
    "localidad": "San Clemente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 36,
    "localidad": "San Esteban"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 37,
    "localidad": "San Gregorio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 38,
    "localidad": "San Guillermo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 39,
    "localidad": "Santa Fe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 40,
    "localidad": "Santa Inés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 41,
    "localidad": "Santa Ursula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 42,
    "localidad": "El Siete"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 43,
    "localidad": "El Tarral"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 44,
    "localidad": "El Tempesquite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 45,
    "localidad": "El Tigre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 46,
    "localidad": "Villahermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 47,
    "localidad": "Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 48,
    "localidad": "El Xoñe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 49,
    "localidad": "La Tortuga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 50,
    "localidad": "Río Beltrán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 51,
    "localidad": "Palo Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 52,
    "localidad": "El Dextho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 53,
    "localidad": "La Piña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 54,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 55,
    "localidad": "Chicontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 58,
    "localidad": "Cerro de la Luna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 59,
    "localidad": "Linda Vista (Mirasol)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 61,
    "localidad": "Las Estrellas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 62,
    "localidad": "El Descansadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 69,
    "localidad": "Los Planes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 70,
    "localidad": "Piedras Negras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 72,
    "localidad": "El Arenal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 73,
    "localidad": "El Cajón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 75,
    "localidad": "El Chacal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 76,
    "localidad": "La Chorrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 77,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 79,
    "localidad": "Dos Caminos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 84,
    "localidad": "Milpa Redonda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 85,
    "localidad": "El Ojite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 86,
    "localidad": "Hacienda el Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 87,
    "localidad": "El Salto del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 88,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 89,
    "localidad": "El Dambó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 90,
    "localidad": "Cantarranas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 91,
    "localidad": "El Chamizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 92,
    "localidad": "Cerro del Caballo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 93,
    "localidad": "El Denxe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 95,
    "localidad": "La Pahua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 96,
    "localidad": "La Pera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 98,
    "localidad": "Piedra Desboronada (Potrero Grande)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 99,
    "localidad": "Tierra Amarilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 100,
    "localidad": "Zicatlan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 101,
    "localidad": "Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 102,
    "localidad": "Cerro de Chapingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 103,
    "localidad": "Los Cubes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 104,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 106,
    "localidad": "Tres Marías"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 107,
    "localidad": "Agua Fría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 108,
    "localidad": "Cantarranas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 109,
    "localidad": "La Esmeralda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 110,
    "localidad": "El Palote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 111,
    "localidad": "La Poza Pelona Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 112,
    "localidad": "Lindavista II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 113,
    "localidad": "La Tuza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 114,
    "localidad": "El Catrín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 115,
    "localidad": "La Loma del Juandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 116,
    "localidad": "Pichclillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 27,
    "municipio": "Huehuetla",
    "claveLocalidad": 117,
    "localidad": "El Rincón de Cantarranas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 1,
    "localidad": "Huejutla de Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 2,
    "localidad": "Atalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 3,
    "localidad": "Acatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 6,
    "localidad": "Acoyotipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 7,
    "localidad": "Acuatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 8,
    "localidad": "Aguacatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 9,
    "localidad": "Ahuatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 10,
    "localidad": "Amaxac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 11,
    "localidad": "Apetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 12,
    "localidad": "Apílol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 13,
    "localidad": "Aquixcuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 14,
    "localidad": "Ateixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 15,
    "localidad": "Axcaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 16,
    "localidad": "Axihuiyo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 17,
    "localidad": "Cacateco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 18,
    "localidad": "Calmecate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 20,
    "localidad": "Candelacta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 21,
    "localidad": "La Candelaria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 22,
    "localidad": "Cececapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 23,
    "localidad": "Coacuilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 24,
    "localidad": "Coamila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 25,
    "localidad": "Cuapaxtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 26,
    "localidad": "Coco Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 27,
    "localidad": "Coco Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 28,
    "localidad": "Cochiscuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 30,
    "localidad": "Cóntepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 31,
    "localidad": "La Corrala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 32,
    "localidad": "Coxhuaco II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 33,
    "localidad": "Coyuco Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 34,
    "localidad": "La Cruz de Zocuiteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 35,
    "localidad": "Cruztitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 36,
    "localidad": "Cuatecómetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 37,
    "localidad": "Cuaxocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 40,
    "localidad": "Chalahuitzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 41,
    "localidad": "Chalahuiyapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 42,
    "localidad": "Chililico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 44,
    "localidad": "Chiquemecatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 45,
    "localidad": "El Chote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 46,
    "localidad": "Ecuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 50,
    "localidad": "Los Horcones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 51,
    "localidad": "Huehuetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 52,
    "localidad": "Huitzacháhuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 53,
    "localidad": "Huitzquilititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 54,
    "localidad": "Humotitla Candelaria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 55,
    "localidad": "Humotitla Coyuco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 56,
    "localidad": "Ixcatepéc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 57,
    "localidad": "Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 58,
    "localidad": "Ixtlahuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 59,
    "localidad": "Lemontitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 61,
    "localidad": "Macuxtepetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 62,
    "localidad": "Machetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 63,
    "localidad": "La Mesa de Limantitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 64,
    "localidad": "Los Otates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 65,
    "localidad": "Oxale"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 66,
    "localidad": "Oxtomal I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 67,
    "localidad": "Ozuluama"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 69,
    "localidad": "Pahuatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 70,
    "localidad": "Palzoquico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 71,
    "localidad": "Panacaxtlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 72,
    "localidad": "Los Parajes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 73,
    "localidad": "El Pemuche"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 75,
    "localidad": "Poxtla Coacuilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 76,
    "localidad": "Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 78,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 79,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 80,
    "localidad": "Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 81,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 82,
    "localidad": "Santa Cruz Coyuco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 83,
    "localidad": "Sitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 84,
    "localidad": "Tacuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 85,
    "localidad": "Tlaltzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 86,
    "localidad": "Tamalcuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 87,
    "localidad": "Teacal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 88,
    "localidad": "Tehuetlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 89,
    "localidad": "Temaxcaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 90,
    "localidad": "Tiocuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 91,
    "localidad": "Tepemalintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 92,
    "localidad": "Tepemaxac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 93,
    "localidad": "Tepexititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 94,
    "localidad": "Tepoxteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 96,
    "localidad": "Terrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 98,
    "localidad": "Tetzacual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 99,
    "localidad": "Tlalnepanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 101,
    "localidad": "Xilipatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 102,
    "localidad": "Xionaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 103,
    "localidad": "Xiquila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 104,
    "localidad": "Xocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 106,
    "localidad": "Xochitzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 108,
    "localidad": "Acayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 110,
    "localidad": "Zohuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 111,
    "localidad": "Congreso Permanente Agrario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 112,
    "localidad": "Acuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 113,
    "localidad": "Acuitatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 114,
    "localidad": "Achichípil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 116,
    "localidad": "Tezóhual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 118,
    "localidad": "Los Parajes Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 119,
    "localidad": "Ixcuicuila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 121,
    "localidad": "El Xuchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 123,
    "localidad": "Las Chacas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 125,
    "localidad": "Chilcoaloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 127,
    "localidad": "Cuachiquiapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 128,
    "localidad": "Pitzontzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 129,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 130,
    "localidad": "Tancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 131,
    "localidad": "Tepeica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 132,
    "localidad": "Tepeyacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 133,
    "localidad": "Zacapetlayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 134,
    "localidad": "Zapotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 135,
    "localidad": "Xiloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 137,
    "localidad": "Tepeolol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 142,
    "localidad": "Coyoltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 143,
    "localidad": "Ahuatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 144,
    "localidad": "Ahuacahíxpa Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 146,
    "localidad": "Cocumul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 148,
    "localidad": "Nepalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 149,
    "localidad": "Ahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 150,
    "localidad": "Octatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 151,
    "localidad": "Tachiquilzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 152,
    "localidad": "Atappa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 153,
    "localidad": "Cacatetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 155,
    "localidad": "Amoyahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 156,
    "localidad": "Coyotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 157,
    "localidad": "Pahuatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 173,
    "localidad": "Chachaixpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 175,
    "localidad": "Aguacatitla Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 176,
    "localidad": "Atexaltipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 179,
    "localidad": "Las Conchitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 180,
    "localidad": "Coyoltzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 182,
    "localidad": "Ecuatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 183,
    "localidad": "La Esperanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 184,
    "localidad": "Huacaxtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 185,
    "localidad": "Las Nueces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 186,
    "localidad": "Poxtla Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 188,
    "localidad": "Santa Martha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 189,
    "localidad": "Tepetate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 191,
    "localidad": "La Curva Tlaltzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 192,
    "localidad": "Zocuiteco Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 193,
    "localidad": "Chomaquico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 194,
    "localidad": "Coxhuaco I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 195,
    "localidad": "Granja el Chocoyo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 196,
    "localidad": "Ilamactla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 197,
    "localidad": "Pochotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 198,
    "localidad": "Colonia Rancho la Güera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 199,
    "localidad": "Colonia Tepoxtequito Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 200,
    "localidad": "Tetzahapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 201,
    "localidad": "Xochititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 202,
    "localidad": "Xoloxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 203,
    "localidad": "Zacayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 204,
    "localidad": "Zapotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 205,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 206,
    "localidad": "Corral Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 207,
    "localidad": "Escuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 208,
    "localidad": "Ahuehuetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 209,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 210,
    "localidad": "Palzoquiapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 211,
    "localidad": "San José Anexo Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 212,
    "localidad": "Rancho Nuevo Macuxtepetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 213,
    "localidad": "Ahuatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 215,
    "localidad": "Cochiscuatitla Anexo Ixcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 216,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 217,
    "localidad": "Aquexquillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 218,
    "localidad": "Cececámel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 219,
    "localidad": "Chacatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 220,
    "localidad": "Charco Azul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 221,
    "localidad": "Ejido de Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 222,
    "localidad": "El Crucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 223,
    "localidad": "La Garita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 224,
    "localidad": "Machetla II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 225,
    "localidad": "El Ojite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 226,
    "localidad": "Oxtomal II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 227,
    "localidad": "Las Palomitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 228,
    "localidad": "Parque de Poblamiento Solidaridad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 229,
    "localidad": "Talnepantipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 230,
    "localidad": "Tehuetlanito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 231,
    "localidad": "Tilcalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 232,
    "localidad": "Capáne"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 233,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 235,
    "localidad": "Las Chacas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 236,
    "localidad": "Atecala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 237,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 238,
    "localidad": "Ojtlamekayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 239,
    "localidad": "Santa Ana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 240,
    "localidad": "Universidad Tecnológica de la Huasteca Hidalguense"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 241,
    "localidad": "Xochiatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 242,
    "localidad": "Coxcatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 243,
    "localidad": "Malila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 244,
    "localidad": "El Naranjito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 245,
    "localidad": "Xinamixca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 246,
    "localidad": "Acoyotipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 247,
    "localidad": "Barrio los Cubes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 248,
    "localidad": "El Plan de Tlalnepanco (La Explanada)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 249,
    "localidad": "El Puente (El Vado)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 250,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 251,
    "localidad": "Tlamaya Tepeica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 252,
    "localidad": "La Mesa de Axcaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 253,
    "localidad": "Ahuehuetitla Fraccionamiento"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 28,
    "municipio": "Huejutla de Reyes",
    "claveLocalidad": 254,
    "localidad": "Tamaya Ahuehuetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 1,
    "localidad": "Huichapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 2,
    "localidad": "El Apartadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 3,
    "localidad": "Colonia Guadalupe el Astillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 4,
    "localidad": "Bondojito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 5,
    "localidad": "Boye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 6,
    "localidad": "El Cajón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 7,
    "localidad": "El Carmen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 8,
    "localidad": "Hacienda Comodeje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 9,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 10,
    "localidad": "Dandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 11,
    "localidad": "Dantzibojay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 12,
    "localidad": "Dongoteay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 13,
    "localidad": "Dothi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 14,
    "localidad": "Huixcazdha (La Manga)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 15,
    "localidad": "Jonacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 16,
    "localidad": "Llano Largo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 17,
    "localidad": "Mamithi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 18,
    "localidad": "Maney"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 19,
    "localidad": "Maxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 20,
    "localidad": "Hacienda Mintho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 21,
    "localidad": "Pedregoso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 22,
    "localidad": "La Sabinita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 23,
    "localidad": "Sabina Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 24,
    "localidad": "San José Atlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 25,
    "localidad": "El Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 26,
    "localidad": "Tagui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 27,
    "localidad": "Taxqui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 28,
    "localidad": "El Tendido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 29,
    "localidad": "Tlaxcalilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 30,
    "localidad": "Vitejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 31,
    "localidad": "Xajay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 32,
    "localidad": "Yonthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 33,
    "localidad": "Zamorano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 34,
    "localidad": "Zequeteje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 35,
    "localidad": "Zothe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 36,
    "localidad": "La Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 37,
    "localidad": "Estación Huichapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 38,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 39,
    "localidad": "Rancho las Rosas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 40,
    "localidad": "Rancho Taxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 41,
    "localidad": "Rancho Atobomu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 42,
    "localidad": "El Divisadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 43,
    "localidad": "Comodeje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 44,
    "localidad": "Huisfhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 46,
    "localidad": "Monte Alegre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 47,
    "localidad": "El Gavillero de Mintho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 48,
    "localidad": "Chile Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 49,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 50,
    "localidad": "El Charco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 51,
    "localidad": "El Refugio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 52,
    "localidad": "Rancho San Francisco el Tenyoy (El Tenyoy)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 53,
    "localidad": "Hacienda Huiscaxdha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 55,
    "localidad": "El Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 60,
    "localidad": "La Manzana del Tendido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 62,
    "localidad": "Las Bóvedas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 64,
    "localidad": "Campamento el Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 65,
    "localidad": "Cangadho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 66,
    "localidad": "El Cerrito de las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 67,
    "localidad": "Chichimequillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 68,
    "localidad": "La Cienega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 69,
    "localidad": "Hacienda el Cocol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 70,
    "localidad": "La Cueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 72,
    "localidad": "Dexcadho (Peña Azul)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 73,
    "localidad": "Presa Francisco I. Madero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 77,
    "localidad": "Rancho la Manga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 78,
    "localidad": "Rancho el Membrillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 79,
    "localidad": "La Mesita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 80,
    "localidad": "Pathecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 82,
    "localidad": "San Isidro el Astillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 83,
    "localidad": "San José (Rancho los Jaramillo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 84,
    "localidad": "Santa Bárbara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 86,
    "localidad": "Taxanghu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 88,
    "localidad": "Xindho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 89,
    "localidad": "Zethe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 90,
    "localidad": "Ejido de Huichapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 91,
    "localidad": "Tecofani"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 92,
    "localidad": "Ðatu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 93,
    "localidad": "San Mateo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 96,
    "localidad": "El Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 97,
    "localidad": "Casa Nueva (San Isidro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 98,
    "localidad": "La Bóveda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 99,
    "localidad": "Chimpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 100,
    "localidad": "La Crucita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 101,
    "localidad": "El Dextho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 102,
    "localidad": "Ejido de Maxtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 103,
    "localidad": "Barrio Xindho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 105,
    "localidad": "Fonda Capricornio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 106,
    "localidad": "Potrero Doninghu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 107,
    "localidad": "Rancho Dandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 108,
    "localidad": "Rancho la Venta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 109,
    "localidad": "San José Boye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 110,
    "localidad": "Las Sábilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 111,
    "localidad": "El Tejocote San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 113,
    "localidad": "El Sitio (Las Fuentes)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 114,
    "localidad": "Lagunillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 115,
    "localidad": "Rosendo Aces Quintanar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 116,
    "localidad": "Barrio Macuathi (Barrio Guadalupe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 117,
    "localidad": "Barrio San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 118,
    "localidad": "Barrio San Juan Mandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 119,
    "localidad": "El Betel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 120,
    "localidad": "Las Fracciones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 121,
    "localidad": "Granjas San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 122,
    "localidad": "La Güera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 123,
    "localidad": "El Jarillal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 124,
    "localidad": "Juandhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 125,
    "localidad": "Los Pirules"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 126,
    "localidad": "El Bintzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 127,
    "localidad": "Ejido de Pedregoso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 29,
    "municipio": "Huichapan",
    "claveLocalidad": 128,
    "localidad": "La Siempreviva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 1,
    "localidad": "Ixmiquilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 2,
    "localidad": "El Alberto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 3,
    "localidad": "Arenalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 4,
    "localidad": "Bangandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 5,
    "localidad": "El Banxu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 6,
    "localidad": "Boxhuada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 7,
    "localidad": "Cantamaye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 8,
    "localidad": "Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 9,
    "localidad": "Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 10,
    "localidad": "Cerro Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 11,
    "localidad": "Cuesta Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 12,
    "localidad": "El Defay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 13,
    "localidad": "El Dexthi Alberto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 14,
    "localidad": "El Dexthi San Juanico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 15,
    "localidad": "El Dextho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 16,
    "localidad": "Dios Padre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 17,
    "localidad": "El Espino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 18,
    "localidad": "El Espíritu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 19,
    "localidad": "La Estación"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 21,
    "localidad": "Granaditas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 22,
    "localidad": "Gundho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 23,
    "localidad": "La Heredad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 24,
    "localidad": "El Huacri"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 25,
    "localidad": "Ignacio López Rayón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 26,
    "localidad": "Julián Villagrán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 27,
    "localidad": "La Lagunita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 28,
    "localidad": "Maguey Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 29,
    "localidad": "El Mandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 31,
    "localidad": "Nequeteje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 32,
    "localidad": "El Nith"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 33,
    "localidad": "El Olivo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 34,
    "localidad": "Orizabita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 35,
    "localidad": "Panales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 36,
    "localidad": "La Pechuga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 38,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 39,
    "localidad": "Puerto Dexthi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 41,
    "localidad": "Los Remedios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 42,
    "localidad": "San Andrés Orizabita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 43,
    "localidad": "San Juanico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 46,
    "localidad": "El Tablón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 47,
    "localidad": "Taxadho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 48,
    "localidad": "El Tephe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 49,
    "localidad": "Agua Florida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 50,
    "localidad": "Cañada Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 51,
    "localidad": "Chalmita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 52,
    "localidad": "El Dezha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 53,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 55,
    "localidad": "Jahuey Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 56,
    "localidad": "El Manantial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 57,
    "localidad": "El Meje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 58,
    "localidad": "Naxthey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 59,
    "localidad": "Ojuelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 61,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 62,
    "localidad": "San Pedro Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 63,
    "localidad": "Quixpedhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 64,
    "localidad": "Ustheje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 65,
    "localidad": "Colonia Samayoa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 66,
    "localidad": "El Barrido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 67,
    "localidad": "Cantinela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 69,
    "localidad": "La Loma de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 75,
    "localidad": "El Deca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 96,
    "localidad": "Exhacienda de Ocotza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 97,
    "localidad": "Colonia General Felipe Angeles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 99,
    "localidad": "Botenguedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 100,
    "localidad": "Ex Hacienda Debodhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 101,
    "localidad": "Colonia Lázaro Cárdenas (El Internado)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 102,
    "localidad": "La Loma de Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 103,
    "localidad": "La Loma Julián Villagrán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 104,
    "localidad": "La Loma (La Loma López Rayón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 105,
    "localidad": "López Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 107,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 108,
    "localidad": "Taxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 109,
    "localidad": "Xaxny"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 110,
    "localidad": "El Boye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 111,
    "localidad": "Las Emes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 112,
    "localidad": "Huapilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 113,
    "localidad": "La Huerta Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 114,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 115,
    "localidad": "Milpa Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 116,
    "localidad": "El Nandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 117,
    "localidad": "El Nogal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 118,
    "localidad": "Paredes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 119,
    "localidad": "Los Pinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 120,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 121,
    "localidad": "El Valante"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 122,
    "localidad": "Vázquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 123,
    "localidad": "Pozo el Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 124,
    "localidad": "El Botho (El Botho el Espíritu)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 125,
    "localidad": "Colonia el Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 126,
    "localidad": "Alamo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 127,
    "localidad": "El Bojay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 128,
    "localidad": "Casa Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 129,
    "localidad": "Colonia los Cruces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 130,
    "localidad": "Gastejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 131,
    "localidad": "Huacri de la Paz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 132,
    "localidad": "Villa de la Paz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 133,
    "localidad": "Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 134,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 135,
    "localidad": "Manzana Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 136,
    "localidad": "Loma de San Pedro de Remedios (La Loma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 137,
    "localidad": "Santa Ana (Barrio de Progreso)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 138,
    "localidad": "Arbolado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 139,
    "localidad": "El Rosario Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 140,
    "localidad": "Nixtejhé (San Juanico Nixtejhé)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 141,
    "localidad": "Manzanillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 142,
    "localidad": "La Libertad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 143,
    "localidad": "Independencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 144,
    "localidad": "El Puerto de Bangandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 30,
    "municipio": "Ixmiquilpan",
    "claveLocalidad": 145,
    "localidad": "Cerrito Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 1,
    "localidad": "Jacala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 3,
    "localidad": "Agua Fría Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 5,
    "localidad": "Barranca Arriba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 7,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 8,
    "localidad": "El Cedral"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 9,
    "localidad": "Coñecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 10,
    "localidad": "Cuesta Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 11,
    "localidad": "Los Duraznos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 13,
    "localidad": "Hilojuanico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 14,
    "localidad": "Los Hoyos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 15,
    "localidad": "José María Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 16,
    "localidad": "Laguna Seca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 17,
    "localidad": "Llanitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 18,
    "localidad": "La Mohonera (La Colmena)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 19,
    "localidad": "Mesa de la Cebada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 20,
    "localidad": "Minas Viejas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 21,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 22,
    "localidad": "Octupilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 23,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 24,
    "localidad": "Palos Pintados"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 25,
    "localidad": "Peña Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 27,
    "localidad": "El Pinalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 28,
    "localidad": "Plomosas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 29,
    "localidad": "Quetzalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 30,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 31,
    "localidad": "El Refugio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 32,
    "localidad": "Rincón del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 33,
    "localidad": "San Nicolás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 34,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 35,
    "localidad": "El Sótano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 37,
    "localidad": "Joya de Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 38,
    "localidad": "Joya de las Aguilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 41,
    "localidad": "Puerto del Mezquite (La Calera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 42,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 43,
    "localidad": "Carrizalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 44,
    "localidad": "Comatitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 45,
    "localidad": "Vado Hondo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 46,
    "localidad": "Puerto de la Zorra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 47,
    "localidad": "Puerto los Frijoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 48,
    "localidad": "Agua Fría Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 49,
    "localidad": "El Arenal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 51,
    "localidad": "Oteros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 52,
    "localidad": "El Piñón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 53,
    "localidad": "El Calvario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 54,
    "localidad": "Puerto de  Horcones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 56,
    "localidad": "La Sabinita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 58,
    "localidad": "Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 59,
    "localidad": "El Macoque (La Mesa del Huizachal)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 60,
    "localidad": "La Sabina (El Capulín)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 61,
    "localidad": "Las Vetas (Tierra Negra)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 62,
    "localidad": "Toribio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 63,
    "localidad": "El Aguaje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 64,
    "localidad": "Puerto el Rancho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 31,
    "municipio": "Jacala de Ledezma",
    "claveLocalidad": 65,
    "localidad": "El Polvorín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 1,
    "localidad": "Jaltocán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 2,
    "localidad": "Amáxac I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 3,
    "localidad": "La Capilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 4,
    "localidad": "Cuatecomaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 5,
    "localidad": "El Chote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 6,
    "localidad": "Huichapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 8,
    "localidad": "Matachilillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 9,
    "localidad": "Octatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 10,
    "localidad": "Petacotita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 13,
    "localidad": "Vinazco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 14,
    "localidad": "Ahuayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 16,
    "localidad": "La Ilusión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 20,
    "localidad": "Amáxac II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 21,
    "localidad": "Tepexicuicuil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 22,
    "localidad": "La Ceiba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 23,
    "localidad": "Chiconcoac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 24,
    "localidad": "Potrero Zactipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 25,
    "localidad": "Anacleto Ramos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 26,
    "localidad": "Revolución Mexicana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 28,
    "localidad": "Cuatzatzas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 29,
    "localidad": "Tzinancatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 31,
    "localidad": "El Cafetal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 32,
    "localidad": "Xalamaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 33,
    "localidad": "La Lima"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 34,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 35,
    "localidad": "Tepexica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 36,
    "localidad": "Tetzinatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 37,
    "localidad": "Aguacatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 32,
    "municipio": "Jaltocán",
    "claveLocalidad": 38,
    "localidad": "Terrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 1,
    "localidad": "Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 2,
    "localidad": "San Lorenzo Itztacoyotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 3,
    "localidad": "San Nicolás Coatzontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 4,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 5,
    "localidad": "Tonalixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 7,
    "localidad": "Los Tejocotes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 8,
    "localidad": "Acatitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 11,
    "localidad": "Tetipanchalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 12,
    "localidad": "Sotiopa (El Dolar)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 14,
    "localidad": "Zoquilquiza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 15,
    "localidad": "Cuayacapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 16,
    "localidad": "Tlalostoteno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 17,
    "localidad": "Xochaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 18,
    "localidad": "Tenexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 33,
    "municipio": "Juárez Hidalgo",
    "claveLocalidad": 19,
    "localidad": "Rancho Hernández (Xochipila)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 1,
    "localidad": "Lolotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 2,
    "localidad": "Acatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 3,
    "localidad": "Amecaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 4,
    "localidad": "Atla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 5,
    "localidad": "Santa Cruz Ayotetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 6,
    "localidad": "El Barco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 7,
    "localidad": "Capultitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 8,
    "localidad": "Comontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 9,
    "localidad": "Contepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 10,
    "localidad": "El Coyol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 11,
    "localidad": "Coatetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 12,
    "localidad": "Cuatitlanapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 13,
    "localidad": "Chalma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 14,
    "localidad": "Chantasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 15,
    "localidad": "Chiconcoac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 16,
    "localidad": "Chiquitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 17,
    "localidad": "La Florida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 18,
    "localidad": "Huitznopala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 19,
    "localidad": "Ixtacuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 20,
    "localidad": "Ixtlahuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 21,
    "localidad": "Mazahuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 22,
    "localidad": "Mecapala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 23,
    "localidad": "Ocotlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 24,
    "localidad": "La Pimienta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 25,
    "localidad": "Quimixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 26,
    "localidad": "Santiago"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 27,
    "localidad": "Tentla (Cerro Blanco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 28,
    "localidad": "Tepazintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 29,
    "localidad": "Tetlapaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 30,
    "localidad": "Tlacozintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 31,
    "localidad": "Tlaltepingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 32,
    "localidad": "Xalcuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 33,
    "localidad": "Xuchipantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 34,
    "localidad": "Xuchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 35,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 36,
    "localidad": "Aquixquitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 37,
    "localidad": "Chicazapa (Pilancón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 39,
    "localidad": "La Pahua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 40,
    "localidad": "Las Puentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 41,
    "localidad": "Atoscalao"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 42,
    "localidad": "El Vergel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 43,
    "localidad": "El Chalahuite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 44,
    "localidad": "Los Otates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 45,
    "localidad": "Texacal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 47,
    "localidad": "Las Adjuntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 48,
    "localidad": "Ixtlapalaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 49,
    "localidad": "Nopayahuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 50,
    "localidad": "Tecamachal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 51,
    "localidad": "Tequixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 52,
    "localidad": "Tlamaxa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 53,
    "localidad": "Tlaxcango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 54,
    "localidad": "Totonicapa(Tlamaya)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 55,
    "localidad": "Zihuatego (Ohuesco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 56,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 57,
    "localidad": "Tenquiquixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 59,
    "localidad": "Chalchocotipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 60,
    "localidad": "Crisolco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 61,
    "localidad": "Cuaxala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 62,
    "localidad": "Cero Boludo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 63,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 34,
    "municipio": "Lolotla",
    "claveLocalidad": 64,
    "localidad": "Potrero Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 1,
    "localidad": "Metepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 2,
    "localidad": "El Acocul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 3,
    "localidad": "Atlixtaca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 4,
    "localidad": "Buena  Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 5,
    "localidad": "Cañada de Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 6,
    "localidad": "El Casco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 7,
    "localidad": "Acocul Cebolletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 8,
    "localidad": "El Chamizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 9,
    "localidad": "Ferrería de Apulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 11,
    "localidad": "Majadillas (Loma Bonita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 12,
    "localidad": "Mesillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 13,
    "localidad": "Nopalillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 14,
    "localidad": "Palo Gordo (Ejido Nopalillo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 15,
    "localidad": "Peña Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 16,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 17,
    "localidad": "Estación de Apulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 18,
    "localidad": "San Antonio la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 19,
    "localidad": "San José Palmillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 20,
    "localidad": "San Salvador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 21,
    "localidad": "Temaxcalillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 22,
    "localidad": "Tortugas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 23,
    "localidad": "El Vesubio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 24,
    "localidad": "La Victoria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 25,
    "localidad": "Zacatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 26,
    "localidad": "Palo Gacho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 27,
    "localidad": "Colonia Ignacio Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 28,
    "localidad": "El Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 29,
    "localidad": "San Diego"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 31,
    "localidad": "Colonia Nueva Ex Hacienda de Apulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 32,
    "localidad": "Las Trojas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 33,
    "localidad": "La Loma de Metepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 34,
    "localidad": "Metepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 35,
    "localidad": "Ejido Apulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 36,
    "localidad": "El Tanque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 37,
    "localidad": "Ejido de Majadillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 35,
    "municipio": "Metepec",
    "claveLocalidad": 38,
    "localidad": "Mesillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 1,
    "localidad": "Mezquititlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 2,
    "localidad": "Agua Bendita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 3,
    "localidad": "Los Alamos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 4,
    "localidad": "Arroyo Hondo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 5,
    "localidad": "Atecoxco (San Nicolás Atecoxco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 6,
    "localidad": "Carpinteros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 7,
    "localidad": "Carrizal Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 8,
    "localidad": "Cieneguillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 9,
    "localidad": "Chichinapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 10,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 11,
    "localidad": "Milpillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 12,
    "localidad": "Ocuilcalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 13,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 14,
    "localidad": "San Juan Cuahutengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 15,
    "localidad": "Tuzanapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 16,
    "localidad": "El Veladero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 17,
    "localidad": "Venados"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 18,
    "localidad": "Santa María Xoxoteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 19,
    "localidad": "Yerbabuena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 20,
    "localidad": "Zahuastipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 21,
    "localidad": "El Tular"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 22,
    "localidad": "La Almarciguera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 23,
    "localidad": "Apartadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 24,
    "localidad": "El Banco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 25,
    "localidad": "Barrio Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 26,
    "localidad": "La Camelia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 27,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 28,
    "localidad": "El Enzuelado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 29,
    "localidad": "Loma la Pareja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 30,
    "localidad": "Llano de las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 31,
    "localidad": "Peñas Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 32,
    "localidad": "Rancho Alegre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 34,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 35,
    "localidad": "Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 36,
    "localidad": "La Troja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 37,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 38,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 39,
    "localidad": "El Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 40,
    "localidad": "Las Canoas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 41,
    "localidad": "La Cantera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 42,
    "localidad": "Las Cañaditas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 43,
    "localidad": "Iglesia Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 44,
    "localidad": "Tecorral (Tecorral Chico)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 45,
    "localidad": "El Terrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 46,
    "localidad": "Tlachiquil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 47,
    "localidad": "Axoloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 48,
    "localidad": "La Capilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 36,
    "municipio": "San Agustín Metzquititlán",
    "claveLocalidad": 49,
    "localidad": "El Reparo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 1,
    "localidad": "Metztitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 2,
    "localidad": "Alumbres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 3,
    "localidad": "San Pedro Amajatlán (Amajatlán)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 4,
    "localidad": "La Paila de Anáhuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 5,
    "localidad": "Los Arcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 6,
    "localidad": "Atzolcintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 7,
    "localidad": "Ayacatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 8,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 9,
    "localidad": "Cacalome (Acalome)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 10,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 11,
    "localidad": "Cerro Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 12,
    "localidad": "Coalquizque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 13,
    "localidad": "Coyometeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 14,
    "localidad": "Chimalacatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 15,
    "localidad": "Fontezuelas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 16,
    "localidad": "Hacienda de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 17,
    "localidad": "Huayateno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 18,
    "localidad": "Huistícola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 19,
    "localidad": "Itztayatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 20,
    "localidad": "Itztazacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 21,
    "localidad": "La Cumbre Jagüey Seco (Jagüey Seco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 22,
    "localidad": "Jihuico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 23,
    "localidad": "Jiliapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 24,
    "localidad": "Jilotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 26,
    "localidad": "La Mesa Grande (Mesa Grande)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 27,
    "localidad": "Metznoxtla (Metznoztla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 28,
    "localidad": "Milpa Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 29,
    "localidad": "Olotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 30,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 31,
    "localidad": "El Pedregal de Zaragoza (El Pedregal)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 32,
    "localidad": "El Pirú Tepozotlán (El Pirú)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 33,
    "localidad": "Pontadhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 35,
    "localidad": "Rincón de Coalquixque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 37,
    "localidad": "El Salitre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 38,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 39,
    "localidad": "San Juan Metztitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 40,
    "localidad": "San Juan Tlatepexi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 41,
    "localidad": "San Pablo Tetlapayac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 42,
    "localidad": "San Pedro Ayotoxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 43,
    "localidad": "San Pedro Tlatemalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 44,
    "localidad": "Santa Mónica Autempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 45,
    "localidad": "El Tablón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 46,
    "localidad": "Tecruz de Anáhuac (Tecruz de Jihuico)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 47,
    "localidad": "Tepatetipa (San Agustín Tepatetipa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 49,
    "localidad": "Tezochuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 50,
    "localidad": "Tlacotepec (Cerrito de Tlacotepec)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 51,
    "localidad": "Tlamaxa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 52,
    "localidad": "Tlamaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 53,
    "localidad": "Tlatepexe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 54,
    "localidad": "Tlaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 55,
    "localidad": "Tlazoquitipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 56,
    "localidad": "Tolapa (Santiago Tolapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 57,
    "localidad": "Tres Cruces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 58,
    "localidad": "Zoquiteno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 59,
    "localidad": "Zoquizoquipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 60,
    "localidad": "Zotola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 61,
    "localidad": "Zotoltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 62,
    "localidad": "Agua Hedeonda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 64,
    "localidad": "Cerro Partido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 65,
    "localidad": "El Escobal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 66,
    "localidad": "Estocuapa (La Colmena)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 67,
    "localidad": "El Mamtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 68,
    "localidad": "El Meje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 69,
    "localidad": "San Antonio Tlaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 70,
    "localidad": "Palo Blanco (Cacaloco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 71,
    "localidad": "Pie de la Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 72,
    "localidad": "Pilas y Granadas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 73,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 74,
    "localidad": "Tablón Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 75,
    "localidad": "Tecruz Cozapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 76,
    "localidad": "Tierra Nueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 77,
    "localidad": "Tochintla (Chipeco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 83,
    "localidad": "Apanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 84,
    "localidad": "Atzingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 85,
    "localidad": "El Banco (La Cumbre de Huistícola)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 87,
    "localidad": "Hacienda de Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 88,
    "localidad": "Higueras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 89,
    "localidad": "Joya de Analco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 90,
    "localidad": "Loma Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 92,
    "localidad": "Loma Cuata (La Cumbre de Loma Cuata)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 93,
    "localidad": "Macuila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 94,
    "localidad": "Meztititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 95,
    "localidad": "Miahuatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 96,
    "localidad": "Potrero de Camacho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 97,
    "localidad": "Las Presas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 98,
    "localidad": "Puerto de las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 99,
    "localidad": "Rincón Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 100,
    "localidad": "La Rivera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 101,
    "localidad": "Tepetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 102,
    "localidad": "Tezisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 103,
    "localidad": "Tepecahuantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 104,
    "localidad": "Yerbabuena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 107,
    "localidad": "Rincón de Santa Cruz (Santa Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 108,
    "localidad": "Cerro Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 109,
    "localidad": "Rincón Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 110,
    "localidad": "Huiloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 113,
    "localidad": "Apanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 114,
    "localidad": "El Arenal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 115,
    "localidad": "Barrio de Quinjuá"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 116,
    "localidad": "El Damhú"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 117,
    "localidad": "Huixastla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 118,
    "localidad": "La Laja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 119,
    "localidad": "La Laja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 120,
    "localidad": "Luisa Vargas Callejas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 121,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 122,
    "localidad": "Pie de la Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 123,
    "localidad": "Pie de la Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 124,
    "localidad": "La Cumbre de Huistícola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 125,
    "localidad": "El Rincón (El Rincón de Ixcoatitla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 126,
    "localidad": "Rosa Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 127,
    "localidad": "Los Terreros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 128,
    "localidad": "Tierra Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 129,
    "localidad": "Tlaxco  Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 130,
    "localidad": "La Trampa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 131,
    "localidad": "Xocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 132,
    "localidad": "Barrio Coatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 133,
    "localidad": "Barrio del Pato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 134,
    "localidad": "Cabeza de Toro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 135,
    "localidad": "El Dezdhá"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 136,
    "localidad": "Cerro Boludo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 138,
    "localidad": "El Potrerillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 139,
    "localidad": "Rancho Nuevo de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 140,
    "localidad": "El Tezontle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 37,
    "municipio": "Metztitlán",
    "claveLocalidad": 141,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 1,
    "localidad": "Mineral del Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 2,
    "localidad": "Cerro Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 3,
    "localidad": "Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 4,
    "localidad": "Carboneras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 5,
    "localidad": "Cebadas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 6,
    "localidad": "Cimbrones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 7,
    "localidad": "La Estanzuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 8,
    "localidad": "El Jaspe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 9,
    "localidad": "Loma del Maguey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 10,
    "localidad": "Llano de los Ajos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 12,
    "localidad": "Manzanas (Barrio de Manzanas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 13,
    "localidad": "Pie de la Viga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 14,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 15,
    "localidad": "El Puente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 16,
    "localidad": "San Antonio el Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 17,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 18,
    "localidad": "San José Capulines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 19,
    "localidad": "San Sebastián Capulines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 20,
    "localidad": "San Simón Lo de Rojas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 21,
    "localidad": "Santa Inés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 22,
    "localidad": "Tierras Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 23,
    "localidad": "Los Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 24,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 25,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 26,
    "localidad": "Barrio Tepozanes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 28,
    "localidad": "Puentecillas (Cueva Blanca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 31,
    "localidad": "Plan Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 32,
    "localidad": "Barrio de la Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 33,
    "localidad": "Puentecillas (La Mesa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 37,
    "localidad": "Rincón Grande (Las Ventanas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 38,
    "localidad": "Bandola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 39,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 41,
    "localidad": "Barrio de los Ocotes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 42,
    "localidad": "La Gran Compaña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 44,
    "localidad": "Las Piletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 38,
    "municipio": "Mineral del Chico",
    "claveLocalidad": 45,
    "localidad": "Tezahuapa (El Río)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 1,
    "localidad": "Mineral del Monte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 2,
    "localidad": "Cabrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 3,
    "localidad": "Ciénega Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 4,
    "localidad": "Barrio de Escobar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 6,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 7,
    "localidad": "San Pedro Huixotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 8,
    "localidad": "Santa Rosalía"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 9,
    "localidad": "Tezoantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 12,
    "localidad": "San Felipe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 14,
    "localidad": "El Jilguero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 16,
    "localidad": "San Agustín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 23,
    "localidad": "Palo Hueco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 26,
    "localidad": "Rufina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 28,
    "localidad": "Calicanto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 29,
    "localidad": "Barrio del Agua Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 30,
    "localidad": "Fraccionamiento Bosques de San Cayetano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 31,
    "localidad": "Los Cajones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 32,
    "localidad": "Rancho Valencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 33,
    "localidad": "Las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 34,
    "localidad": "Fraternidad (La Minita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 35,
    "localidad": "Llano Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 36,
    "localidad": "San Felipe (La Providencia)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 38,
    "localidad": "Agua Bendita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 39,
    "localidad": "San Patricio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 39,
    "municipio": "Mineral del Monte",
    "claveLocalidad": 40,
    "localidad": "La venta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 1,
    "localidad": "La Misión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 2,
    "localidad": "Aguaje de Cerro Prieto (Los Paredones)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 3,
    "localidad": "Agua Zarca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 4,
    "localidad": "Agua Hedionda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 5,
    "localidad": "Alamo de Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 6,
    "localidad": "Alamo de la Misión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 7,
    "localidad": "El Algodón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 10,
    "localidad": "Cerro Frío de Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 11,
    "localidad": "Cerro Prieto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 12,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 13,
    "localidad": "Coñe Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 14,
    "localidad": "Crucita de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 15,
    "localidad": "La Culebra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 16,
    "localidad": "Las Fuentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 17,
    "localidad": "Damathi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 18,
    "localidad": "Encino Largo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 19,
    "localidad": "Escrito de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 20,
    "localidad": "El Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 21,
    "localidad": "La Hondura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 22,
    "localidad": "Jacalilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 24,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 25,
    "localidad": "Lagunita de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 26,
    "localidad": "Loma de Pericón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 27,
    "localidad": "Loma de Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 28,
    "localidad": "Loma de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 29,
    "localidad": "Llano de Boxijhá"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 30,
    "localidad": "Macanguí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 31,
    "localidad": "Macojú"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 32,
    "localidad": "La Mesa del Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 33,
    "localidad": "Mesa del Huizache"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 34,
    "localidad": "Mesa de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 35,
    "localidad": "El Mexe Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 36,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 37,
    "localidad": "El Naranjo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 38,
    "localidad": "Los Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 39,
    "localidad": "Nogal de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 40,
    "localidad": "El Nogalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 41,
    "localidad": "Ocote de Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 42,
    "localidad": "La Palizada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 43,
    "localidad": "Las Palmitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 44,
    "localidad": "Palo Hueco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 45,
    "localidad": "El Paraje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 46,
    "localidad": "Pemuche de Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 47,
    "localidad": "Piedra Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 48,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 49,
    "localidad": "Puertecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 50,
    "localidad": "Puerto de Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 51,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 52,
    "localidad": "El Roa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 53,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 54,
    "localidad": "La Soledad (El Enebro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 55,
    "localidad": "Tierra Caliente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 56,
    "localidad": "Tinaja de Jacalilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 57,
    "localidad": "Vega de la Carrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 58,
    "localidad": "Zipatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 59,
    "localidad": "El Llano (Llano de Jacalilla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 60,
    "localidad": "El Rayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 61,
    "localidad": "Nuevo Linares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 62,
    "localidad": "Las Cañitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 63,
    "localidad": "El Chamal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 64,
    "localidad": "Naranjitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 65,
    "localidad": "Las Adjuntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 66,
    "localidad": "El Balcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 67,
    "localidad": "La Ladera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 68,
    "localidad": "Lagunita de Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 70,
    "localidad": "Loma de Macangui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 71,
    "localidad": "Cerro Frío"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 73,
    "localidad": "Agua Fría Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 74,
    "localidad": "Miraflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 75,
    "localidad": "Barbechos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 76,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 77,
    "localidad": "Cerro Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 78,
    "localidad": "El Hualul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 79,
    "localidad": "Mirador de la Culebra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 80,
    "localidad": "Puerto de la Culebra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 81,
    "localidad": "Puerto de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 82,
    "localidad": "Puerto del Algodón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 84,
    "localidad": "Tepehuaje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 86,
    "localidad": "Arroyo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 87,
    "localidad": "Los Castros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 88,
    "localidad": "Cuartel de Jacalilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 89,
    "localidad": "Curva de San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 90,
    "localidad": "El Fuste"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 91,
    "localidad": "Nogal de Cerro Prieto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 93,
    "localidad": "El Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 94,
    "localidad": "Palo Hueco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 95,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 97,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 98,
    "localidad": "El Mexe Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 99,
    "localidad": "Puerto del Aire"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 100,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 40,
    "municipio": "La Misión",
    "claveLocalidad": 101,
    "localidad": "Vado Hondo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 1,
    "localidad": "Mixquiahuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 2,
    "localidad": "Arbol Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 3,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 4,
    "localidad": "Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 5,
    "localidad": "Carrillo Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 6,
    "localidad": "Jagüey Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 7,
    "localidad": "Colonia Morelos (El Nueve)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 8,
    "localidad": "Motobatha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 9,
    "localidad": "Colonia Palmillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 10,
    "localidad": "Colonia Teñhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 11,
    "localidad": "Tepeitic"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 12,
    "localidad": "Colonia Veracruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 21,
    "localidad": "La Arbolera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 24,
    "localidad": "Dos Cerros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 25,
    "localidad": "Hacienda Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 26,
    "localidad": "El Volador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 27,
    "localidad": "Rancho Viborillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 28,
    "localidad": "El Rodeo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 29,
    "localidad": "El Rodeo Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 30,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 31,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 32,
    "localidad": "Los Colorines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 33,
    "localidad": "Las Azucenas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 34,
    "localidad": "Cinta Larga Sección 22"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 35,
    "localidad": "Colonia 3 de Mayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 36,
    "localidad": "Deshuesadero Márquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 37,
    "localidad": "Emigdio Mera Salas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 38,
    "localidad": "Los Higos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 39,
    "localidad": "Palo Seco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 40,
    "localidad": "La Discordia (Los Bigotones)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 41,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 42,
    "localidad": "Monte Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 41,
    "municipio": "Mixquiahuala de Juárez",
    "claveLocalidad": 43,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 1,
    "localidad": "Molango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 2,
    "localidad": "Acayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 3,
    "localidad": "Acuatitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 4,
    "localidad": "Achocoatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 5,
    "localidad": "Atezca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 6,
    "localidad": "Coachula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 7,
    "localidad": "Cuxhuacan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 8,
    "localidad": "Ixmolintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 9,
    "localidad": "Ixcatlán (San Pedro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 10,
    "localidad": "Ixcotla (Nuevo Ixcotla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 11,
    "localidad": "Ixcuicuila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 12,
    "localidad": "Malila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 13,
    "localidad": "Naopa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 14,
    "localidad": "Ohuezco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 15,
    "localidad": "Pemuxtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 16,
    "localidad": "Piedras Negras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 17,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 18,
    "localidad": "San Bernardo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 19,
    "localidad": "Tehuizco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 20,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 21,
    "localidad": "Tepetlapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 22,
    "localidad": "Tlatzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 23,
    "localidad": "Xicalango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 24,
    "localidad": "Zacuala (Huixquilico)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 25,
    "localidad": "Xuchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 26,
    "localidad": "Molocotlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 27,
    "localidad": "Olotlilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 28,
    "localidad": "Zacapetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 29,
    "localidad": "Puerto Tlamaxa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 30,
    "localidad": "Satiopa (Rancho Nahuiopan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 31,
    "localidad": "Tepeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 33,
    "localidad": "Tzacatzonco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 34,
    "localidad": "Acatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 35,
    "localidad": "Acoyotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 36,
    "localidad": "Chicoyotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 37,
    "localidad": "Cuacomol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 38,
    "localidad": "Tecuaqueo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 40,
    "localidad": "Xalango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 42,
    "localidad": "Zoyatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 43,
    "localidad": "Temacuil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 44,
    "localidad": "Acatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 45,
    "localidad": "Acatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 46,
    "localidad": "Chayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 47,
    "localidad": "Mina la 300 (Ixtapalapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 48,
    "localidad": "El Plan (Barrio Nuevo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 49,
    "localidad": "Tetipanchalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 50,
    "localidad": "Santo Roa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 51,
    "localidad": "Barrio Tlalaquia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 42,
    "municipio": "Molango de Escamilla",
    "claveLocalidad": 52,
    "localidad": "Cohuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 1,
    "localidad": "Nicolás Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 2,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 3,
    "localidad": "Agua Limpia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 4,
    "localidad": "Bocua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 5,
    "localidad": "La Bonanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 6,
    "localidad": "Cerro de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 7,
    "localidad": "El Cobre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 8,
    "localidad": "Cruz de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 9,
    "localidad": "El Dothu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 10,
    "localidad": "Iglesia Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 11,
    "localidad": "Itatlaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 13,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 14,
    "localidad": "Las Milpas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 15,
    "localidad": "Pijay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 16,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 17,
    "localidad": "Segundo Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 18,
    "localidad": "Puerto de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 19,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 20,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 21,
    "localidad": "Taxhay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 22,
    "localidad": "Texcadho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 23,
    "localidad": "Tedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 24,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 25,
    "localidad": "Villa Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 26,
    "localidad": "Villa Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 27,
    "localidad": "Yudho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 28,
    "localidad": "Zoyatal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 29,
    "localidad": "Jagüey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 30,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 31,
    "localidad": "Cerro Prieto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 32,
    "localidad": "El Molino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 33,
    "localidad": "Pajiadhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 34,
    "localidad": "Segundo Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 35,
    "localidad": "Chibirino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 38,
    "localidad": "Padapho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 40,
    "localidad": "Castadho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 41,
    "localidad": "El Encinote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 42,
    "localidad": "Los Lirios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 43,
    "localidad": "Paso de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 44,
    "localidad": "Piedra de Sal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 45,
    "localidad": "Puerto Cangandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 46,
    "localidad": "Puerto de Higos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 47,
    "localidad": "Puerto las Animas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 48,
    "localidad": "Puerto Menta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 49,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 50,
    "localidad": "Segundo Centro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 43,
    "municipio": "Nicolás Flores",
    "claveLocalidad": 51,
    "localidad": "Barrio del Tedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 1,
    "localidad": "Nopala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 2,
    "localidad": "Batha y Barrios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 3,
    "localidad": "El Borbollón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 4,
    "localidad": "El Capulín de Aragón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 5,
    "localidad": "El Fresno (Casas Viejas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 6,
    "localidad": "El Cedazo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 7,
    "localidad": "Los Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 8,
    "localidad": "Cuaxithi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 9,
    "localidad": "La Cuchilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 10,
    "localidad": "Dañu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 11,
    "localidad": "Denthó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 12,
    "localidad": "Humini"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 13,
    "localidad": "El Jagüey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 14,
    "localidad": "La Laja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 15,
    "localidad": "Loma Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 16,
    "localidad": "Loma del Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 17,
    "localidad": "Loma del Toro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 18,
    "localidad": "El Mangui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 19,
    "localidad": "Maravillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 20,
    "localidad": "Las Manzanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 23,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 24,
    "localidad": "El Pedregoso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 25,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 27,
    "localidad": "La Salita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 29,
    "localidad": "San Lorenzo el Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 30,
    "localidad": "San Sebastián Tenochtitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 31,
    "localidad": "La Siempreviva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 32,
    "localidad": "Taxtejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 33,
    "localidad": "San Sebastián de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 37,
    "localidad": "Las Cruces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 38,
    "localidad": "El Zendho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 39,
    "localidad": "Las Campanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 41,
    "localidad": "La Matanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 43,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 44,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 45,
    "localidad": "El Desierto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 46,
    "localidad": "El Fresnillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 47,
    "localidad": "La Lechuga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 48,
    "localidad": "Venta Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 49,
    "localidad": "Aragón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 50,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 51,
    "localidad": "Los Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 52,
    "localidad": "Santa Rosa el Marquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 54,
    "localidad": "Santa Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 55,
    "localidad": "El Campamento"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 56,
    "localidad": "El Aguila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 57,
    "localidad": "Jesús María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 58,
    "localidad": "Los Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 60,
    "localidad": "Deca Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 61,
    "localidad": "El Deca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 62,
    "localidad": "Dingüichi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 63,
    "localidad": "Escandón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 64,
    "localidad": "La Esperanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 65,
    "localidad": "La Estación"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 68,
    "localidad": "El Gato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 69,
    "localidad": "La Huerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 70,
    "localidad": "La Fuente (Jagüey Blanco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 71,
    "localidad": "El Jazmín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 72,
    "localidad": "La Luz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 73,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 74,
    "localidad": "Palo Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 75,
    "localidad": "Rancho Paye"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 76,
    "localidad": "Peñafiel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 77,
    "localidad": "Puerto Dañu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 78,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 80,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 81,
    "localidad": "San Ignacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 82,
    "localidad": "San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 83,
    "localidad": "San Lorenzo Amarillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 84,
    "localidad": "Santa Catalina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 85,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 86,
    "localidad": "Santa Fe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 87,
    "localidad": "El Sauz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 89,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 90,
    "localidad": "Temascales Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 91,
    "localidad": "El Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 92,
    "localidad": "Las Vegas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 93,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 94,
    "localidad": "Los Nidos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 97,
    "localidad": "El Manantial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 98,
    "localidad": "El Destello"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 99,
    "localidad": "La Martinica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 100,
    "localidad": "Tierra Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 101,
    "localidad": "La Presa Dañu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 102,
    "localidad": "Tequexhido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 108,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 109,
    "localidad": "San Juanita (Casas Viejas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 110,
    "localidad": "El Capulín Dañu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 111,
    "localidad": "Devego"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 112,
    "localidad": "Pachuquilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 113,
    "localidad": "Pedregales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 115,
    "localidad": "Batha del Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 117,
    "localidad": "Pedregales Dañu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 120,
    "localidad": "El Fresno (Casas Viejas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 121,
    "localidad": "La Leña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 123,
    "localidad": "La Pila del León"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 124,
    "localidad": "Inmobiliaria Avícola Pilgrim's Pride"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 125,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 126,
    "localidad": "La Primavera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 127,
    "localidad": "Puerta Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 128,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 129,
    "localidad": "Ojuelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 130,
    "localidad": "Los Caballos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 131,
    "localidad": "Los Pozos (La Presa Vieja)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 132,
    "localidad": "El Mogote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 133,
    "localidad": "Rancho el Charcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 134,
    "localidad": "Rancho la Herradura (Colonia Campesina)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 135,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 136,
    "localidad": "Los Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 44,
    "municipio": "Nopala de Villagrán",
    "claveLocalidad": 137,
    "localidad": "Canutillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 1,
    "localidad": "Omitlán de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 2,
    "localidad": "Agua Fría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 3,
    "localidad": "Santa Rita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 5,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 6,
    "localidad": "Cerro Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 7,
    "localidad": "Ciénega Chica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 8,
    "localidad": "Ciénega Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 9,
    "localidad": "El Comanche"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 10,
    "localidad": "Cruz de Mujer"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 11,
    "localidad": "Cruz de Omitlán (La Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 12,
    "localidad": "Vicente Guerrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 13,
    "localidad": "Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 14,
    "localidad": "Manuel Teniente (El Llano)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 15,
    "localidad": "Mixquiapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 16,
    "localidad": "Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 18,
    "localidad": "El Perico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 19,
    "localidad": "Puentecillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 20,
    "localidad": "Ignacio López Rayón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 21,
    "localidad": "Rincón Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 22,
    "localidad": "San Antonio el Paso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 23,
    "localidad": "Santa Elena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 26,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 27,
    "localidad": "Tres Cañadas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 28,
    "localidad": "Velasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 29,
    "localidad": "Venta de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 30,
    "localidad": "El Mirador (La Coyotera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 31,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 32,
    "localidad": "Cuchilalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 35,
    "localidad": "El Crucero (Crucero de Huasca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 39,
    "localidad": "El Resbalón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 40,
    "localidad": "Agua Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 41,
    "localidad": "El Manzano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 43,
    "localidad": "Los Tapancos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 45,
    "municipio": "Omitlán de Juárez",
    "claveLocalidad": 44,
    "localidad": "Barrio del Calvario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 1,
    "localidad": "Orizatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 3,
    "localidad": "Ahuatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 4,
    "localidad": "Ahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 5,
    "localidad": "Ahuehuetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 6,
    "localidad": "Ahuaixpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 7,
    "localidad": "Los Altos de San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 8,
    "localidad": "Apaxtzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 9,
    "localidad": "Arroyo de Cal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 12,
    "localidad": "El Brasilar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 14,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 15,
    "localidad": "El Cerro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 16,
    "localidad": "Cuamecaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 17,
    "localidad": "Coaxocotitla II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 18,
    "localidad": "Los Coyoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 20,
    "localidad": "Las Chacas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 21,
    "localidad": "Chancuetlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 23,
    "localidad": "Huextetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 24,
    "localidad": "Hueytlale"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 25,
    "localidad": "Huichintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 26,
    "localidad": "Huitzilinguito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 27,
    "localidad": "Huitzitzilingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 28,
    "localidad": "La Labor I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 29,
    "localidad": "La Labor II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 30,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 31,
    "localidad": "La Laja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 32,
    "localidad": "Lomas Altas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 33,
    "localidad": "Maxcarillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 34,
    "localidad": "La Mesa de Cuatolol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 35,
    "localidad": "Monte Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 36,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 37,
    "localidad": "Nexpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 38,
    "localidad": "El Ojite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 39,
    "localidad": "Palma Sola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 42,
    "localidad": "Petlácatl Comunal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 43,
    "localidad": "Piedra Hincada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 44,
    "localidad": "Las Piedras (Micropolis Ecológica las Piedras)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 45,
    "localidad": "Pilcapilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 46,
    "localidad": "La Pitajaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 47,
    "localidad": "Pochotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 48,
    "localidad": "Potejamel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 49,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 50,
    "localidad": "Los Sabinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 51,
    "localidad": "Santa Ana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 52,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 53,
    "localidad": "El Zapotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 54,
    "localidad": "Talapitz I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 55,
    "localidad": "Talol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 56,
    "localidad": "Tamalcuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 57,
    "localidad": "Tatacuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 58,
    "localidad": "Teoxtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 59,
    "localidad": "Tepantitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 60,
    "localidad": "Tepetzintla I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 61,
    "localidad": "Tequexquilico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 62,
    "localidad": "Texcatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 63,
    "localidad": "Taxiscoatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 64,
    "localidad": "Totonicapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 65,
    "localidad": "Tultitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 66,
    "localidad": "Tzapoyo I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 67,
    "localidad": "Las Víboras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 68,
    "localidad": "Xalamakechpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 70,
    "localidad": "Zacayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 71,
    "localidad": "Zapote Arriba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 73,
    "localidad": "Los Jobos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 74,
    "localidad": "La Carolina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 75,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 76,
    "localidad": "Mazaquilico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 77,
    "localidad": "Ejido 3 de Marzo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 78,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 81,
    "localidad": "El Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 84,
    "localidad": "La Mariana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 85,
    "localidad": "Buenos Aires"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 86,
    "localidad": "Santa Clara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 87,
    "localidad": "La Cuchilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 88,
    "localidad": "Las Adjuntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 89,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 91,
    "localidad": "Coyolito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 92,
    "localidad": "Chacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 94,
    "localidad": "Tantoyuquita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 95,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 97,
    "localidad": "Zapote Abajo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 98,
    "localidad": "Los Panales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 99,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 101,
    "localidad": "Tetzácual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 102,
    "localidad": "Los Humos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 103,
    "localidad": "Santa Rosa Tetlama"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 105,
    "localidad": "Cececamel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 107,
    "localidad": "Aguacayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 108,
    "localidad": "Zapotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 109,
    "localidad": "Zacapilol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 110,
    "localidad": "Las Palmas (Las Puentes)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 112,
    "localidad": "La Huilona"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 115,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 117,
    "localidad": "Generales Azuara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 122,
    "localidad": "Tamocalito II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 123,
    "localidad": "Tepetzintla II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 124,
    "localidad": "Tetlama Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 125,
    "localidad": "Tzapoyo II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 128,
    "localidad": "Andrés Martínez Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 129,
    "localidad": "El Cartucho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 130,
    "localidad": "Comuntla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 131,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 133,
    "localidad": "El Manantial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 134,
    "localidad": "Melchor Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 135,
    "localidad": "Petlácatl Ejido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 136,
    "localidad": "Talapitz II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 137,
    "localidad": "Tamocalito I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 138,
    "localidad": "Valle Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 142,
    "localidad": "El Zapotal (El Tigre)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 143,
    "localidad": "Alfonso Cravioto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 144,
    "localidad": "Coaxocotitla I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 145,
    "localidad": "Crucero las Piedras Chacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 146,
    "localidad": "Ejido la Coneja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 147,
    "localidad": "Huextetitla Bienes Comunales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 148,
    "localidad": "Nueva Tenochtitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 149,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 150,
    "localidad": "San Antonio Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 151,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 152,
    "localidad": "Tepehica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 153,
    "localidad": "Barrio Prolongación 20 de Noviembre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 154,
    "localidad": "Barrio las Campanas (Barrio Tantima)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 155,
    "localidad": "Bellavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 156,
    "localidad": "Tecuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 157,
    "localidad": "Ahuimul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 158,
    "localidad": "Apetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 160,
    "localidad": "Fraccionamiento Nuevo Orizatlán (Fraccionamiento Magisterial)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 161,
    "localidad": "Mecapala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 162,
    "localidad": "Ejido Plan de Ayala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 163,
    "localidad": "El Chalahuite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 164,
    "localidad": "Pilalamesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 165,
    "localidad": "Xiinico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 166,
    "localidad": "Coyuco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 167,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 168,
    "localidad": "La Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 169,
    "localidad": "El Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 46,
    "municipio": "San Felipe Orizatlán",
    "claveLocalidad": 170,
    "localidad": "Xalamatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 1,
    "localidad": "Pacula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 2,
    "localidad": "Adjuntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 3,
    "localidad": "El Aguacatito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 4,
    "localidad": "El Baile"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 5,
    "localidad": "La Calera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 6,
    "localidad": "Canoas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 7,
    "localidad": "El Fraile"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 8,
    "localidad": "Jiliapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 9,
    "localidad": "Lagunillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 10,
    "localidad": "Loma de los Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 11,
    "localidad": "Mesa de San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 12,
    "localidad": "El Mezquite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 13,
    "localidad": "Milpas Viejas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 14,
    "localidad": "Mixquiahuales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 15,
    "localidad": "La Mohonera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 16,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 18,
    "localidad": "Potrerillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 19,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 20,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 21,
    "localidad": "Santa María Miraflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 22,
    "localidad": "Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 23,
    "localidad": "Vicente Guerrero (Presidio)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 24,
    "localidad": "Jagüey Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 25,
    "localidad": "Licenciado  Javier Rojo Gómez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 26,
    "localidad": "El Devisadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 27,
    "localidad": "Tierras Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 28,
    "localidad": "Mina la Negra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 30,
    "localidad": "Los Corrales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 31,
    "localidad": "La Hoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 32,
    "localidad": "El Huizachal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 33,
    "localidad": "Maguey Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 34,
    "localidad": "La Puerta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 35,
    "localidad": "Puerto Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 38,
    "localidad": "Barranca Seca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 39,
    "localidad": "Los Fresnos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 40,
    "localidad": "Río Camarones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 41,
    "localidad": "Sajunta de las Minas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 42,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 47,
    "municipio": "Pacula",
    "claveLocalidad": 43,
    "localidad": "El Puerto de Llano Largo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 1,
    "localidad": "Pachuca de Soto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 148,
    "localidad": "El Bordo (Barrio del Bordo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 149,
    "localidad": "Camelia (Barrio la Camelia)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 150,
    "localidad": "San Miguel Cerezo (El Cerezo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 153,
    "localidad": "El Huixmí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 154,
    "localidad": "Pitayas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 157,
    "localidad": "Santa Matilde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 158,
    "localidad": "Santiago Tlapacoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 188,
    "localidad": "San Pedro Nopancalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 193,
    "localidad": "Santa Gertrudis (Colonia Santa Gertrudis)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 195,
    "localidad": "Colonia la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 201,
    "localidad": "San Bartolo (Cerro Gordo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 204,
    "localidad": "Los Arcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 205,
    "localidad": "San Pedro (El Cigarro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 206,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 207,
    "localidad": "La Rabia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 208,
    "localidad": "Barrio de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 210,
    "localidad": "Rincones de San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 211,
    "localidad": "Ampliación San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 213,
    "localidad": "Restaurant Huasteco (Colonia San Miguel)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 214,
    "localidad": "Barrio Tiquixu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 215,
    "localidad": "Colonia las Campanitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 216,
    "localidad": "El Comal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 217,
    "localidad": "Barrio del Judío"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 219,
    "localidad": "San Bartolo ((Ejido Villa Aquiles Serdán)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 220,
    "localidad": "Cerro de San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 222,
    "localidad": "Colonia Miguel Ramos Arizpe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 223,
    "localidad": "Colonia 20 de Noviembre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 226,
    "localidad": "Makarenko"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 227,
    "localidad": "Teresa Vázquez Pérez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 230,
    "localidad": "Los Pirules"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 48,
    "municipio": "Pachuca de Soto",
    "claveLocalidad": 231,
    "localidad": "Unión Antorchista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 1,
    "localidad": "Pisaflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 3,
    "localidad": "El Alamo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 4,
    "localidad": "La Ameca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 5,
    "localidad": "El Amolar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 6,
    "localidad": "La Arena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 7,
    "localidad": "El Bonigu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 8,
    "localidad": "El Caracol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 9,
    "localidad": "Casas Viejas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 10,
    "localidad": "Cerro Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 11,
    "localidad": "Cerro de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 12,
    "localidad": "Cerro del Carmen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 13,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 14,
    "localidad": "El Coyol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 15,
    "localidad": "La Crucita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 16,
    "localidad": "Chalahuite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 17,
    "localidad": "Chalahuitito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 18,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 19,
    "localidad": "Escondida de San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 20,
    "localidad": "La Escondida de Lo Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 21,
    "localidad": "La Florida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 22,
    "localidad": "El Garabato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 23,
    "localidad": "Gargantilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 24,
    "localidad": "Guayabos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 25,
    "localidad": "El Higuerón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 26,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 27,
    "localidad": "El Limoncito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 28,
    "localidad": "Miraflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 29,
    "localidad": "Las Moras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 30,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 31,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 32,
    "localidad": "Palmitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 33,
    "localidad": "La Pechuga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 34,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 35,
    "localidad": "Pie de la Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 36,
    "localidad": "Poza Amarilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 37,
    "localidad": "Puerto Obscuro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 38,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 39,
    "localidad": "El Rayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 40,
    "localidad": "San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 41,
    "localidad": "Tlacuilola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 42,
    "localidad": "Tripuente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 43,
    "localidad": "San Pedro Xochicuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 44,
    "localidad": "El Zacatal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 45,
    "localidad": "Zapotal de Moras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 46,
    "localidad": "El Chililite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 47,
    "localidad": "Plan de Ayala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 48,
    "localidad": "El Petatillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 50,
    "localidad": "El Cuamirro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 51,
    "localidad": "La Barranca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 52,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 53,
    "localidad": "El Pemuche"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 54,
    "localidad": "El Pescadito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 55,
    "localidad": "Agua del Mono"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 56,
    "localidad": "El Cedral"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 57,
    "localidad": "La Cueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 58,
    "localidad": "El Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 59,
    "localidad": "San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 61,
    "localidad": "La Tinaja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 62,
    "localidad": "Villeda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 64,
    "localidad": "Cuartel Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 65,
    "localidad": "La Palma (Los Chivos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 66,
    "localidad": "Cuicillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 67,
    "localidad": "El Dexthi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 68,
    "localidad": "Los Encinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 69,
    "localidad": "Puerto Enebro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 70,
    "localidad": "La Hormiga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 71,
    "localidad": "Laguna de Palmitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 72,
    "localidad": "Lagunita del Cerro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 73,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 74,
    "localidad": "El Magueyal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 75,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 76,
    "localidad": "El Nogal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 77,
    "localidad": "Piedra Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 78,
    "localidad": "El Platanito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 79,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 80,
    "localidad": "Zapotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 81,
    "localidad": "El Plan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 82,
    "localidad": "El Sancudo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 83,
    "localidad": "La Tinaja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 84,
    "localidad": "El Algodonal (La Minita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 49,
    "municipio": "Pisaflores",
    "claveLocalidad": 85,
    "localidad": "Cuartel Escamilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 1,
    "localidad": "Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 2,
    "localidad": "El Xamu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 3,
    "localidad": "Xochitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 4,
    "localidad": "Colonia los Manantiales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 5,
    "localidad": "Las Calvas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 6,
    "localidad": "El Dho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 8,
    "localidad": "Los Pinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 10,
    "localidad": "El Jardín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 11,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 12,
    "localidad": "El Moreno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 13,
    "localidad": "Los Olivos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 15,
    "localidad": "La Ranchería"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 16,
    "localidad": "La Era"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 17,
    "localidad": "Periócolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 18,
    "localidad": "Donija"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 19,
    "localidad": "Palma Gorda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 20,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 21,
    "localidad": "Rancho de la Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 50,
    "municipio": "Progreso de Obregón",
    "claveLocalidad": 22,
    "localidad": "Dotzibi (Lomas de Xochitlán)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 1,
    "localidad": "Pachuquilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 2,
    "localidad": "Amaque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 3,
    "localidad": "Azoyatla de Ocampo (Azoyatla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 6,
    "localidad": "Santa María la Calera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 7,
    "localidad": "San Miguel la Higa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 8,
    "localidad": "La Noria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 9,
    "localidad": "San José Palma Gorda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 16,
    "localidad": "Velillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 17,
    "localidad": "El Venado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 18,
    "localidad": "Hacienda San Lunes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 19,
    "localidad": "Francisco Villa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 21,
    "localidad": "La Pila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 27,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 31,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 33,
    "localidad": "El Chacón (Nuevo Centro de Población Chacón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 38,
    "localidad": "Ex Hacienda de Chavarría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 52,
    "localidad": "San Cayetano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 57,
    "localidad": "Fraccionamiento la Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 58,
    "localidad": "Las Ladrilleras (Parcela Número 8)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 60,
    "localidad": "Pachuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 61,
    "localidad": "Barrio Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 62,
    "localidad": "Hacienda Santa Gertrudis (El Cuartel)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 65,
    "localidad": "Felipe Guerrero Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 66,
    "localidad": "Ampliación el Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 67,
    "localidad": "Dos Carlos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 68,
    "localidad": "Fraccionamiento Jesús Angeles Contreras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 69,
    "localidad": "Los Gemelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 70,
    "localidad": "El Jardín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 71,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 72,
    "localidad": "El Murciélago (El Pavo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 73,
    "localidad": "Palma Mocha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 74,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 75,
    "localidad": "Segunda Sección del Portezuelo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 76,
    "localidad": "El Popolito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 51,
    "municipio": "Mineral de la Reforma",
    "claveLocalidad": 77,
    "localidad": "Rancho Cadena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 1,
    "localidad": "San Agustín Tlaxiaca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 2,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 3,
    "localidad": "San José Cedo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 4,
    "localidad": "La Concepción"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 5,
    "localidad": "Chapultepec de Pozos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 6,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 7,
    "localidad": "Guadalupe Tezontle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 8,
    "localidad": "Colonia Guadalupe Victoria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 9,
    "localidad": "Ixcuinquitlapilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 10,
    "localidad": "San Isidro Llano Largo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 11,
    "localidad": "Colonia José Maria Pino Suárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 12,
    "localidad": "Puerto México"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 13,
    "localidad": "San Juan Solís"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 14,
    "localidad": "Santa Catarina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 15,
    "localidad": "San Francisco Tecajique"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 17,
    "localidad": "Tecamatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 19,
    "localidad": "San Juan Tilcuautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 20,
    "localidad": "San Miguel Tornacuxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 22,
    "localidad": "Oriental de Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 23,
    "localidad": "Colonia Guadalupe los Manantiales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 26,
    "localidad": "San José de los Altos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 27,
    "localidad": "El Campanario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 28,
    "localidad": "El Botho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 29,
    "localidad": "Las Cajas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 31,
    "localidad": "Chalmita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 32,
    "localidad": "Barrio el Dajie"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 33,
    "localidad": "El Huizache"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 36,
    "localidad": "La Nopalera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 37,
    "localidad": "Palos Blancos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 38,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 39,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 40,
    "localidad": "Santa Bárbara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 41,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 42,
    "localidad": "Santana (Reserva Cinegetica Santana)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 44,
    "localidad": "El Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 46,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 47,
    "localidad": "Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 48,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 50,
    "localidad": "El Chamizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 51,
    "localidad": "Barrio de Españita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 52,
    "localidad": "Colonia Nueva Tlaxiaca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 55,
    "localidad": "Monte de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 56,
    "localidad": "El Canal (Parada Santa María)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 59,
    "localidad": "Santo Tomás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 60,
    "localidad": "La Máquina Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 61,
    "localidad": "Modeda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 62,
    "localidad": "El Viborón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 63,
    "localidad": "Barrio el Vindho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 64,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 65,
    "localidad": "Barrio Casagrande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 67,
    "localidad": "Cerro Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 68,
    "localidad": "Casas Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 69,
    "localidad": "Cima de San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 70,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 71,
    "localidad": "El Pilón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 52,
    "municipio": "San Agustín Tlaxiaca",
    "claveLocalidad": 72,
    "localidad": "El Tequia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 1,
    "localidad": "San Bartolo Tutotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 3,
    "localidad": "Agua Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 4,
    "localidad": "Agua Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 5,
    "localidad": "Agua Hedionda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 6,
    "localidad": "Los Alamos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 7,
    "localidad": "El Banco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 8,
    "localidad": "Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 9,
    "localidad": "Calintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 10,
    "localidad": "La Campana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 11,
    "localidad": "El Candeje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 12,
    "localidad": "El Canjoy (Casas Quemadas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 13,
    "localidad": "La Cerca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 14,
    "localidad": "Cerro de Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 15,
    "localidad": "Cerro Macho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 16,
    "localidad": "Cerro Pelón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 17,
    "localidad": "Cerro Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 18,
    "localidad": "El Copal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 19,
    "localidad": "El Coyul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 20,
    "localidad": "Cueva Ahumada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 21,
    "localidad": "La Cueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 22,
    "localidad": "La Cumbre de Muridores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 23,
    "localidad": "Chicamole"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 24,
    "localidad": "El Dónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 25,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 26,
    "localidad": "El Hongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 27,
    "localidad": "La Huahua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 28,
    "localidad": "Huasquilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 29,
    "localidad": "El Jicote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 30,
    "localidad": "El Jovión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 31,
    "localidad": "El Juandhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 34,
    "localidad": "Loma Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 35,
    "localidad": "Llano Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 36,
    "localidad": "El Mahuaquite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 37,
    "localidad": "El Mavodo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 38,
    "localidad": "Medio Monte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 39,
    "localidad": "Milpa Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 41,
    "localidad": "Monte Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 42,
    "localidad": "El Mothó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 43,
    "localidad": "El Mundhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 46,
    "localidad": "El Nanjo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 47,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 48,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 49,
    "localidad": "El Nenjo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 50,
    "localidad": "El Ðundo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 52,
    "localidad": "Palo Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 53,
    "localidad": "El Paraíso Tierra Fuerte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 54,
    "localidad": "El Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 56,
    "localidad": "Pie del Cerro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 57,
    "localidad": "Pie del Cerro de Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 58,
    "localidad": "Piedra Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 60,
    "localidad": "Los Planes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 61,
    "localidad": "El Popotillo Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 63,
    "localidad": "El Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 64,
    "localidad": "Valle Verde (Rancho Viejo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 65,
    "localidad": "Río Chiquito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 66,
    "localidad": "Juntas del Río"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 67,
    "localidad": "San Andrés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 68,
    "localidad": "San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 69,
    "localidad": "San Juan de las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 70,
    "localidad": "San Mateo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 71,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 72,
    "localidad": "San Sebastián"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 73,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 74,
    "localidad": "Santiago"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 75,
    "localidad": "Santiaguito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 76,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 77,
    "localidad": "La Sorpresa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 78,
    "localidad": "El Sotol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 79,
    "localidad": "Tenantitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 80,
    "localidad": "Tierra Amarilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 81,
    "localidad": "Tierra Fuerte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 82,
    "localidad": "El Tigrillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 83,
    "localidad": "Rincón de Cerro Macho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 84,
    "localidad": "El Cojolite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 85,
    "localidad": "El Veinte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 86,
    "localidad": "La Venta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 90,
    "localidad": "La Vereda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 91,
    "localidad": "Xuchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 92,
    "localidad": "El Zenthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 93,
    "localidad": "El Zopilote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 94,
    "localidad": "Arroyo Seco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 95,
    "localidad": "El Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 99,
    "localidad": "La Flor de Santiago (La Flor)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 100,
    "localidad": "Llano Seco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 102,
    "localidad": "El Oratorio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 103,
    "localidad": "Piedra Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 105,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 106,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 107,
    "localidad": "Salto del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 109,
    "localidad": "La Segunda Ranchería"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 110,
    "localidad": "El Tomate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 111,
    "localidad": "El Xúchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 112,
    "localidad": "El Seis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 113,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 114,
    "localidad": "Piedra Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 115,
    "localidad": "La Sabana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 118,
    "localidad": "El Grillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 122,
    "localidad": "La Barranca (El Infiernillo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 125,
    "localidad": "El Boncho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 126,
    "localidad": "Colonia Industrial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 127,
    "localidad": "El Borbollón (Loma Bonita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 128,
    "localidad": "Cerro Negro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 129,
    "localidad": "El Denxe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 130,
    "localidad": "Diez Cerros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 131,
    "localidad": "El Hongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 132,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 133,
    "localidad": "El Lindero Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 134,
    "localidad": "La Loma de San Andrés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 135,
    "localidad": "Masoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 136,
    "localidad": "El Nandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 138,
    "localidad": "Poza Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 139,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 140,
    "localidad": "El Templado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 141,
    "localidad": "Tutotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 142,
    "localidad": "El Arco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 144,
    "localidad": "La Cumbre de la Campana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 145,
    "localidad": "La Pagua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 147,
    "localidad": "El Piñal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 148,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 149,
    "localidad": "La Ventilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 150,
    "localidad": "El Caliche"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 151,
    "localidad": "Agua Linda (La Fábrica)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 152,
    "localidad": "El Barrio de San Mateo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 153,
    "localidad": "Camarones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 154,
    "localidad": "La Florida (La Canoa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 155,
    "localidad": "El Jonotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 156,
    "localidad": "Las Juntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 157,
    "localidad": "El Lindero de San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 158,
    "localidad": "El Lindero de San Mateo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 159,
    "localidad": "La Loma de Cerro Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 160,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 161,
    "localidad": "El Mamey (Agua de los Monos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 162,
    "localidad": "Los Manantiales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 163,
    "localidad": "Parte Baja de Anaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 164,
    "localidad": "Piedra Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 165,
    "localidad": "El Popotillo Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 166,
    "localidad": "Santiago el Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 167,
    "localidad": "Barrio del Canjoy"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 168,
    "localidad": "Piedras Negras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 169,
    "localidad": "San Gabriel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 53,
    "municipio": "San Bartolo Tutotepec",
    "claveLocalidad": 170,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 1,
    "localidad": "San Salvador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 2,
    "localidad": "Bocaja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 3,
    "localidad": "Bominthza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 4,
    "localidad": "El Bondho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 5,
    "localidad": "Boxaxni"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 6,
    "localidad": "Bóxtha Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 7,
    "localidad": "Cañada Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 8,
    "localidad": "Casa Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 10,
    "localidad": "Demacu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 11,
    "localidad": "Déxtho de Victoria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 12,
    "localidad": "Francisco Villa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 13,
    "localidad": "Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 14,
    "localidad": "El Olvera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 15,
    "localidad": "Pacheco de Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 17,
    "localidad": "Poxindeje de Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 18,
    "localidad": "Quemtha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 19,
    "localidad": "San Antonio Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 20,
    "localidad": "San Miguel Acambay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 21,
    "localidad": "Santa María Amajac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 22,
    "localidad": "El Tablón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 23,
    "localidad": "Teofani"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 24,
    "localidad": "Tothie (Tothie de Rojo Gómez)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 26,
    "localidad": "El Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 27,
    "localidad": "Leandro Valle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 28,
    "localidad": "El Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 29,
    "localidad": "Dengandhó de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 30,
    "localidad": "Vixtha de Madero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 32,
    "localidad": "Caxuxi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 34,
    "localidad": "San Antonio Abad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 35,
    "localidad": "Cerro Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 36,
    "localidad": "Chichimecas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 37,
    "localidad": "La Flor"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 38,
    "localidad": "El Mezquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 39,
    "localidad": "El Mothe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 40,
    "localidad": "Xuchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 41,
    "localidad": "El Durazno (El Durazno de Flores Magón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 43,
    "localidad": "El Rosario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 44,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 45,
    "localidad": "Herminia Olguín Diaz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 46,
    "localidad": "San José Doxey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 47,
    "localidad": "La Hacienda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 48,
    "localidad": "El Puerto Lázaro Cárdenas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 49,
    "localidad": "Rincón Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 50,
    "localidad": "Ejido Santa Teresa (El Tablón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 51,
    "localidad": "Casa Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 52,
    "localidad": "El Gómez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 53,
    "localidad": "Fraccionamiento Media Luna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 54,
    "localidad": "Pacheco Leandro Valle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 54,
    "municipio": "San Salvador",
    "claveLocalidad": 55,
    "localidad": "Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 1,
    "localidad": "Santiago de Anaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 2,
    "localidad": "El Aguila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 3,
    "localidad": "La Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 4,
    "localidad": "Cerritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 5,
    "localidad": "El Encino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 6,
    "localidad": "González González"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 7,
    "localidad": "González Ortega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 8,
    "localidad": "Guerrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 9,
    "localidad": "Hermosillo Monte Noble"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 10,
    "localidad": "Lomas de Guillén"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 11,
    "localidad": "El Mezquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 12,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 13,
    "localidad": "Patria Nueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 14,
    "localidad": "Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 15,
    "localidad": "El Sitio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 16,
    "localidad": "Xitzo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 17,
    "localidad": "Yolotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 18,
    "localidad": "Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 19,
    "localidad": "El Porvenir"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 20,
    "localidad": "El Nopalillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 21,
    "localidad": "Ejido el Mezquital"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 22,
    "localidad": "Puerto Tavera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 23,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 24,
    "localidad": "La Loma del Conejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 25,
    "localidad": "El Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 26,
    "localidad": "Xhotadi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 27,
    "localidad": "El Contza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 28,
    "localidad": "Jagüey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 29,
    "localidad": "Cerro Gordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 55,
    "municipio": "Santiago de Anaya",
    "claveLocalidad": 30,
    "localidad": "La Corraleja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 1,
    "localidad": "Santiago Tulantepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 3,
    "localidad": "Las Lajas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 4,
    "localidad": "Los Romeros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 5,
    "localidad": "El Pedregal de San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 6,
    "localidad": "San Miguel Huatengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 7,
    "localidad": "Tilhuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 8,
    "localidad": "Ventoquipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 12,
    "localidad": "Palpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 14,
    "localidad": "Altepemila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 16,
    "localidad": "Paxtepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 18,
    "localidad": "Sayola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 21,
    "localidad": "Sangre de Cristo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 28,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 29,
    "localidad": "Rancho Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 30,
    "localidad": "Rancho el Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 32,
    "localidad": "Agrícola Oriental"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 33,
    "localidad": "Colonia Felipe Angeles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 34,
    "localidad": "Ampliación Mimila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 35,
    "localidad": "Emiliano Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 36,
    "localidad": "Habitacional del Bosque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 37,
    "localidad": "San Francisco Huatengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 38,
    "localidad": "San Luis Buena Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 39,
    "localidad": "San Pedro Huatengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 40,
    "localidad": "Santa Ana del Monte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 41,
    "localidad": "El Charco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 42,
    "localidad": "La Era"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 43,
    "localidad": "Las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 56,
    "municipio": "Santiago Tulantepec de Lugo Guerrero",
    "claveLocalidad": 44,
    "localidad": "Fraccionamiento Pedregal de San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 1,
    "localidad": "Singuilucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 2,
    "localidad": "Alfajayucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 3,
    "localidad": "Amolucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 4,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 5,
    "localidad": "Caraballo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 6,
    "localidad": "El Cebadal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 7,
    "localidad": "La Comunidad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 8,
    "localidad": "Cuatro Palos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 9,
    "localidad": "La Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 10,
    "localidad": "Francisco I.  Madero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 11,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 12,
    "localidad": "Jalapilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 13,
    "localidad": "El Listón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 14,
    "localidad": "Matías Rodríguez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 15,
    "localidad": "Mirasoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 16,
    "localidad": "La Paila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 18,
    "localidad": "Plutarco Elías Calles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 19,
    "localidad": "Poza Rica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 20,
    "localidad": "San Cayetano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 21,
    "localidad": "Santa Ana Chichicuautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 22,
    "localidad": "Segundas Lajas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 23,
    "localidad": "Somorriel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 24,
    "localidad": "El Susto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 25,
    "localidad": "San Nicolás Tecoaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 26,
    "localidad": "Ejido Texcaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 27,
    "localidad": "Tlalayote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 28,
    "localidad": "San Joaquín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 30,
    "localidad": "Colonia Francisco I. Madero (Colonia Agrícola)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 31,
    "localidad": "La Estancia (La Mora)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 32,
    "localidad": "Tlazala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 33,
    "localidad": "Texcaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 34,
    "localidad": "Aguayutla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 35,
    "localidad": "La Cuchilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 36,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 37,
    "localidad": "La Peñuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 41,
    "localidad": "Totolquemetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 44,
    "localidad": "Tecanecapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 46,
    "localidad": "Chapultepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 48,
    "localidad": "Sabanetas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 49,
    "localidad": "La Conchita (La Cantera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 50,
    "localidad": "Los Angeles (La Paila)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 51,
    "localidad": "Las Canoas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 52,
    "localidad": "San Luis Xuchitepec (Rancho Colorado)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 53,
    "localidad": "Colonia San Martín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 54,
    "localidad": "San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 55,
    "localidad": "Las Galeras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 56,
    "localidad": "La Herradura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 57,
    "localidad": "Jagüey Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 58,
    "localidad": "Minillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 59,
    "localidad": "El Sueño (Los Morales)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 60,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 61,
    "localidad": "Pedernales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 62,
    "localidad": "Las Pintas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 63,
    "localidad": "La Raya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 65,
    "localidad": "La Gloria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 66,
    "localidad": "San Cristóbal el Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 67,
    "localidad": "La Reforma (San Isidro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 68,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 69,
    "localidad": "San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 70,
    "localidad": "San Rafael Amolucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 72,
    "localidad": "Tres Moneras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 73,
    "localidad": "El Varal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 74,
    "localidad": "La Venta Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 75,
    "localidad": "La Virgen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 79,
    "localidad": "Monte Quieto (Las Arboledas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 80,
    "localidad": "Las Cruces"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 82,
    "localidad": "La Colmena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 83,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 86,
    "localidad": "La Gaspareña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 89,
    "localidad": "El Campamento"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 93,
    "localidad": "La Lagunita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 94,
    "localidad": "Ampliación el Varal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 96,
    "localidad": "Las Marianas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 98,
    "localidad": "Ex Hacienda de Mirasoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 101,
    "localidad": "El Paraíso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 105,
    "localidad": "San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 106,
    "localidad": "La Conchita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 108,
    "localidad": "La Esmeralda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 110,
    "localidad": "Los Gorriones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 112,
    "localidad": "Los Olvera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 114,
    "localidad": "El Venado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 116,
    "localidad": "Rincón del Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 117,
    "localidad": "Rincón del Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 118,
    "localidad": "Los San Antonios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 120,
    "localidad": "El Sustito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 121,
    "localidad": "La Herradura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 122,
    "localidad": "La Cueva (El Tezontle)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 131,
    "localidad": "Xuchipango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 132,
    "localidad": "El Encinal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 133,
    "localidad": "El Nopalillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 136,
    "localidad": "El Jazmín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 137,
    "localidad": "Fraccionamiento las Fuentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 138,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 141,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 142,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 143,
    "localidad": "Los Rosales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 144,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 145,
    "localidad": "Colonia del Bosque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 146,
    "localidad": "El Cordero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 147,
    "localidad": "Los Arbolitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 148,
    "localidad": "Crucero de Jalapilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 149,
    "localidad": "Cuatro Vientos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 150,
    "localidad": "Ejido del Susto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 151,
    "localidad": "La Era Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 152,
    "localidad": "Hacienda Alfajayucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 153,
    "localidad": "La Ladrillera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 154,
    "localidad": "Loma del Toro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 155,
    "localidad": "Las Minas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 156,
    "localidad": "Las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 157,
    "localidad": "La Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 158,
    "localidad": "Los Pinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 159,
    "localidad": "San Ignacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 160,
    "localidad": "Santa Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 161,
    "localidad": "Tepetongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 162,
    "localidad": "Las Trojes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 163,
    "localidad": "Los Aguilar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 164,
    "localidad": "Altamira"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 165,
    "localidad": "El Chichimeco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 166,
    "localidad": "Estación San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 167,
    "localidad": "La Hacienda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 168,
    "localidad": "Jagüey Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 169,
    "localidad": "El Mirador (El Templo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 170,
    "localidad": "El Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 171,
    "localidad": "San Carlos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 172,
    "localidad": "La Pradera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 173,
    "localidad": "El Toronjil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 174,
    "localidad": "Colonia los Patos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 57,
    "municipio": "Singuilucan",
    "claveLocalidad": 175,
    "localidad": "Mirasoles Parte Alta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 1,
    "localidad": "Tasquillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 2,
    "localidad": "Arbolado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 3,
    "localidad": "Bondhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 4,
    "localidad": "Caltimacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 6,
    "localidad": "Candelaria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 8,
    "localidad": "Cuauhtémoc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 9,
    "localidad": "Danghu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 10,
    "localidad": "El Epazote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 11,
    "localidad": "La Florida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 12,
    "localidad": "Huizachez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 13,
    "localidad": "Juchitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 14,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 15,
    "localidad": "Motho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 16,
    "localidad": "Noxthey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 17,
    "localidad": "Portezuelo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 18,
    "localidad": "Quitandejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 19,
    "localidad": "Remedios"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 20,
    "localidad": "Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 21,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 23,
    "localidad": "San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 24,
    "localidad": "Santiago Ixtlahuaca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 25,
    "localidad": "Tetzhu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 27,
    "localidad": "San Nicolás (San Nicolás Caltimacan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 31,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 32,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 34,
    "localidad": "Muntzi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 36,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 37,
    "localidad": "La Vega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 38,
    "localidad": "Puente de Fierro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 39,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 40,
    "localidad": "Campamento Puente Taxquillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 41,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 42,
    "localidad": "Balneario el Bidho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 43,
    "localidad": "Balneario Tzindejeh"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 44,
    "localidad": "El Porvenir del Epazote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 45,
    "localidad": "Frente al Vivero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 46,
    "localidad": "Jorge Torres Torres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 47,
    "localidad": "Cerro Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 48,
    "localidad": "Ojo de Agua (Mothe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 58,
    "municipio": "Tasquillo",
    "claveLocalidad": 49,
    "localidad": "El Puerto de la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 1,
    "localidad": "Tecozautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 2,
    "localidad": "El Ahorcado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 3,
    "localidad": "Aljibes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 4,
    "localidad": "Atengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 5,
    "localidad": "Bajhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 6,
    "localidad": "Banzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 7,
    "localidad": "Bomanxotha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 8,
    "localidad": "Boñhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 9,
    "localidad": "Bothe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 10,
    "localidad": "Boxhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 11,
    "localidad": "Cuamxhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 12,
    "localidad": "El Dedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 13,
    "localidad": "La Esquina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 14,
    "localidad": "Gandho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 15,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 16,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 17,
    "localidad": "Maguey Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 18,
    "localidad": "Manguani"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 19,
    "localidad": "La Mesilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 20,
    "localidad": "Ninthi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 21,
    "localidad": "La Paila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 22,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 23,
    "localidad": "Pañhé"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 24,
    "localidad": "El Paso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 25,
    "localidad": "Ranzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 26,
    "localidad": "El Riíto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 27,
    "localidad": "La Salitrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 28,
    "localidad": "El Salto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 29,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 30,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 31,
    "localidad": "San Joaquín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 32,
    "localidad": "San José el Desierto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 33,
    "localidad": "San Miguel Caltepantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 34,
    "localidad": "Taxbatha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 35,
    "localidad": "Tenzabhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 36,
    "localidad": "Uxdejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 37,
    "localidad": "Yethay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 38,
    "localidad": "La Sabina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 39,
    "localidad": "El Mercader"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 40,
    "localidad": "Rayón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 43,
    "localidad": "Las Galindas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 46,
    "localidad": "El Doranhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 48,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 49,
    "localidad": "El Géiser"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 50,
    "localidad": "Yextho Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 52,
    "localidad": "Barrio la Cochera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 53,
    "localidad": "Rancho Pathecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 54,
    "localidad": "Tzidejhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 55,
    "localidad": "San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 59,
    "localidad": "Joñhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 69,
    "localidad": "Rancho la Alameda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 71,
    "localidad": "Candhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 72,
    "localidad": "La Cruz de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 73,
    "localidad": "La Codorniz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 74,
    "localidad": "Hacienda Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 76,
    "localidad": "Pared Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 77,
    "localidad": "La Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 79,
    "localidad": "Taxhidó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 83,
    "localidad": "La Polvadera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 84,
    "localidad": "Botzhiquia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 85,
    "localidad": "Rancho Gumbhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 86,
    "localidad": "El Crucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 87,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 88,
    "localidad": "La Cueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 89,
    "localidad": "El Huizachal (El Sombrerete)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 90,
    "localidad": "La Lomita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 91,
    "localidad": "Nuevo Aljibes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 92,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 93,
    "localidad": "Rancho Cerro Frío"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 94,
    "localidad": "Rancho la Parada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 95,
    "localidad": "Rancho Santa Bárbara"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 96,
    "localidad": "El Caracol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 97,
    "localidad": "Las Granjas del Ejido de Tecozautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 98,
    "localidad": "La Otra Banda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 99,
    "localidad": "La Sexta Manzana Hidalgo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 100,
    "localidad": "La Cruz de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 101,
    "localidad": "El Charcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 102,
    "localidad": "El Granjenal (Las Adjuntas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 103,
    "localidad": "El Halcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 104,
    "localidad": "El Zundho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 59,
    "municipio": "Tecozautla",
    "claveLocalidad": 105,
    "localidad": "Los Carrizos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 1,
    "localidad": "Tenango de Doria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 2,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 3,
    "localidad": "Los Ahilares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 4,
    "localidad": "El Bopo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 5,
    "localidad": "El Cásiu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 6,
    "localidad": "Cerro Chiquito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 8,
    "localidad": "La Concepción (El Carrizal)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 9,
    "localidad": "La Cruz de Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 10,
    "localidad": "El Damo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 11,
    "localidad": "El Desdavi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 12,
    "localidad": "El Dequeña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 13,
    "localidad": "El Despi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 14,
    "localidad": "El Dexhuadá"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 15,
    "localidad": "El Gosco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 16,
    "localidad": "Huasquilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 19,
    "localidad": "San Isidro la Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 20,
    "localidad": "Ejido López Mateos (La Colonia)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 21,
    "localidad": "El Mamay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 22,
    "localidad": "Agua Zarca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 23,
    "localidad": "El Nanthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 24,
    "localidad": "El Ðanjuay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 26,
    "localidad": "Peña Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 27,
    "localidad": "Los Planes de Santiago"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 28,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 29,
    "localidad": "El Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 30,
    "localidad": "La Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 31,
    "localidad": "San Francisco Ixmiquilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 32,
    "localidad": "San Francisco la Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 33,
    "localidad": "San José del Valle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 34,
    "localidad": "San Nicolás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 35,
    "localidad": "San Pablo el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 36,
    "localidad": "Santa María Temaxcalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 37,
    "localidad": "Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 38,
    "localidad": "El Temapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 40,
    "localidad": "El Texme"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 41,
    "localidad": "La Viejita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 43,
    "localidad": "El Xuthí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 44,
    "localidad": "El Zetoy"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 45,
    "localidad": "Cerro Grande (Veinte Barrancas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 47,
    "localidad": "Las Juntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 48,
    "localidad": "Linda Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 49,
    "localidad": "El Lindero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 50,
    "localidad": "El Madhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 51,
    "localidad": "Palo Gacho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 53,
    "localidad": "El Tramo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 54,
    "localidad": "El Xindhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 55,
    "localidad": "Ejido de Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 56,
    "localidad": "El Tuxtay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 57,
    "localidad": "El Xajá"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 58,
    "localidad": "La Palizada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 59,
    "localidad": "El Juanthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 60,
    "localidad": "El Barrio de San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 61,
    "localidad": "Colonia San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 62,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 64,
    "localidad": "El Dixoy"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 65,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 66,
    "localidad": "Piedras Negras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 60,
    "municipio": "Tenango de Doria",
    "claveLocalidad": 67,
    "localidad": "Colonia Ermita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 1,
    "localidad": "Tepeapulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 2,
    "localidad": "Fray Bernardino de Sahagún (Ciudad Sahagún)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 3,
    "localidad": "Los Cides"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 4,
    "localidad": "Los Coyotes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 5,
    "localidad": "Francisco Sarabia (Corralillos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 7,
    "localidad": "Irolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 8,
    "localidad": "Jagüey Prieto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 9,
    "localidad": "Palo Hueco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 10,
    "localidad": "San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 11,
    "localidad": "San Miguel Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 12,
    "localidad": "San Salvador (El Calvario)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 13,
    "localidad": "Tepalpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 14,
    "localidad": "San Bartolomé Tepetates"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 15,
    "localidad": "Texcatzongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 16,
    "localidad": "Tultengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 17,
    "localidad": "Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 18,
    "localidad": "San Jeronimito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 20,
    "localidad": "La Estación Ocho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 23,
    "localidad": "Cruz Blanca (Santa Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 29,
    "localidad": "Colonia 20 de Noviembre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 30,
    "localidad": "San Ignacio de Loyola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 33,
    "localidad": "Las Cabrerías (La Rinconada)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 34,
    "localidad": "Las Delicias"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 35,
    "localidad": "El Mirto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 37,
    "localidad": "La Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 38,
    "localidad": "San José Tultengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 39,
    "localidad": "Santa Ana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 40,
    "localidad": "Tepantiloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 41,
    "localidad": "Granja de Aguilera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 43,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 45,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 46,
    "localidad": "Palmillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 47,
    "localidad": "Paso del Cristo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 48,
    "localidad": "Pueblilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 50,
    "localidad": "Rancho los Angeles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 51,
    "localidad": "Rancho las Aguilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 52,
    "localidad": "Los García"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 53,
    "localidad": "Rancho Gutiérrez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 54,
    "localidad": "Isidro Cuellar Velazquez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 58,
    "localidad": "La Loma de San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 60,
    "localidad": "Rancho Juan Montaño Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 61,
    "localidad": "Rancho Morales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 64,
    "localidad": "Los Ortiz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 66,
    "localidad": "Rancho San Javier"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 68,
    "localidad": "Rancho Sánchez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 69,
    "localidad": "La Plateada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 70,
    "localidad": "Rancho Zárate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 71,
    "localidad": "Las Bedollas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 73,
    "localidad": "Rancho Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 74,
    "localidad": "Los Duraznos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 75,
    "localidad": "Benito Meneses"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 77,
    "localidad": "Rancho Quince Hermanos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 78,
    "localidad": "Los Reyes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 79,
    "localidad": "Rancho el Jihuingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 81,
    "localidad": "La Tula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 82,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 83,
    "localidad": "La Caseta de Aforos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 84,
    "localidad": "La Isleta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 85,
    "localidad": "Oxtocapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 86,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 88,
    "localidad": "Rancho Heriberto Castillo Muñoz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 89,
    "localidad": "El Llano de la Presa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 90,
    "localidad": "Rancho los 10 Hermanos (Las Huertas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 91,
    "localidad": "Los López"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 92,
    "localidad": "Rancho Pedro Meneses"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 93,
    "localidad": "Los Quintos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 94,
    "localidad": "Temomusgo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 95,
    "localidad": "El Fraile"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 96,
    "localidad": "Tlacatepa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 97,
    "localidad": "Colonia el Magueyal (Las Palomas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 98,
    "localidad": "El Pitayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 99,
    "localidad": "La Hermita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 100,
    "localidad": "La Pelusa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 61,
    "municipio": "Tepeapulco",
    "claveLocalidad": 101,
    "localidad": "San José (Los Montaño)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 1,
    "localidad": "Tepehuacán de Guerrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 2,
    "localidad": "Acoxcatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 3,
    "localidad": "Acoyotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 4,
    "localidad": "Acuimantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 5,
    "localidad": "San Juan Ahuehueco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 6,
    "localidad": "Amola de Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 7,
    "localidad": "Aquilastec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 8,
    "localidad": "San Miguel Ayotempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 9,
    "localidad": "Cahuazaz de Morelos (Rancho Alegre)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 10,
    "localidad": "Cuatolol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 11,
    "localidad": "Cuazáhuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 12,
    "localidad": "Chahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 13,
    "localidad": "Chilijapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 14,
    "localidad": "Choquintla (San Nicolás Choquintla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 15,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 16,
    "localidad": "Colonia Guadalupe (Otongo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 17,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 18,
    "localidad": "Petlapixca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 19,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 20,
    "localidad": "La Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 21,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 22,
    "localidad": "San Simón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 23,
    "localidad": "Tamala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 24,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 25,
    "localidad": "Texcapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 26,
    "localidad": "Texopich"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 27,
    "localidad": "Teyahuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 28,
    "localidad": "Xiliapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 29,
    "localidad": "Xilitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 30,
    "localidad": "Zacualtipanito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 34,
    "localidad": "Ixtlapalaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 43,
    "localidad": "Las Golondrinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 45,
    "localidad": "Xalamatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 55,
    "localidad": "Almolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 58,
    "localidad": "Chacola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 61,
    "localidad": "Soyuco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 69,
    "localidad": "El Zacatal (El Zacatal de los Rosales)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 76,
    "localidad": "Ahuatetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 82,
    "localidad": "Tetipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 83,
    "localidad": "Loma de Choquintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 84,
    "localidad": "Apantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 85,
    "localidad": "Cuahuixajco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 87,
    "localidad": "Zacatlamaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 94,
    "localidad": "Amatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 95,
    "localidad": "Acahuastitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 96,
    "localidad": "Cuatotol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 97,
    "localidad": "La Ceiba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 98,
    "localidad": "Chalahuite"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 99,
    "localidad": "El Chote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 101,
    "localidad": "Coyutla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 102,
    "localidad": "El Durazno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 104,
    "localidad": "Olcuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 106,
    "localidad": "Poxtatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 107,
    "localidad": "San Andrés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 111,
    "localidad": "Tizapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 113,
    "localidad": "Tlaxcala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 115,
    "localidad": "Zacatal (San Maíz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 116,
    "localidad": "Acatlajapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 117,
    "localidad": "Almolo (San Isidro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 118,
    "localidad": "Atapach"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 119,
    "localidad": "El Barco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 122,
    "localidad": "Epixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 123,
    "localidad": "El Naranjal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 124,
    "localidad": "Montaxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 127,
    "localidad": "Tlaíca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 128,
    "localidad": "Tlacuilola (Poza Verde)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 129,
    "localidad": "Tlalcuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 130,
    "localidad": "Tlapexmecaapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 131,
    "localidad": "Tzinangal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 132,
    "localidad": "Villa de Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 133,
    "localidad": "Vista de Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 134,
    "localidad": "Xolompiasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 136,
    "localidad": "Apetlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 137,
    "localidad": "Auescalli"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 138,
    "localidad": "El Camposanto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 139,
    "localidad": "El Chote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 140,
    "localidad": "La Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 141,
    "localidad": "Huixquilico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 142,
    "localidad": "Molashtitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 143,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 145,
    "localidad": "Huitlala (Huexoapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 146,
    "localidad": "Nancuaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 147,
    "localidad": "Tlalica (El Rancho del Padre)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 148,
    "localidad": "El Remolino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 149,
    "localidad": "Tlacotepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 151,
    "localidad": "Comaltipa (La Joya)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 152,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 153,
    "localidad": "Agua Bendita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 154,
    "localidad": "Arroyo el Tigre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 155,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 156,
    "localidad": "Cuahuixtlahuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 157,
    "localidad": "La Fábrica Vieja (Alamo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 158,
    "localidad": "Ixcuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 159,
    "localidad": "Arroyo Seco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 160,
    "localidad": "San Felipe Teteltipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 161,
    "localidad": "Santo Niño"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 162,
    "localidad": "Tepala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 163,
    "localidad": "Tetlapaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 164,
    "localidad": "Tlamaxac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 165,
    "localidad": "Versayes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 166,
    "localidad": "Tzoletla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 167,
    "localidad": "Tonales (La Pedrera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 62,
    "municipio": "Tepehuacán de Guerrero",
    "claveLocalidad": 168,
    "localidad": "Teixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 1,
    "localidad": "Tepeji de Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 2,
    "localidad": "El Banco (El Banco Vega de Madero)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 3,
    "localidad": "Cantera de Villagrán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 4,
    "localidad": "Cañada de Madero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 5,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 6,
    "localidad": "Melchor Ocampo (El Salto)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 7,
    "localidad": "Montecillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 8,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 9,
    "localidad": "San Buenaventura"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 10,
    "localidad": "San Ignacio Nopala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 11,
    "localidad": "San Ildefonso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 12,
    "localidad": "San José Piedra Gorda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 13,
    "localidad": "San Mateo Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 14,
    "localidad": "Santa Ana Atzcapotzaltongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 15,
    "localidad": "Santa María Magdalena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 16,
    "localidad": "Santa María Quelites"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 17,
    "localidad": "Santiago Tlapanaloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 18,
    "localidad": "Santiago Tlautla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 19,
    "localidad": "Taxhido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 20,
    "localidad": "Tianguistengo (La Romera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 21,
    "localidad": "Tinajas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 23,
    "localidad": "Vega de Madero (El Panal)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 24,
    "localidad": "Dos Peñas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 25,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 26,
    "localidad": "Santiago Tlaltepoxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 27,
    "localidad": "Canoas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 28,
    "localidad": "Miraflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 29,
    "localidad": "El Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 41,
    "localidad": "El Crucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 42,
    "localidad": "El Encino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 44,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 46,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 47,
    "localidad": "Presa Escondida Segunda Sección Hacienda la Nopalera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 48,
    "localidad": "La Estancia Primera Sección Santa María Magdalena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 49,
    "localidad": "Golondrinas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 52,
    "localidad": "Presa Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 53,
    "localidad": "Unidad Obrera Habitacional CTM"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 54,
    "localidad": "Xaisnal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 55,
    "localidad": "Tinajas Segunda Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 56,
    "localidad": "Pie de Casas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 59,
    "localidad": "Lumbrera 19 (Barranca del Muerto)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 60,
    "localidad": "Lumbrera 18"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 61,
    "localidad": "La Placa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 62,
    "localidad": "Lumbrera 20"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 64,
    "localidad": "Loma de la Lechuguilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 66,
    "localidad": "La Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 67,
    "localidad": "Corral de Piedra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 68,
    "localidad": "Las Colonias"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 69,
    "localidad": "La Planada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 70,
    "localidad": "Colonia Caracol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 72,
    "localidad": "Ejido San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 74,
    "localidad": "La Flor"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 76,
    "localidad": "Rancho Montería Real del Río"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 77,
    "localidad": "Lomas Campestre de la Cantera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 78,
    "localidad": "Camino a la Presa (Los Rincones)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 79,
    "localidad": "Ejido de Xalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 80,
    "localidad": "Hacienda Xajay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 81,
    "localidad": "Puertecito (Cerrito de la Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 82,
    "localidad": "Palo Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 83,
    "localidad": "Rancho las Isabeles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 84,
    "localidad": "La Loma 2a Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 85,
    "localidad": "Rancho Los Manolos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 86,
    "localidad": "Raramuri"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 63,
    "municipio": "Tepeji del Río de Ocampo",
    "claveLocalidad": 87,
    "localidad": "Rancho San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 1,
    "localidad": "Tepetitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 2,
    "localidad": "Encinillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 3,
    "localidad": "General Pedro María Anaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 4,
    "localidad": "José María Pino Suárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 5,
    "localidad": "La Joya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 6,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 7,
    "localidad": "Palo Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 8,
    "localidad": "San Pedro Nextlalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 9,
    "localidad": "Santa María Daxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 10,
    "localidad": "Estación Sayula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 11,
    "localidad": "Sayula Pueblo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 12,
    "localidad": "Xithi Segunda Sección (Xithi de Abasolo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 13,
    "localidad": "Xithi Primera Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 14,
    "localidad": "El Retiro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 15,
    "localidad": "San Mateo la Curva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 16,
    "localidad": "La Ermita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 17,
    "localidad": "La Puerta (Las Bugambilias)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 19,
    "localidad": "Colonia Ampliación (Segunda Manzana)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 20,
    "localidad": "La Cuarta Manzana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 24,
    "localidad": "El Bordo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 64,
    "municipio": "Tepetitlán",
    "claveLocalidad": 25,
    "localidad": "Ejido Pedro María Anaya (Ejido San Mateo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 1,
    "localidad": "Tetepango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 2,
    "localidad": "Juandhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 3,
    "localidad": "Ulapa de Melchor Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 8,
    "localidad": "Fernando Hernández Jiménez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 9,
    "localidad": "La Estanzuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 12,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 65,
    "municipio": "Tetepango",
    "claveLocalidad": 13,
    "localidad": "Barrio Nicolás Bravo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 1,
    "localidad": "Tezontepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 2,
    "localidad": "Acozac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 3,
    "localidad": "La Cantera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 4,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 5,
    "localidad": "Chamberluco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 6,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 7,
    "localidad": "Jagüey de Arriba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 8,
    "localidad": "Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 10,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 11,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 12,
    "localidad": "Terreros"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 13,
    "localidad": "Tlexpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 16,
    "localidad": "Las Rosas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 18,
    "localidad": "Colonia Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 19,
    "localidad": "Jagüeycillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 20,
    "localidad": "Progreso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 21,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 22,
    "localidad": "Xoconoxtle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 23,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 24,
    "localidad": "San Agustín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 25,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 26,
    "localidad": "Ampliación San Juanita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 27,
    "localidad": "Altamira"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 28,
    "localidad": "El Magueyal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 29,
    "localidad": "El Miravalle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 66,
    "municipio": "Villa de Tezontepec",
    "claveLocalidad": 30,
    "localidad": "Rancho Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 1,
    "localidad": "Tezontepec de Aldama"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 2,
    "localidad": "Santiago Acayutlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 3,
    "localidad": "Atengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 4,
    "localidad": "Santa María Batha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 5,
    "localidad": "Huitel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 6,
    "localidad": "Mangas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 7,
    "localidad": "La Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 8,
    "localidad": "Panuaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 9,
    "localidad": "Presas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 10,
    "localidad": "San Gabriel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 11,
    "localidad": "San juan Achichilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 12,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 13,
    "localidad": "El Tinaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 14,
    "localidad": "Manantiales de Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 15,
    "localidad": "Monte Alegre (Carranza)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 17,
    "localidad": "Colonia San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 18,
    "localidad": "San Isidro Presas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 19,
    "localidad": "Cinco de Febrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 20,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 21,
    "localidad": "La Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 22,
    "localidad": "San Isidro Carrasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 24,
    "localidad": "Colonia de Presas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 25,
    "localidad": "Cerro del Xicuco (La Cantera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 26,
    "localidad": "El Solís"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 28,
    "localidad": "El Gavillero de Barrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 29,
    "localidad": "Julián Cornejo Serrano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 30,
    "localidad": "Los Manantiales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 31,
    "localidad": "El Mogote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 32,
    "localidad": "Rancho la Chiripa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 33,
    "localidad": "San Isidro Presas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 34,
    "localidad": "San Isidro el Tanque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 35,
    "localidad": "Zanja Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 37,
    "localidad": "Rancho la Luz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 38,
    "localidad": "Juana Baltazar Bautista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 39,
    "localidad": "La Avenida de Carrasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 40,
    "localidad": "Vicente Zuñiga Bernal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 41,
    "localidad": "Rancho el Sitio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 42,
    "localidad": "El Chamizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 67,
    "municipio": "Tezontepec de Aldama",
    "claveLocalidad": 43,
    "localidad": "San Isidro el Tanque"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 1,
    "localidad": "Tianguistengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 2,
    "localidad": "Atecoxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 3,
    "localidad": "Atla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 4,
    "localidad": "Las Cantinas (San José de las Cruces)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 5,
    "localidad": "Coamelco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 6,
    "localidad": "Coatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 7,
    "localidad": "Comala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 8,
    "localidad": "Conchintlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 10,
    "localidad": "Coaxímal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 11,
    "localidad": "La Cumbre de Tlacolula (La Cumbre)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 12,
    "localidad": "Chahuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 13,
    "localidad": "Chapaltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 14,
    "localidad": "Chapula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 15,
    "localidad": "Chinango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 16,
    "localidad": "Cholula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 17,
    "localidad": "La Esperanza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 18,
    "localidad": "El Hormiguero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 19,
    "localidad": "Ixcotitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 20,
    "localidad": "Joquela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 21,
    "localidad": "Los Linderos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 22,
    "localidad": "Matlatenco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 23,
    "localidad": "Mazahuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 24,
    "localidad": "La Morita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 25,
    "localidad": "El Ocotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 26,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 27,
    "localidad": "Otlamalacatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 28,
    "localidad": "Oxpantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 29,
    "localidad": "La Pahua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 30,
    "localidad": "Pahuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 31,
    "localidad": "Pemuxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 32,
    "localidad": "Piedra Ancha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 33,
    "localidad": "Polintotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 34,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 35,
    "localidad": "Santa Mónica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 36,
    "localidad": "Soyatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 37,
    "localidad": "Techimal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 38,
    "localidad": "Tenexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 40,
    "localidad": "Tepehuixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 41,
    "localidad": "Texacal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 43,
    "localidad": "Tlacohechac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 44,
    "localidad": "Tlacolula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 45,
    "localidad": "Tlahuiltepa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 46,
    "localidad": "Tlapixhueca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 47,
    "localidad": "Tonchintlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 48,
    "localidad": "Xalacahuantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 49,
    "localidad": "Xococoatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 50,
    "localidad": "Xochimilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 51,
    "localidad": "Yatipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 52,
    "localidad": "Zacatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 53,
    "localidad": "Zacatipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 55,
    "localidad": "El Retoñal (Habitacional Ruperto Alarcón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 56,
    "localidad": "Cuatro Caminos (Cuatro Hermanos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 57,
    "localidad": "Tepaneca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 59,
    "localidad": "Acatenco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 60,
    "localidad": "Amatepec (Los Pocitos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 61,
    "localidad": "Manitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 68,
    "localidad": "Teopancahuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 73,
    "localidad": "El Astillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 74,
    "localidad": "Media Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 76,
    "localidad": "Zacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 78,
    "localidad": "Coatzontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 79,
    "localidad": "Piedras Negras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 81,
    "localidad": "Bella Vista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 82,
    "localidad": "Chalacuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 83,
    "localidad": "Coatlajal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 86,
    "localidad": "Hualula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 87,
    "localidad": "La Loma (La Joya Grande)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 89,
    "localidad": "Tilasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 90,
    "localidad": "Tolapa (Tonalapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 91,
    "localidad": "Coatlapila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 92,
    "localidad": "Barrio Tlane (Xicotenco)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 93,
    "localidad": "Tizapán (Coatlapila)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 68,
    "municipio": "Tianguistengo",
    "claveLocalidad": 94,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 1,
    "localidad": "Tizayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 2,
    "localidad": "El Carmen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 3,
    "localidad": "El Chato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 4,
    "localidad": "El Chopo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 5,
    "localidad": "Emiliano Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 7,
    "localidad": "La Golondrina"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 8,
    "localidad": "Huitzila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 9,
    "localidad": "Mogotes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 10,
    "localidad": "El Cid"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 11,
    "localidad": "Olmos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 13,
    "localidad": "La Purísima"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 17,
    "localidad": "San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 19,
    "localidad": "Tepojaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 22,
    "localidad": "Rancho María Candelaria"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 23,
    "localidad": "Rancho el Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 24,
    "localidad": "El Manantial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 26,
    "localidad": "La Provincia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 27,
    "localidad": "Caseta del Carmen"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 28,
    "localidad": "Ciudad de los Niños (Rosas Rojas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 29,
    "localidad": "Las Plazas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 30,
    "localidad": "Restaurante Mi Ranchito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 31,
    "localidad": "Rancho San Rafael (Kilómetro 57)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 32,
    "localidad": "La Posta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 33,
    "localidad": "Balneario Flamingos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 34,
    "localidad": "La Pista de Tizayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 35,
    "localidad": "Felipe Ortiz Chávez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 36,
    "localidad": "Rancho San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 37,
    "localidad": "Rancho Eduardo Hernández"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 38,
    "localidad": "Loma Bonita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 39,
    "localidad": "Rancho la Ilusión (La Casa del Manantial)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 40,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 69,
    "municipio": "Tizayuca",
    "claveLocalidad": 41,
    "localidad": "El Chopo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 1,
    "localidad": "Tlahuelilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 2,
    "localidad": "Munitepec de Madero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 3,
    "localidad": "Colonia Cuauhtémoc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 5,
    "localidad": "Miravalle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 14,
    "localidad": "Colonia Cerro de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 15,
    "localidad": "Ejido Media Luna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 16,
    "localidad": "La Mercadela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 18,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 19,
    "localidad": "El Salitre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 20,
    "localidad": "Rancho Bugambilias"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 21,
    "localidad": "Dexhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 70,
    "municipio": "Tlahuelilpan",
    "claveLocalidad": 22,
    "localidad": "San Gregorio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 1,
    "localidad": "Tlahuiltepa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 2,
    "localidad": "Acapa (Santiago Acapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 3,
    "localidad": "Agua del Cuervo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 4,
    "localidad": "Agua Tapada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 5,
    "localidad": "Barrio de Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 6,
    "localidad": "Boca de León"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 7,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 8,
    "localidad": "Camarones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 9,
    "localidad": "Cerro Chato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 10,
    "localidad": "Cerro del Aguila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 11,
    "localidad": "La Concordia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 12,
    "localidad": "Coyocala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 13,
    "localidad": "Chichicaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 14,
    "localidad": "Dominí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 15,
    "localidad": "Profesor Raciel Salcedo Rangel (El Duraznito)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 16,
    "localidad": "Itztamichapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 17,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 18,
    "localidad": "Las Manzanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 19,
    "localidad": "Nuevo Morelos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 20,
    "localidad": "Nuevo Reynosa (Cinco Palos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 21,
    "localidad": "Palo Perdido"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 22,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 23,
    "localidad": "San Andrés Miraflores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 24,
    "localidad": "San Marcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 25,
    "localidad": "Santiago"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 26,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 27,
    "localidad": "Tlaxcantitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 28,
    "localidad": "Tolantongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 29,
    "localidad": "El Venado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 30,
    "localidad": "Xilocuatitla (El Puerto de Xilocuatitla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 32,
    "localidad": "Yerbabuena (El Puerto)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 33,
    "localidad": "Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 34,
    "localidad": "El Ocotal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 35,
    "localidad": "La Unión"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 36,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 37,
    "localidad": "Nuevo Monterrey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 38,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 40,
    "localidad": "Lázaro Cárdenas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 41,
    "localidad": "Xiopa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 42,
    "localidad": "Catí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 43,
    "localidad": "Agua Fría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 45,
    "localidad": "Cajete"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 46,
    "localidad": "El Somerial"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 47,
    "localidad": "El Picacho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 48,
    "localidad": "Cerro Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 49,
    "localidad": "Los Tigres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 51,
    "localidad": "San Antonio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 52,
    "localidad": "Nemixi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 53,
    "localidad": "El Fresno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 54,
    "localidad": "Agua Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 55,
    "localidad": "El Fresno (Tierra Seca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 56,
    "localidad": "Cangui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 57,
    "localidad": "Amajac (La Maroma)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 58,
    "localidad": "El Aviadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 59,
    "localidad": "Agua del Capulín (El Capulín)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 60,
    "localidad": "Agua Zarca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 61,
    "localidad": "La Yesca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 62,
    "localidad": "Xilitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 63,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 64,
    "localidad": "Agua del Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 65,
    "localidad": "El Borbollón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 66,
    "localidad": "Calderones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 67,
    "localidad": "Demañi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 68,
    "localidad": "El Dominí"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 69,
    "localidad": "El Duraznito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 70,
    "localidad": "La Era"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 71,
    "localidad": "La Guayaba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 72,
    "localidad": "Jilguero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 73,
    "localidad": "La Laguna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 74,
    "localidad": "El Limón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 75,
    "localidad": "Media Luna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 76,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 77,
    "localidad": "El Nenfi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 78,
    "localidad": "La Nueva Era"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 79,
    "localidad": "Nuevo Zacatlán (El Zacate)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 80,
    "localidad": "El Orégano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 81,
    "localidad": "Piedra Parada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 82,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 83,
    "localidad": "La Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 84,
    "localidad": "El Roble"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 85,
    "localidad": "El Sarro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 86,
    "localidad": "La Soledad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 87,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 88,
    "localidad": "Tierra Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 89,
    "localidad": "La Ventana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 90,
    "localidad": "Las Canoas (Vado Hondo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 91,
    "localidad": "El Magani"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 92,
    "localidad": "Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 93,
    "localidad": "El Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 94,
    "localidad": "Lindavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 95,
    "localidad": "San Jerónimo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 96,
    "localidad": "Rancho Nuevo (Xiopa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 97,
    "localidad": "Xuchiatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 98,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 99,
    "localidad": "El Zancudo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 100,
    "localidad": "El Aguacate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 101,
    "localidad": "Barranca del Cerro del Aguila (Barranca Seca)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 102,
    "localidad": "La Barranca (El Somerial)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 103,
    "localidad": "La Barranca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 104,
    "localidad": "El Bexu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 105,
    "localidad": "El Boto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 106,
    "localidad": "Las Canoas (El Somerial)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 107,
    "localidad": "Cerro del León (El Cerrito)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 108,
    "localidad": "La Chirimoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 109,
    "localidad": "La Ciruela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 110,
    "localidad": "El Conizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 111,
    "localidad": "La Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 112,
    "localidad": "Los Frijolares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 113,
    "localidad": "El Garabato"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 114,
    "localidad": "Agua Fría (La Laguna)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 115,
    "localidad": "El Limoncito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 116,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 117,
    "localidad": "El Maguey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 118,
    "localidad": "Majua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 119,
    "localidad": "Manuel Cruz Barrera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 120,
    "localidad": "Las Manzanas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 121,
    "localidad": "El Cinalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 122,
    "localidad": "Naranjalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 123,
    "localidad": "Rancho de la Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 124,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 125,
    "localidad": "El Palmillar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 126,
    "localidad": "Agua Fría (El Guayabal)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 127,
    "localidad": "Pie de la Cuesta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 128,
    "localidad": "El Puerto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 129,
    "localidad": "Puerto el Paichle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 130,
    "localidad": "Rancho Viejo (Rancho Nuevo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 131,
    "localidad": "La Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 132,
    "localidad": "San Antonio (El Ojo de Agua)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 135,
    "localidad": "Los Tigres (Antíoco Morales Velázquez)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 136,
    "localidad": "Tonchi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 137,
    "localidad": "El Alamo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 138,
    "localidad": "El Bordo (Manzana Chata)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 139,
    "localidad": "El Embocadero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 71,
    "municipio": "Tlahuiltepa",
    "claveLocalidad": 140,
    "localidad": "Piedra Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 1,
    "localidad": "Tlanalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 2,
    "localidad": "Bellavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 4,
    "localidad": "Calaveras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 5,
    "localidad": "Chiconcuac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 6,
    "localidad": "San Gregorio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 7,
    "localidad": "Rancho San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 8,
    "localidad": "San Miguel Amiltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 9,
    "localidad": "Tepechichilco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 10,
    "localidad": "San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 11,
    "localidad": "Ex Hacienda San Pedro Tochatlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 13,
    "localidad": "San Juan Ahuayalulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 18,
    "localidad": "Colonia Km. 27"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 19,
    "localidad": "Colonia Km. 28"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 20,
    "localidad": "Fraccionamiento San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 21,
    "localidad": "Rancho los Arcos (Santa Inés)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 22,
    "localidad": "Desviación a Tlanalapa (Ejido de Tepa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 30,
    "localidad": "Estación Sahagún"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 31,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 32,
    "localidad": "Rancho el Nopalito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 34,
    "localidad": "Rancho de los Capulines"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 35,
    "localidad": "San Judas Tadeo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 36,
    "localidad": "Rancho de la Comex"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 37,
    "localidad": "Teodoro Castillo Roldán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 38,
    "localidad": "Emilio Martínez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 39,
    "localidad": "Silverio Hernández Pérez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 40,
    "localidad": "Capula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 41,
    "localidad": "Colonia de la Rosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 42,
    "localidad": "Jagüey del Aire"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 43,
    "localidad": "La Trinidad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 44,
    "localidad": "Rancho de los Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 72,
    "municipio": "Tlanalapa",
    "claveLocalidad": 45,
    "localidad": "San Francisco la Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 1,
    "localidad": "Tlanchinol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 2,
    "localidad": "Acahuasco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 3,
    "localidad": "Acatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 4,
    "localidad": "Acuapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 5,
    "localidad": "Apantlazol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 6,
    "localidad": "Citlala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 7,
    "localidad": "Coamapil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 8,
    "localidad": "Copaltitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 9,
    "localidad": "Cuatatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 10,
    "localidad": "Cuatlapech"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 11,
    "localidad": "Cuatlimax"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 12,
    "localidad": "Cuatlapextla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 13,
    "localidad": "Chachala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 14,
    "localidad": "Chalchocotipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 15,
    "localidad": "Chichatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 16,
    "localidad": "Chichiltépec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 17,
    "localidad": "Chipoco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 18,
    "localidad": "Ehuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 19,
    "localidad": "Pueblo Hidalgo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 20,
    "localidad": "Hueyapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 21,
    "localidad": "Huitepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 22,
    "localidad": "Ixtlapala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 23,
    "localidad": "Jalpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 24,
    "localidad": "Lontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 25,
    "localidad": "Olotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 26,
    "localidad": "Pahuayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 27,
    "localidad": "Peyula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 28,
    "localidad": "Pilcuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 29,
    "localidad": "La Pimienta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 30,
    "localidad": "Pitzotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 31,
    "localidad": "Quetzaltzongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 32,
    "localidad": "Quimixtla (Xitlama)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 33,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 34,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 35,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 36,
    "localidad": "San Salvador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 37,
    "localidad": "Santa Lucía"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 38,
    "localidad": "Santa María Catzotipan (Santa María Tepetzintla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 39,
    "localidad": "Tecontla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 40,
    "localidad": "Temango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 41,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 42,
    "localidad": "Tenexco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 43,
    "localidad": "Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 44,
    "localidad": "Tequispízal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 45,
    "localidad": "Tianguis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 46,
    "localidad": "Tlahuelompa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 47,
    "localidad": "Toctitlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 48,
    "localidad": "Totonicapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 49,
    "localidad": "Santa Martha Ula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 50,
    "localidad": "Xaltipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 51,
    "localidad": "Xitlama"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 54,
    "localidad": "Quimixtla Hula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 55,
    "localidad": "Rancho Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 57,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 59,
    "localidad": "Tlahuelongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 60,
    "localidad": "Tierra Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 62,
    "localidad": "Tochintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 63,
    "localidad": "Comala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 64,
    "localidad": "Las Puentes"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 65,
    "localidad": "Xoloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 67,
    "localidad": "El Suspiro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 95,
    "localidad": "Amoxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 96,
    "localidad": "Tenexatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 98,
    "localidad": "El Balcón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 99,
    "localidad": "Chicaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 100,
    "localidad": "El Mirador (Casetas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 101,
    "localidad": "Tlazolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 102,
    "localidad": "Tolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 104,
    "localidad": "Cuatahuatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 105,
    "localidad": "Tamazolapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 106,
    "localidad": "Atoscalao"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 107,
    "localidad": "Catlapani"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 108,
    "localidad": "Cerro Alto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 109,
    "localidad": "Cuahuilacáts"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 110,
    "localidad": "Vista Hermosa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 111,
    "localidad": "La Montaña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 112,
    "localidad": "Los Pemuches"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 113,
    "localidad": "Cececapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 114,
    "localidad": "Tetzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 115,
    "localidad": "Texcatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 116,
    "localidad": "Xuchiatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 117,
    "localidad": "Barrio Independencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 118,
    "localidad": "Barrio Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 119,
    "localidad": "Barrio Santa Cecilia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 120,
    "localidad": "Barrio Tlacomul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 121,
    "localidad": "Cuatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 122,
    "localidad": "Moyotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 123,
    "localidad": "Xochititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 124,
    "localidad": "Cuaxocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 125,
    "localidad": "La Garrapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 126,
    "localidad": "La Morita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 127,
    "localidad": "Tecruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 128,
    "localidad": "Tlapacoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 129,
    "localidad": "Xala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 73,
    "municipio": "Tlanchinol",
    "claveLocalidad": 130,
    "localidad": "La Quebradora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 1,
    "localidad": "Tlaxcoapan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 2,
    "localidad": "Doxey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 3,
    "localidad": "Teltipán de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 4,
    "localidad": "Teocalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 7,
    "localidad": "Camino al Tecolote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 8,
    "localidad": "Ejido Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 11,
    "localidad": "El Gavillero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 12,
    "localidad": "El Monte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 13,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 14,
    "localidad": "Camino a Puente Negro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 15,
    "localidad": "Los Olivos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 16,
    "localidad": "La Tierra Negra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 74,
    "municipio": "Tlaxcoapan",
    "claveLocalidad": 18,
    "localidad": "Ejido de San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 1,
    "localidad": "Tolcayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 2,
    "localidad": "General Felipe Angeles (Los Angeles)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 4,
    "localidad": "La Biznaga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 6,
    "localidad": "Matías Rodríguez el Mambrú"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 7,
    "localidad": "Miravalle"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 8,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 9,
    "localidad": "Las Pintas (El Porvenir)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 10,
    "localidad": "San Miguel Eyacalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 11,
    "localidad": "Santiago Tlajomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 12,
    "localidad": "Tláloc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 13,
    "localidad": "Vicente Guerrero (San Javier)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 16,
    "localidad": "El Cerrito (Huaquixchula)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 17,
    "localidad": "Rancho Cannan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 18,
    "localidad": "Rancho Don Urbano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 19,
    "localidad": "La Carcajada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 21,
    "localidad": "El Cuetero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 22,
    "localidad": "Lomas de San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 23,
    "localidad": "Rancho Villaporci"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 24,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 25,
    "localidad": "La Casa Enterrada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 26,
    "localidad": "La Colmena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 27,
    "localidad": "Granja los Pinos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 28,
    "localidad": "El Tejocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 29,
    "localidad": "Teodoro Ramírez Islas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 30,
    "localidad": "Esteban Meneses Corona"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 31,
    "localidad": "Guadalupe Mendoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 32,
    "localidad": "Gumaro Ramírez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 33,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 75,
    "municipio": "Tolcayuca",
    "claveLocalidad": 34,
    "localidad": "La Gloria (Rancho de la Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 1,
    "localidad": "Tula de Allende"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 2,
    "localidad": "Acoculco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 4,
    "localidad": "Xiteje de Zapata"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 5,
    "localidad": "Héroes Carranza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 6,
    "localidad": "Ignacio Zaragoza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 7,
    "localidad": "Colonia Julián Villagrán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 8,
    "localidad": "El Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 9,
    "localidad": "Santa María Michimaltongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 10,
    "localidad": "Michimaloya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 11,
    "localidad": "Bomintzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 12,
    "localidad": "Monte Alegre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 13,
    "localidad": "Nantzha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 15,
    "localidad": "Xiteje de la Reforma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 16,
    "localidad": "San Andrés (San Andrés Tultepec)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 17,
    "localidad": "San Antonio Tula"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 18,
    "localidad": "San Francisco Bojay Pueblo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 19,
    "localidad": "San Francisco Bojay Colonia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 21,
    "localidad": "San Lucas Teacalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 22,
    "localidad": "San Marcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 23,
    "localidad": "San Miguel de las Piedras Primera Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 24,
    "localidad": "San Miguel Vindho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 25,
    "localidad": "San Pedrito Alpuyeca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 26,
    "localidad": "Santa Ana Ahuehuepan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 28,
    "localidad": "Santa María Macua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 29,
    "localidad": "Teocalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 31,
    "localidad": "Xijay de Cuauhtémoc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 32,
    "localidad": "Xochitlán de las Flores"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 40,
    "localidad": "Colonia el Sesenta y Uno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 46,
    "localidad": "Colonia Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 52,
    "localidad": "Colonia Tenjay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 53,
    "localidad": "Praderas del Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 57,
    "localidad": "Colonia Santa María Michimaltongo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 58,
    "localidad": "Colonia Sesenta y Dos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 61,
    "localidad": "Colonia Nueva Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 62,
    "localidad": "Colonia el Recinto (Ejido Pueblo Nuevo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 63,
    "localidad": "El Godo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 64,
    "localidad": "El Paso"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 65,
    "localidad": "Colonia el Saabi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 67,
    "localidad": "La Amistad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 69,
    "localidad": "Rancho Bojay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 70,
    "localidad": "Xonthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 71,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 72,
    "localidad": "El Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 73,
    "localidad": "La Cuarta Manzana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 74,
    "localidad": "Jardines de San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 75,
    "localidad": "La Milpa de García"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 76,
    "localidad": "Rancho los Truenitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 79,
    "localidad": "La Mora"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 80,
    "localidad": "Rancho el Cielito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 81,
    "localidad": "Boulevard el Cooperativismo (Ejido San Miguel)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 82,
    "localidad": "El Puendhó"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 83,
    "localidad": "Dengui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 84,
    "localidad": "El Tesoro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 85,
    "localidad": "San Miguel de las Piedras Segunda Sección"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 86,
    "localidad": "Ejido Tula (Arriba del Parque Ecológico)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 87,
    "localidad": "Cerrito del Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 88,
    "localidad": "Ejido de San Lucas Teacalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 89,
    "localidad": "Las Manzanitas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 90,
    "localidad": "La Mezquitera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 91,
    "localidad": "Montecillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 92,
    "localidad": "Tercera Manzana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 93,
    "localidad": "Antonio Guerrero Briseño"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 94,
    "localidad": "La Vuelta del Río"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 95,
    "localidad": "Ejido de Acoculco (Dos Peñas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 96,
    "localidad": "El Carmen (La Mesita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 97,
    "localidad": "La Ciénega"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 98,
    "localidad": "El Ocote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 76,
    "municipio": "Tula de Allende",
    "claveLocalidad": 99,
    "localidad": "Pueblo Nuevo (La Subida)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 1,
    "localidad": "Tulancingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 2,
    "localidad": "Acocul la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 3,
    "localidad": "Ahuehuetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 5,
    "localidad": "Axatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 7,
    "localidad": "San Nicolás Cebolletas (Cebolletas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 8,
    "localidad": "Huajomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 10,
    "localidad": "Jaltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 11,
    "localidad": "La Laguna del Cerrito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 12,
    "localidad": "La Lagunilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 14,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 16,
    "localidad": "San Francisco Huatengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 17,
    "localidad": "San Nicolás el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 18,
    "localidad": "Santa Ana Hueytlalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 20,
    "localidad": "Santa María Asunción"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 21,
    "localidad": "Santa María el Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 22,
    "localidad": "Tepalzingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 24,
    "localidad": "El Abra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 33,
    "localidad": "Rancho San Andrés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 34,
    "localidad": "San Antonio Farías"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 41,
    "localidad": "San Vidal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 42,
    "localidad": "Zototlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 48,
    "localidad": "Acocul Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 53,
    "localidad": "Javier Rojo Gómez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 54,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 55,
    "localidad": "Napateco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 57,
    "localidad": "Sultepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 59,
    "localidad": "Otontepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 60,
    "localidad": "Las Piletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 62,
    "localidad": "Santiago Caltengo (Buenos Aires)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 64,
    "localidad": "Ejido Mimila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 65,
    "localidad": "Loma Bonita San Rafael"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 66,
    "localidad": "Rancho Santa Isabel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 68,
    "localidad": "Parque Urbano Napateco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 69,
    "localidad": "San Pablo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 70,
    "localidad": "Fraccionamiento del Magisterio Tulancinguense"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 71,
    "localidad": "Pedregal de San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 72,
    "localidad": "Colonia Buenos Aires (Ejido Ahuehuetitla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 73,
    "localidad": "Colonia Francisco Villa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 74,
    "localidad": "La Colmena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 75,
    "localidad": "Fraccionamiento Carlos Salinas de Gortari"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 76,
    "localidad": "Huitititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 77,
    "localidad": "Rancho Buenos Aires"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 78,
    "localidad": "La Raya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 79,
    "localidad": "San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 80,
    "localidad": "Viveros de la Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 82,
    "localidad": "Ejido Huapalcalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 83,
    "localidad": "Maroja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 84,
    "localidad": "Pozas Encantadas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 85,
    "localidad": "La Presa de Santa Ana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 86,
    "localidad": "Rancho los Cortez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 87,
    "localidad": "Rancho San Nicolás el Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 88,
    "localidad": "Barrio Atlalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 89,
    "localidad": "Colonia San Felipe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 90,
    "localidad": "Los Alamos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 91,
    "localidad": "Colonia Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 92,
    "localidad": "Ejido Huapalcalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 93,
    "localidad": "San Rafael los Teteles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 94,
    "localidad": "Ejido Santiago Caltengo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 95,
    "localidad": "Lomas de Tulancingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 97,
    "localidad": "La Pastoría"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 98,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 99,
    "localidad": "Rancho Universitario"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 101,
    "localidad": "San Cayetano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 102,
    "localidad": "El Pedregal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 77,
    "municipio": "Tulancingo de Bravo",
    "claveLocalidad": 103,
    "localidad": "Rancho San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 1,
    "localidad": "Xochiatipan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 2,
    "localidad": "Acanoa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 3,
    "localidad": "Acatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 4,
    "localidad": "Acomul"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 5,
    "localidad": "Ahuatitla (Aguayo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 6,
    "localidad": "Amolo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 7,
    "localidad": "Atlajco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 8,
    "localidad": "Atlalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 10,
    "localidad": "Cocotla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 11,
    "localidad": "Cruzhica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 13,
    "localidad": "Chiapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 14,
    "localidad": "Ixtaczoquico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 16,
    "localidad": "Nanayatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 17,
    "localidad": "Ohuatipa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 18,
    "localidad": "Pachiquitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 19,
    "localidad": "Pesmayo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 20,
    "localidad": "Pocantla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 21,
    "localidad": "Pohuantitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 22,
    "localidad": "Santiago II"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 23,
    "localidad": "Tecopia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 24,
    "localidad": "Tenexhueyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 25,
    "localidad": "Texoloc"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 26,
    "localidad": "Tlaltecatla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 27,
    "localidad": "Xilico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 28,
    "localidad": "Xocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 29,
    "localidad": "Zacatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 30,
    "localidad": "El Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 31,
    "localidad": "Santiago I"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 32,
    "localidad": "Nuevo Coyolar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 33,
    "localidad": "Nuevo Acatepec (Mezcalapa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 34,
    "localidad": "Ixtakuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 35,
    "localidad": "Tectzonquiliapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 38,
    "localidad": "Xóchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 40,
    "localidad": "Ocuilapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 41,
    "localidad": "Hueyájtetl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 42,
    "localidad": "Xochititla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 47,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 48,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 49,
    "localidad": "Tonalixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 52,
    "localidad": "El Crucero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 78,
    "municipio": "Xochiatipan",
    "claveLocalidad": 53,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 1,
    "localidad": "Xochicoatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 2,
    "localidad": "Acatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 3,
    "localidad": "Acomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 4,
    "localidad": "Coatitlamixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 5,
    "localidad": "Coatlamayán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 6,
    "localidad": "Coatencalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 7,
    "localidad": "Culhuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 8,
    "localidad": "Chinameca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 9,
    "localidad": "Epopulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 10,
    "localidad": "Huitzintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 11,
    "localidad": "Jalamelco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 12,
    "localidad": "Mazahuacán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 13,
    "localidad": "Mecapala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 14,
    "localidad": "Michumitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 15,
    "localidad": "Mixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 16,
    "localidad": "Molangotzi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 17,
    "localidad": "Nonoalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 18,
    "localidad": "Papaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 19,
    "localidad": "Tenango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 20,
    "localidad": "Texcaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 21,
    "localidad": "Tlaxcoya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 22,
    "localidad": "Tototla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 23,
    "localidad": "Tuzancoac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 24,
    "localidad": "Zapocoatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 25,
    "localidad": "Tenextitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 26,
    "localidad": "Otonapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 27,
    "localidad": "Quimixtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 28,
    "localidad": "Xiatlán (San José Xiatlán)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 29,
    "localidad": "Barrio Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 30,
    "localidad": "Coatempa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 31,
    "localidad": "Tecoloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 32,
    "localidad": "Ocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 33,
    "localidad": "Las Pilas (Agua Bendita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 35,
    "localidad": "Temoaya (Los Pocitos)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 79,
    "municipio": "Xochicoatlán",
    "claveLocalidad": 36,
    "localidad": "Zoteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 1,
    "localidad": "Yahualica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 2,
    "localidad": "Aguacatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 3,
    "localidad": "El Arenal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 4,
    "localidad": "Atlajco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 5,
    "localidad": "Atlalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 6,
    "localidad": "Chompeletla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 7,
    "localidad": "Chiatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 8,
    "localidad": "Hueyactétl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 9,
    "localidad": "Huitznopala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 10,
    "localidad": "Mangocuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 11,
    "localidad": "Mecatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 12,
    "localidad": "Mesa Larga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 13,
    "localidad": "Los Naranjos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 14,
    "localidad": "Oxeloco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 15,
    "localidad": "Olma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 16,
    "localidad": "Pepeyocatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 17,
    "localidad": "Santa Teresa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 18,
    "localidad": "Tamalcuatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 19,
    "localidad": "Tenamaxtepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 20,
    "localidad": "Tepehixpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 21,
    "localidad": "Tepetitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 22,
    "localidad": "Tetla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 23,
    "localidad": "Tlalchiyahualica"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 24,
    "localidad": "Xóchitl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 25,
    "localidad": "Xoxolpa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 26,
    "localidad": "Zacayahual"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 27,
    "localidad": "Zoquitipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 28,
    "localidad": "Acalamatitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 29,
    "localidad": "Crisolco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 30,
    "localidad": "Huexoapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 31,
    "localidad": "El Paraje"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 32,
    "localidad": "El Sacrificio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 34,
    "localidad": "Tecacalax"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 38,
    "localidad": "Xocotitla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 80,
    "municipio": "Yahualica",
    "claveLocalidad": 39,
    "localidad": "Tenexapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 1,
    "localidad": "Zacualtipán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 2,
    "localidad": "Ajacaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 3,
    "localidad": "Atopixco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 4,
    "localidad": "Coatlila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 5,
    "localidad": "La Cumbre de Alumbres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 6,
    "localidad": "La Cumbre de Ohuesco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 7,
    "localidad": "Chinancáhuatl"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 8,
    "localidad": "Jalapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 9,
    "localidad": "Matlatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 10,
    "localidad": "Maxala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 11,
    "localidad": "Mimiahuaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 12,
    "localidad": "La Mojonera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 13,
    "localidad": "Olonteco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 14,
    "localidad": "Papaxtla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 15,
    "localidad": "El Reparo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 16,
    "localidad": "Rincón Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 17,
    "localidad": "San Bernardo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 18,
    "localidad": "San Miguel (Ferrería San Miguel)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 19,
    "localidad": "Santo Domingo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 20,
    "localidad": "Sietla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 21,
    "localidad": "Tehuitzila"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 22,
    "localidad": "Tepeoco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 23,
    "localidad": "Tetzimico (San Bartolo Tetzimico)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 24,
    "localidad": "Tizapán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 25,
    "localidad": "Tlahuelompa (San Francisco Tlahuelompa)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 26,
    "localidad": "Tzincoatlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 31,
    "localidad": "Xicopantla (Jicopantla)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 33,
    "localidad": "Panohuaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 37,
    "localidad": "Atecoxco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 38,
    "localidad": "Jiliapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 39,
    "localidad": "La Obsidiana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 40,
    "localidad": "Piedra Blanca (El Vivero)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 41,
    "localidad": "Pinolco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 42,
    "localidad": "Tlatoxca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 43,
    "localidad": "Xoluapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 44,
    "localidad": "Olma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 45,
    "localidad": "La Flor del Campo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 46,
    "localidad": "La Cumbre de Tlahuelompa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 47,
    "localidad": "Colonia los Pinos (El Crucero)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 48,
    "localidad": "Ixtacapa (Río Chiquito)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 49,
    "localidad": "Ixtlahuipita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 50,
    "localidad": "Tejería"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 51,
    "localidad": "Barrio Cozapa (Agua Bendita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 52,
    "localidad": "Barrio J. Trinidad Hernández Ibarra"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 53,
    "localidad": "Barrio Panotlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 54,
    "localidad": "Barrio Tepanapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 55,
    "localidad": "Colonia 11 de Abril (El Depósito Viejo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 56,
    "localidad": "Quince de Septiembre el Pantano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 57,
    "localidad": "Fraccionamiento Cozapa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 58,
    "localidad": "Tlacomolt"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 59,
    "localidad": "Barrio de Cacala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 60,
    "localidad": "Colonia Benito Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 81,
    "municipio": "Zacualtipán de Angeles",
    "claveLocalidad": 61,
    "localidad": "La Galera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 1,
    "localidad": "Zapotlán de Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 2,
    "localidad": "Acayuca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 4,
    "localidad": "San Javier"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 5,
    "localidad": "Chiltepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 8,
    "localidad": "San Pedro Huitepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 9,
    "localidad": "Los Chávez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 11,
    "localidad": "El Fortino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 13,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 14,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 15,
    "localidad": "El Pavo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 16,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 17,
    "localidad": "El Vergel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 18,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 19,
    "localidad": "Rancho Alegre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 20,
    "localidad": "Rancho Alegre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 21,
    "localidad": "Rancho Orozco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 22,
    "localidad": "Rancho Rafael Pérez O."
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 23,
    "localidad": "La Cañada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 24,
    "localidad": "Antonio Torres"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 25,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 27,
    "localidad": "Urizán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 82,
    "municipio": "Zapotlán de Juárez",
    "claveLocalidad": 28,
    "localidad": "El Herradero (Loma Bonita)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 1,
    "localidad": "Zempoala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 2,
    "localidad": "Acelotla de Ocampo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 6,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 7,
    "localidad": "Francisco Villa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 8,
    "localidad": "Rancho Luna"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 9,
    "localidad": "Guadalupe Santa Rita de Arriba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 11,
    "localidad": "Rancho Margarita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 12,
    "localidad": "Ex Hacienda Metepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 13,
    "localidad": "Nextlalpan (San Miguel Nextlalpan)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 14,
    "localidad": "Las Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 15,
    "localidad": "San Agustín Zapotlán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 16,
    "localidad": "San Antonio Oxtoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 17,
    "localidad": "San Gabriel Azteca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 19,
    "localidad": "Santa María Tecajete"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 20,
    "localidad": "Exhacienda Santa Rita el Sauz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 21,
    "localidad": "Santo Tomás"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 22,
    "localidad": "Ex Hacienda de Tecajete"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 23,
    "localidad": "Jagüey de Téllez (Estación Téllez)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 25,
    "localidad": "Tepa el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 26,
    "localidad": "Santiago Tepeyahualco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 27,
    "localidad": "Tepozoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 28,
    "localidad": "San Mateo Tlajomulco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 29,
    "localidad": "San Pedro Tlaquilpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 30,
    "localidad": "La Trinidad"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 31,
    "localidad": "Venustiano Carranza"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 32,
    "localidad": "Villa Margarita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 34,
    "localidad": "Zontecomate"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 35,
    "localidad": "Hacienda Tepa el Chico"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 36,
    "localidad": "Granjas Integradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 42,
    "localidad": "La Cuchilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 43,
    "localidad": "El Cerrito de Téllez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 44,
    "localidad": "San Juan Pueblilla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 45,
    "localidad": "Santa Gertrudis"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 46,
    "localidad": "San Cristóbal el Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 47,
    "localidad": "Ex Hacienda San Antonio Tochatlaco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 48,
    "localidad": "Mazatepec"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 49,
    "localidad": "Exhacienda Montecillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 55,
    "localidad": "Rancho Bachimba"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 56,
    "localidad": "El Capiro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 58,
    "localidad": "Rancho Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 59,
    "localidad": "Exhacienda Guadalupe Arcos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 60,
    "localidad": "El Mirador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 61,
    "localidad": "Los Olivos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 62,
    "localidad": "La Providencia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 64,
    "localidad": "San José Tetecuintla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 65,
    "localidad": "San Antonio Tepeyac"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 66,
    "localidad": "Rancho San Mateo Axtlacoyoacan (Rancho San Mateo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 67,
    "localidad": "Rancho Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 70,
    "localidad": "Las Casas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 71,
    "localidad": "Alfonso Corona del Rosal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 73,
    "localidad": "Los Pilares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 74,
    "localidad": "El Potrero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 75,
    "localidad": "Los Pozos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 76,
    "localidad": "Santa Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 77,
    "localidad": "La Isla"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 80,
    "localidad": "El Barrio Casas Coloradas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 81,
    "localidad": "Los Canales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 82,
    "localidad": "El Capulín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 84,
    "localidad": "Casa Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 85,
    "localidad": "Santa Isabel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 86,
    "localidad": "Colonia Nueva San Agustín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 87,
    "localidad": "La Grava"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 88,
    "localidad": "Las Lomas (Los Galleros)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 89,
    "localidad": "Rancho Berlín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 90,
    "localidad": "Rancho Viejo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 91,
    "localidad": "El Tejamanil"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 92,
    "localidad": "Ejido San Antonio Oxtoyucan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 93,
    "localidad": "Rancho los Laureles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 94,
    "localidad": "Rancho Dazha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 95,
    "localidad": "Pozo el Llano"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 96,
    "localidad": "La Era de la Peña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 97,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 99,
    "localidad": "Rancho Cañada el Salvador"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 100,
    "localidad": "Rancho la Luz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 101,
    "localidad": "La Galera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 102,
    "localidad": "Lindavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 103,
    "localidad": "Rancho Cuatro Caminos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 105,
    "localidad": "Rancho el Caracol"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 106,
    "localidad": "Rancho la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 109,
    "localidad": "Santa Inés"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 110,
    "localidad": "Margarito Osorno"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 111,
    "localidad": "Rancho San Hipólito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 112,
    "localidad": "Casa Sola"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 113,
    "localidad": "El Charquito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 114,
    "localidad": "Jagüey Seco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 115,
    "localidad": "Ojo de Agua"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 116,
    "localidad": "Rancho Cerro Pelón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 117,
    "localidad": "Rancho el Chocolín"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 118,
    "localidad": "Rancho el Cristo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 119,
    "localidad": "Rancho el Obregón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 120,
    "localidad": "Rancho la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 121,
    "localidad": "Rancho las Calaveras"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 122,
    "localidad": "Rancho las  Palomas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 123,
    "localidad": "La Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 124,
    "localidad": "Roberto Islas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 125,
    "localidad": "San José"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 126,
    "localidad": "San Juan Tepemazalco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 127,
    "localidad": "Rancho San Ignacio"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 128,
    "localidad": "Ejido de Tzacuala"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 129,
    "localidad": "Las Palmas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 130,
    "localidad": "Colonia la Palma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 83,
    "municipio": "Zempoala",
    "claveLocalidad": 131,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 1,
    "localidad": "Zimapán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 2,
    "localidad": "Las Adjuntas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 3,
    "localidad": "El Aguacatito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 4,
    "localidad": "Aguas Blancas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 5,
    "localidad": "Alvaro Obregón (Temuthe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 6,
    "localidad": "Apezco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 7,
    "localidad": "Benito Juárez (Detzani)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 8,
    "localidad": "Boñhu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 10,
    "localidad": "Camposanto del Oro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 11,
    "localidad": "Cerro Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 12,
    "localidad": "El Cerrote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 13,
    "localidad": "Cobrecito"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 14,
    "localidad": "El Cuarto"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 16,
    "localidad": "Coaxithi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 17,
    "localidad": "El Dedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 18,
    "localidad": "Doxthi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 19,
    "localidad": "Durango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 20,
    "localidad": "Los Duraznos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 21,
    "localidad": "Tzijay (Emiliano Zapata)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 22,
    "localidad": "Encarnación"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 23,
    "localidad": "La Estanzuela"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 24,
    "localidad": "Francisco I. Madero (Guadalupe)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 25,
    "localidad": "Garabatos (Garabatos la Estancia)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 26,
    "localidad": "Jagüey Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 27,
    "localidad": "Lázaro Cárdenas (Remedios)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 28,
    "localidad": "Llanitos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 29,
    "localidad": "Llano Segundo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 31,
    "localidad": "Maguey Verde"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 32,
    "localidad": "La Majada Grande"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 33,
    "localidad": "La Manzana"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 34,
    "localidad": "Megui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 35,
    "localidad": "El Mezquite Segundo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 36,
    "localidad": "Morelos (Trancas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 37,
    "localidad": "La Ortiga"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 39,
    "localidad": "Plutarco Elías Calles (Santiago)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 40,
    "localidad": "Pueblo Nuevo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 41,
    "localidad": "Puerto del Angel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 42,
    "localidad": "Puerto Juárez"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 43,
    "localidad": "La Rinconada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 44,
    "localidad": "El Rincón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 45,
    "localidad": "El Salitre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 46,
    "localidad": "San Andrés (Toxthi)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 47,
    "localidad": "San Francisco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 48,
    "localidad": "San José del Oro (San Vicente)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 49,
    "localidad": "Santa Rita"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 50,
    "localidad": "El Saucillo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 51,
    "localidad": "Sóstenes Vega (Xitha Segundo Cedho)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 52,
    "localidad": "Tadhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 53,
    "localidad": "El Tathi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 54,
    "localidad": "Taxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 55,
    "localidad": "Tenguedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 56,
    "localidad": "Tinthe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 57,
    "localidad": "Tolimán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 58,
    "localidad": "Las Vegas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 59,
    "localidad": "Venustiano Carranza (San Pedro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 60,
    "localidad": "Verdosas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 61,
    "localidad": "Vicente Guerrero (El Tablón)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 62,
    "localidad": "Xajha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 63,
    "localidad": "Xindho Guadalupe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 64,
    "localidad": "Xhita Primero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 65,
    "localidad": "Xodhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 66,
    "localidad": "Yerbabuena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 67,
    "localidad": "Yethay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 68,
    "localidad": "San Cristóbal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 69,
    "localidad": "Codornices"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 70,
    "localidad": "Puerto del Efe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 71,
    "localidad": "La Cruz (Ejido de la Cruz)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 72,
    "localidad": "Doxthi la Sabina (La Sabina)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 73,
    "localidad": "La Tinaja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 74,
    "localidad": "Pontihu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 75,
    "localidad": "Puetzey"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 76,
    "localidad": "San Miguel Tetillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 77,
    "localidad": "El Aguacatal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 78,
    "localidad": "Francisco Villa (Llano Segundo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 79,
    "localidad": "La Ventolera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 81,
    "localidad": "Pared Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 82,
    "localidad": "San Felipe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 83,
    "localidad": "Barrón"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 88,
    "localidad": "San Antonio (Cuauhtémoc)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 89,
    "localidad": "Puerto Colorado"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 90,
    "localidad": "El Alamo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 92,
    "localidad": "Mina Balcones"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 93,
    "localidad": "Botha"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 94,
    "localidad": "Bothiña"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 95,
    "localidad": "Cajay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 96,
    "localidad": "La Calera"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 98,
    "localidad": "Los Carrizos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 99,
    "localidad": "Cruz Pinta"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 100,
    "localidad": "Cuesta Blanca"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 101,
    "localidad": "El Dedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 102,
    "localidad": "Mina el Espíritu"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 103,
    "localidad": "Mina Carrizal (Peñoles)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 104,
    "localidad": "Mina el Monte"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 105,
    "localidad": "Ex Hacienda la Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 106,
    "localidad": "Cazay"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 107,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 109,
    "localidad": "Llano Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 110,
    "localidad": "La Majada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 111,
    "localidad": "Los Mármoles"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 112,
    "localidad": "La Mesa"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 113,
    "localidad": "Mezquite Primero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 114,
    "localidad": "La Milpota"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 115,
    "localidad": "El Muhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 116,
    "localidad": "Los Nogales"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 117,
    "localidad": "Puerto Zapote (La Nopalera)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 118,
    "localidad": "El Palmar"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 119,
    "localidad": "Pelillos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 120,
    "localidad": "Las Piletas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 121,
    "localidad": "Potreritos"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 122,
    "localidad": "Puerto de Vigas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 123,
    "localidad": "Puerto de la Estancia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 124,
    "localidad": "Puerto Xodhe"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 126,
    "localidad": "El Rodeo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 127,
    "localidad": "La Ruda"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 128,
    "localidad": "Mina San Guillermo (Lomo de Toro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 129,
    "localidad": "Rancho San Juan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 130,
    "localidad": "San Miguel"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 131,
    "localidad": "La Tinaja Durango"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 132,
    "localidad": "Tlalpan"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 133,
    "localidad": "El Tule"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 135,
    "localidad": "Villa Nueva"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 136,
    "localidad": "Xhita Segundo (San Isidro)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 137,
    "localidad": "Xindho Segundo (Xindho Saucillo)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 141,
    "localidad": "Xindhó Primero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 142,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 144,
    "localidad": "Puerto Ingeniero Isidro Díaz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 145,
    "localidad": "El Sabino"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 146,
    "localidad": "Buenavista"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 147,
    "localidad": "La Casota"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 148,
    "localidad": "La Cebada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 149,
    "localidad": "Puerto la Palma (Cerrito Enmedio)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 150,
    "localidad": "Cuesta Texquedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 151,
    "localidad": "Ejido de la Cruz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 152,
    "localidad": "La Escondida"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 153,
    "localidad": "Iglesia Vieja"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 154,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 155,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 156,
    "localidad": "La Mesa de Camposanto del Oro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 157,
    "localidad": "Mina Concordia"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 158,
    "localidad": "Peña Colorada"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 159,
    "localidad": "Pozo Hondo"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 160,
    "localidad": "Puertecito del Megui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 161,
    "localidad": "Puerto Jagüey (Puerto de Guaymas)"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 162,
    "localidad": "Puerto Montero"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 163,
    "localidad": "Puerto Yerbabuena"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 164,
    "localidad": "El Rancho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 165,
    "localidad": "El Salitre"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 166,
    "localidad": "San Francisco Texquedho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 167,
    "localidad": "San Isidro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 168,
    "localidad": "Santa María"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 169,
    "localidad": "El Sauz"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 170,
    "localidad": "Taxtho"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 171,
    "localidad": "El Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 172,
    "localidad": "El Tepozán"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 173,
    "localidad": "Tierras Amarillas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 174,
    "localidad": "Toxhi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 175,
    "localidad": "Tzitzi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 176,
    "localidad": "La Venta de Coaxithi"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 177,
    "localidad": "Changui"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 178,
    "localidad": "Xindho San Pedro"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 179,
    "localidad": "El Zapote"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 180,
    "localidad": "Los Pilares"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 181,
    "localidad": "Agua Vaya"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 182,
    "localidad": "El Carrizal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 183,
    "localidad": "La Loma"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 184,
    "localidad": "El Organal"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 185,
    "localidad": "Las Pilas"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 186,
    "localidad": "Maguey Blanco"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 187,
    "localidad": "San Vicente"
  },
  {
    "clave": 13,
    "entidad": "Hidalgo",
    "claveMunicipio": 84,
    "municipio": "Zimapán",
    "claveLocalidad": 188,
    "localidad": "La Barranca del Muhi"
  }
]
